/* tslint:disable */
/* eslint-disable */
/**
 * e:lmo core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.5.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from './common'
import type { RequestArgs } from './base'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base'

/**
 *
 * @export
 * @interface AkiDemographyDTO
 */
export interface AkiDemographyDTO {
  /**
   *
   * @type {string}
   * @memberof AkiDemographyDTO
   */
  admissionDate: string
  /**
   *
   * @type {number}
   * @memberof AkiDemographyDTO
   */
  age?: number | null
  /**
   *
   * @type {number}
   * @memberof AkiDemographyDTO
   */
  bmi?: number | null
}
/**
 *
 * @export
 * @interface AkiInfoPanelDTO
 */
export interface AkiInfoPanelDTO {
  /**
   *
   * @type {CaseDTO}
   * @memberof AkiInfoPanelDTO
   */
  case: CaseDTO
  /**
   *
   * @type {AkiDemographyDTO}
   * @memberof AkiInfoPanelDTO
   */
  demography: AkiDemographyDTO
  /**
   *
   * @type {Array<AkiParamsItem>}
   * @memberof AkiInfoPanelDTO
   */
  eGFR: Array<AkiParamsItem>
  /**
   *
   * @type {AkiLaboratoryDTO}
   * @memberof AkiInfoPanelDTO
   */
  laboratory: AkiLaboratoryDTO
  /**
   *
   * @type {OrganSupportDTO}
   * @memberof AkiInfoPanelDTO
   */
  organSupport: OrganSupportDTO
  /**
   *
   * @type {PredictionResultDTO}
   * @memberof AkiInfoPanelDTO
   */
  predictionResult: PredictionResultDTO
  /**
   *
   * @type {any}
   * @memberof AkiInfoPanelDTO
   */
  temperature: any
  /**
   *
   * @type {string}
   * @memberof AkiInfoPanelDTO
   */
  trend?: AkiInfoPanelDTOTrendEnum | null
  /**
   *
   * @type {AkiVasopressorsDTO}
   * @memberof AkiInfoPanelDTO
   */
  vasopressors: AkiVasopressorsDTO
  /**
   *
   * @type {AkiVitalSignsDTO}
   * @memberof AkiInfoPanelDTO
   */
  vitalSigns: AkiVitalSignsDTO
}

export const AkiInfoPanelDTOTrendEnum = {
  UP: 'UP',
  DOWN: 'DOWN',
  STEADY: 'STEADY'
} as const

export type AkiInfoPanelDTOTrendEnum =
  (typeof AkiInfoPanelDTOTrendEnum)[keyof typeof AkiInfoPanelDTOTrendEnum]

/**
 *
 * @export
 * @interface AkiLaboratoryDTO
 */
export interface AkiLaboratoryDTO {
  /**
   *
   * @type {Array<AkiParamsItem>}
   * @memberof AkiLaboratoryDTO
   */
  bilirubin: Array<AkiParamsItem>
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  creatinine: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  crp: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  lactate: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  leukocytes: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  ph: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  potassium: any
  /**
   *
   * @type {any}
   * @memberof AkiLaboratoryDTO
   */
  urine: any
}
/**
 *
 * @export
 * @interface AkiOverviewResponseDTO
 */
export interface AkiOverviewResponseDTO {
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  highRiskCount: number
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  page: number
  /**
   *
   * @type {Array<CaseWithPredictionResultDTO>}
   * @memberof AkiOverviewResponseDTO
   */
  results: Array<CaseWithPredictionResultDTO>
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  size: number
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  totalAkiRiskPatients: number
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  totalElements: number
  /**
   *
   * @type {number}
   * @memberof AkiOverviewResponseDTO
   */
  veryHighRiskCount: number
}
/**
 *
 * @export
 * @interface AkiParamsItem
 */
export interface AkiParamsItem {
  /**
   *
   * @type {string}
   * @memberof AkiParamsItem
   */
  observationTime: string
  /**
   *
   * @type {number}
   * @memberof AkiParamsItem
   */
  observationValue: number
  /**
   *
   * @type {string}
   * @memberof AkiParamsItem
   */
  typeKey: string
  /**
   *
   * @type {string}
   * @memberof AkiParamsItem
   */
  unit?: string | null
}
/**
 *
 * @export
 * @interface AkiVasopressorsDTO
 */
export interface AkiVasopressorsDTO {
  /**
   *
   * @type {Array<AkiParamsItem>}
   * @memberof AkiVasopressorsDTO
   */
  perfusionRate: Array<AkiParamsItem>
}
/**
 *
 * @export
 * @interface AkiVitalSignsDTO
 */
export interface AkiVitalSignsDTO {
  /**
   *
   * @type {Array<AkiParamsItem>}
   * @memberof AkiVitalSignsDTO
   */
  heartRate: Array<AkiParamsItem>
  /**
   *
   * @type {BloodPressureMeasurementsDTO}
   * @memberof AkiVitalSignsDTO
   */
  invasiveBloodPressure: BloodPressureMeasurementsDTO
  /**
   *
   * @type {BloodPressureMeasurementsDTO}
   * @memberof AkiVitalSignsDTO
   */
  nonInvasiveBloodPressure: BloodPressureMeasurementsDTO
  /**
   *
   * @type {any}
   * @memberof AkiVitalSignsDTO
   */
  respiratoryRate: any
  /**
   *
   * @type {any}
   * @memberof AkiVitalSignsDTO
   */
  spo2: any
}
/**
 *
 * @export
 * @enum {string}
 */

export const AllCaseOrderOptionsDTO = {
  PATIENT_NAME: 'PATIENT_NAME',
  HEART_RATE: 'HEART_RATE',
  PULSE_RATE: 'PULSE_RATE',
  INV_M_BP: 'INV_M_BP',
  INV_S_BP: 'INV_S_BP',
  INV_D_BP: 'INV_D_BP',
  NON_INV_M_BP: 'NON_INV_M_BP',
  NON_INV_S_BP: 'NON_INV_S_BP',
  NON_INV_D_BP: 'NON_INV_D_BP',
  RR: 'RR',
  TEMP: 'TEMP',
  SPO2: 'SPO2',
  RR_M: 'RR_M',
  ORGAN_SUPPORT: 'ORGAN_SUPPORT',
  EDS_SCORE: 'EDS_SCORE'
} as const

export type AllCaseOrderOptionsDTO =
  (typeof AllCaseOrderOptionsDTO)[keyof typeof AllCaseOrderOptionsDTO]

/**
 *
 * @export
 * @interface AssignDoctorToConsultationRequestDTO
 */
export interface AssignDoctorToConsultationRequestDTO {
  /**
   *
   * @type {string}
   * @memberof AssignDoctorToConsultationRequestDTO
   */
  userName?: string | null
}
/**
 *
 * @export
 * @interface AssignableUserDTO
 */
export interface AssignableUserDTO {
  /**
   *
   * @type {string}
   * @memberof AssignableUserDTO
   */
  firstName?: string | null
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof AssignableUserDTO
   */
  hospitals: Array<HospitalDTO>
  /**
   *
   * @type {string}
   * @memberof AssignableUserDTO
   */
  lastName?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof AssignableUserDTO
   */
  medicalFields?: Array<string>
  /**
   *
   * @type {AssignableUserDTOTitle}
   * @memberof AssignableUserDTO
   */
  title?: AssignableUserDTOTitle
  /**
   *
   * @type {string}
   * @memberof AssignableUserDTO
   */
  userName: string
}
/**
 * @type AssignableUserDTOTitle
 * @export
 */
export type AssignableUserDTOTitle = MedicalTitle | any

/**
 *
 * @export
 * @enum {string}
 */

export const AssignmentStrategyDTO = {
  BROADCAST: 'broadcast',
  SINGLE: 'single'
} as const

export type AssignmentStrategyDTO =
  (typeof AssignmentStrategyDTO)[keyof typeof AssignmentStrategyDTO]

/**
 *
 * @export
 * @interface AuditResponseConsultationAudit
 */
export interface AuditResponseConsultationAudit {
  /**
   *
   * @type {Array<ConsultationAudit>}
   * @memberof AuditResponseConsultationAudit
   */
  audits: Array<ConsultationAudit>
  /**
   *
   * @type {number}
   * @memberof AuditResponseConsultationAudit
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof AuditResponseConsultationAudit
   */
  size: number
  /**
   *
   * @type {number}
   * @memberof AuditResponseConsultationAudit
   */
  total: number
}
/**
 *
 * @export
 * @interface AuditResponseHospitalEscalationAudit
 */
export interface AuditResponseHospitalEscalationAudit {
  /**
   *
   * @type {Array<HospitalEscalationAudit>}
   * @memberof AuditResponseHospitalEscalationAudit
   */
  audits: Array<HospitalEscalationAudit>
  /**
   *
   * @type {number}
   * @memberof AuditResponseHospitalEscalationAudit
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof AuditResponseHospitalEscalationAudit
   */
  size: number
  /**
   *
   * @type {number}
   * @memberof AuditResponseHospitalEscalationAudit
   */
  total: number
}
/**
 *
 * @export
 * @interface BatchPredictionRequestItemDTO
 */
export interface BatchPredictionRequestItemDTO {
  /**
   *
   * @type {string}
   * @memberof BatchPredictionRequestItemDTO
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof BatchPredictionRequestItemDTO
   */
  wardId: string
}
/**
 *
 * @export
 * @interface BatchScoreRequestItemDto
 */
export interface BatchScoreRequestItemDto {
  /**
   *
   * @type {string}
   * @memberof BatchScoreRequestItemDto
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof BatchScoreRequestItemDto
   */
  wardId: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const BloodGasTypeKey = {
  AG: 'AG',
  BE: 'BE',
  BIC: 'BIC',
  CA: 'CA',
  CL: 'CL',
  D_BIC: 'D_BIC',
  FCOHB: 'FCOHB',
  FHHB: 'FHHB',
  FMETHB: 'FMETHB',
  FO2_HB: 'FO2HB',
  GLU: 'GLU',
  LAC: 'LAC',
  PACO2: 'PACO2',
  PCO2: 'PCO2',
  PAO2: 'PAO2',
  PCV: 'PCV',
  PH: 'PH',
  PO2: 'PO2',
  K: 'K',
  SO2: 'SO2',
  NA: 'NA',
  THB: 'THB'
} as const

export type BloodGasTypeKey = (typeof BloodGasTypeKey)[keyof typeof BloodGasTypeKey]

/**
 *
 * @export
 * @interface BloodPressureMeasurementsDTO
 */
export interface BloodPressureMeasurementsDTO {
  /**
   *
   * @type {Array<AkiParamsItem>}
   * @memberof BloodPressureMeasurementsDTO
   */
  diastolic: Array<AkiParamsItem>
  /**
   *
   * @type {any}
   * @memberof BloodPressureMeasurementsDTO
   */
  meanArterialPressure: any
  /**
   *
   * @type {any}
   * @memberof BloodPressureMeasurementsDTO
   */
  systolic: any
}
/**
 *
 * @export
 * @interface CallAccessDTO
 */
export interface CallAccessDTO {
  /**
   *
   * @type {string}
   * @memberof CallAccessDTO
   */
  accessToken: string
  /**
   *
   * @type {string}
   * @memberof CallAccessDTO
   */
  consultationRequestId: string
  /**
   *
   * @type {number}
   * @memberof CallAccessDTO
   */
  roomId: number
}
/**
 *
 * @export
 * @interface CaseCreateDTO
 */
export interface CaseCreateDTO {
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  admissionDiagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  caseIdExt: string
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  dateOfBirth?: string | null
  /**
   *
   * @type {CaseCreateDTODepartment}
   * @memberof CaseCreateDTO
   */
  department?: CaseCreateDTODepartment
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  diagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  firstName?: string | null
  /**
   *
   * @type {GenderDTO}
   * @memberof CaseCreateDTO
   */
  gender: GenderDTO
  /**
   *
   * @type {CaseCreateDTOHospital}
   * @memberof CaseCreateDTO
   */
  hospital?: CaseCreateDTOHospital
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  lastName: string
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  patientIdExt: string
  /**
   *
   * @type {string}
   * @memberof CaseCreateDTO
   */
  preExistingCondition?: string | null
  /**
   *
   * @type {WardDTO}
   * @memberof CaseCreateDTO
   */
  ward: WardDTO
}

/**
 * @type CaseCreateDTODepartment
 * @export
 */
export type CaseCreateDTODepartment = DepartmentDTO | any

/**
 * @type CaseCreateDTOHospital
 * @export
 */
export type CaseCreateDTOHospital = HospitalDTO | any

/**
 *
 * @export
 * @interface CaseDTO
 */
export interface CaseDTO {
  /**
   *
   * @type {string}
   * @memberof CaseDTO
   */
  clientId: string
  /**
   *
   * @type {boolean}
   * @memberof CaseDTO
   */
  consultationsEnabled: boolean
  /**
   *
   * @type {boolean}
   * @memberof CaseDTO
   */
  createdViaApi?: boolean | null
  /**
   *
   * @type {DepartmentDTO}
   * @memberof CaseDTO
   */
  department: DepartmentDTO
  /**
   *
   * @type {boolean}
   * @memberof CaseDTO
   */
  emergencyRoutingUnavailable: boolean
  /**
   *
   * @type {string}
   * @memberof CaseDTO
   */
  externalId: string
  /**
   *
   * @type {HospitalDTO}
   * @memberof CaseDTO
   */
  hospital: HospitalDTO
  /**
   *
   * @type {string}
   * @memberof CaseDTO
   */
  id: string
  /**
   *
   * @type {PatientDTO}
   * @memberof CaseDTO
   */
  patient: PatientDTO
  /**
   *
   * @type {boolean}
   * @memberof CaseDTO
   */
  routineRoutingUnavailable: boolean
  /**
   *
   * @type {boolean}
   * @memberof CaseDTO
   */
  urgentRoutingUnavailable: boolean
  /**
   *
   * @type {WardDTO}
   * @memberof CaseDTO
   */
  ward: WardDTO
}
/**
 *
 * @export
 * @interface CaseEdsScoreDTO
 */
export interface CaseEdsScoreDTO {
  /**
   *
   * @type {string}
   * @memberof CaseEdsScoreDTO
   */
  scoreTimestamp?: string | null
  /**
   *
   * @type {number}
   * @memberof CaseEdsScoreDTO
   */
  scoreValue?: number | null
}
/**
 *
 * @export
 * @interface CaseUpdateDTO
 */
export interface CaseUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  admissionDiagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  caseIdExt: string
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  dateOfBirth?: string | null
  /**
   *
   * @type {CaseUpdateDTODiagnosis}
   * @memberof CaseUpdateDTO
   */
  diagnosis?: CaseUpdateDTODiagnosis
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  firstName?: string | null
  /**
   *
   * @type {GenderDTO}
   * @memberof CaseUpdateDTO
   */
  gender: GenderDTO
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  lastName: string
  /**
   *
   * @type {string}
   * @memberof CaseUpdateDTO
   */
  patientIdExt: string
  /**
   *
   * @type {CaseUpdateDTOPreExistingCondition}
   * @memberof CaseUpdateDTO
   */
  preExistingCondition?: CaseUpdateDTOPreExistingCondition
  /**
   *
   * @type {WardDTO}
   * @memberof CaseUpdateDTO
   */
  ward: WardDTO
}

/**
 * @type CaseUpdateDTODiagnosis
 * @export
 */
export type CaseUpdateDTODiagnosis = DiagnosisDTO | any

/**
 * @type CaseUpdateDTOPreExistingCondition
 * @export
 */
export type CaseUpdateDTOPreExistingCondition = PreExistingConditionDTO | any

/**
 *
 * @export
 * @interface CaseWithPatientV3
 */
export interface CaseWithPatientV3 {
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  datasource_id: string
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  external_id: string
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof CaseWithPatientV3
   */
  is_deleted: boolean
  /**
   *
   * @type {PatientV3}
   * @memberof CaseWithPatientV3
   */
  patient: PatientV3
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  patient_id: string
  /**
   *
   * @type {string}
   * @memberof CaseWithPatientV3
   */
  updated: string
}
/**
 *
 * @export
 * @interface CaseWithPredictionResultDTO
 */
export interface CaseWithPredictionResultDTO {
  /**
   *
   * @type {CaseDTO}
   * @memberof CaseWithPredictionResultDTO
   */
  case: CaseDTO
  /**
   *
   * @type {PredictionResultDTO}
   * @memberof CaseWithPredictionResultDTO
   */
  predictionResult: PredictionResultDTO
  /**
   *
   * @type {PredictionInputsDTO}
   * @memberof CaseWithPredictionResultDTO
   */
  usedInputs: PredictionInputsDTO
}
/**
 *
 * @export
 * @interface CaseWithVitalSignsDTO
 */
export interface CaseWithVitalSignsDTO {
  /**
   *
   * @type {CaseDTO}
   * @memberof CaseWithVitalSignsDTO
   */
  case: CaseDTO
  /**
   *
   * @type {CaseWithVitalSignsDTOEdsScore}
   * @memberof CaseWithVitalSignsDTO
   */
  edsScore?: CaseWithVitalSignsDTOEdsScore
  /**
   *
   * @type {Array<VitalSignItemDTO>}
   * @memberof CaseWithVitalSignsDTO
   */
  laboratory: Array<VitalSignItemDTO>
  /**
   *
   * @type {OrganSupportDTO}
   * @memberof CaseWithVitalSignsDTO
   */
  organSupport: OrganSupportDTO
  /**
   *
   * @type {any}
   * @memberof CaseWithVitalSignsDTO
   */
  vitalSigns: any
}
/**
 * @type CaseWithVitalSignsDTOEdsScore
 * @export
 */
export type CaseWithVitalSignsDTOEdsScore = CaseEdsScoreDTO | any

/**
 *
 * @export
 * @interface CasesWithVitalSignsFilterDTO
 */
export interface CasesWithVitalSignsFilterDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  departmentIds?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  dialysis?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  ecmo?: boolean | null
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  heartRateRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  hemoglobinRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {Array<string>}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  hospitalIds?: Array<string>
  /**
   *
   * @type {boolean}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  impella?: boolean | null
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  lactateRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {number}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  offset: number
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  oxygenSaturationRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  phRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  potassiumRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOSortBy}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  sortBy?: CasesWithVitalSignsFilterDTOSortBy
  /**
   *
   * @type {string}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  sortDirection?: CasesWithVitalSignsFilterDTOSortDirectionEnum | null
  /**
   *
   * @type {CasesWithVitalSignsFilterDTOHeartRateRange}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  temperatureRange?: CasesWithVitalSignsFilterDTOHeartRateRange
  /**
   *
   * @type {boolean}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  vasopressors?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  ventilation?: boolean | null
  /**
   *
   * @type {Array<string>}
   * @memberof CasesWithVitalSignsFilterDTO
   */
  wardIds?: Array<string>
}

export const CasesWithVitalSignsFilterDTOSortDirectionEnum = {
  ASCENDING: 'ASCENDING',
  DESCENDING: 'DESCENDING'
} as const

export type CasesWithVitalSignsFilterDTOSortDirectionEnum =
  (typeof CasesWithVitalSignsFilterDTOSortDirectionEnum)[keyof typeof CasesWithVitalSignsFilterDTOSortDirectionEnum]

/**
 * @type CasesWithVitalSignsFilterDTOHeartRateRange
 * @export
 */
export type CasesWithVitalSignsFilterDTOHeartRateRange = RangeFilterDTO | any

/**
 * @type CasesWithVitalSignsFilterDTOSortBy
 * @export
 */
export type CasesWithVitalSignsFilterDTOSortBy = AllCaseOrderOptionsDTO | any

/**
 *
 * @export
 * @interface CasesWithVitalSignsFilterOptionsResponse
 */
export interface CasesWithVitalSignsFilterOptionsResponse {
  /**
   *
   * @type {Array<DepartmentFilterOptionDTO>}
   * @memberof CasesWithVitalSignsFilterOptionsResponse
   */
  departments: Array<DepartmentFilterOptionDTO>
  /**
   *
   * @type {Array<HospitalFilterOptionDTO>}
   * @memberof CasesWithVitalSignsFilterOptionsResponse
   */
  hospitals: Array<HospitalFilterOptionDTO>
  /**
   *
   * @type {Array<WardFilterOptionDTO>}
   * @memberof CasesWithVitalSignsFilterOptionsResponse
   */
  wards: Array<WardFilterOptionDTO>
}
/**
 *
 * @export
 * @interface ClientCreateDTO
 */
export interface ClientCreateDTO {
  /**
   *
   * @type {string}
   * @memberof ClientCreateDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface ClientStructureDTO
 */
export interface ClientStructureDTO {
  /**
   *
   * @type {Array<HospitalStructureDTO>}
   * @memberof ClientStructureDTO
   */
  hospitals: Array<HospitalStructureDTO>
  /**
   *
   * @type {string}
   * @memberof ClientStructureDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof ClientStructureDTO
   */
  isRoutingV2Enabled: boolean
  /**
   *
   * @type {string}
   * @memberof ClientStructureDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface ClientUpdateDTO
 */
export interface ClientUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof ClientUpdateDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface ClientWithTotalsDTO
 */
export interface ClientWithTotalsDTO {
  /**
   *
   * @type {string}
   * @memberof ClientWithTotalsDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof ClientWithTotalsDTO
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof ClientWithTotalsDTO
   */
  totalCases: number
  /**
   *
   * @type {number}
   * @memberof ClientWithTotalsDTO
   */
  totalUsers: number
}
/**
 *
 * @export
 * @interface ClinicalScoreResultDto
 */
export interface ClinicalScoreResultDto {
  /**
   *
   * @type {string}
   * @memberof ClinicalScoreResultDto
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof ClinicalScoreResultDto
   */
  errorCode?: ClinicalScoreResultDtoErrorCodeEnum | null
  /**
   *
   * @type {string}
   * @memberof ClinicalScoreResultDto
   */
  errorMessage?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ClinicalScoreResultDto
   */
  isSuccessful: boolean
  /**
   *
   * @type {string}
   * @memberof ClinicalScoreResultDto
   */
  scoreTimestamp?: string | null
  /**
   *
   * @type {number}
   * @memberof ClinicalScoreResultDto
   */
  scoreValue?: number | null
}

export const ClinicalScoreResultDtoErrorCodeEnum = {
  WARD_EXCLUDED: 'WARD_EXCLUDED',
  STALE_DATA: 'STALE_DATA',
  MISSING_PARAMS: 'MISSING_PARAMS',
  EXTERNAL_ENGINE_ERROR: 'EXTERNAL_ENGINE_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  MISSING_DATA: 'MISSING_DATA',
  SCHEMA_INCORRECT: 'SCHEMA_INCORRECT',
  PLUGIN_DISABLED: 'PLUGIN_DISABLED'
} as const

export type ClinicalScoreResultDtoErrorCodeEnum =
  (typeof ClinicalScoreResultDtoErrorCodeEnum)[keyof typeof ClinicalScoreResultDtoErrorCodeEnum]

/**
 *
 * @export
 * @interface CompletedConsultationPatientsResponse
 */
export interface CompletedConsultationPatientsResponse {
  /**
   *
   * @type {Array<PatientDTO>}
   * @memberof CompletedConsultationPatientsResponse
   */
  patients: Array<PatientDTO>
}
/**
 *
 * @export
 * @interface ConfirmPairingResponse
 */
export interface ConfirmPairingResponse {
  /**
   *
   * @type {boolean}
   * @memberof ConfirmPairingResponse
   */
  success: boolean
}
/**
 *
 * @export
 * @interface ConfirmPairingStatusAppRequest
 */
export interface ConfirmPairingStatusAppRequest {
  /**
   *
   * @type {string}
   * @memberof ConfirmPairingStatusAppRequest
   */
  confirmationCode: string
  /**
   *
   * @type {string}
   * @memberof ConfirmPairingStatusAppRequest
   */
  email: string
}
/**
 *
 * @export
 * @interface ConsultationAudit
 */
export interface ConsultationAudit {
  /**
   *
   * @type {number}
   * @memberof ConsultationAudit
   */
  auditId?: number | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  auditTimestamp?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  caseId?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  consultationId?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  creator?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  hospital?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  reacted?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  reaction?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  reactionDuration?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  receiver?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  receivingDepartment?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  requestType?: ConsultationAuditRequestTypeEnum | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  shift?: ConsultationAuditShiftEnum | null
  /**
   *
   * @type {string}
   * @memberof ConsultationAudit
   */
  startedAt?: string | null
}

export const ConsultationAuditRequestTypeEnum = {
  EMERGENCY: 'emergency',
  URGENT: 'urgent',
  ROUTINE: 'routine',
  FOLLOW_UP: 'follow_up'
} as const

export type ConsultationAuditRequestTypeEnum =
  (typeof ConsultationAuditRequestTypeEnum)[keyof typeof ConsultationAuditRequestTypeEnum]
export const ConsultationAuditShiftEnum = {
  CREATED: 'created',
  FIRST_SHIFT: 'first_shift',
  BACKUP_SHIFT: 'backup_shift',
  ALL_IN_HOSPITAL: 'all_in_hospital',
  TCC: 'tcc',
  SENIOR_PHYSICIAN: 'senior_physician',
  EMERGENCY_TCC: 'emergency_tcc',
  EMERGENCY_HOSPITAL: 'emergency_hospital',
  EMERGENCY_SENIOR_PHYSICIAN: 'emergency_senior_physician',
  EMERGENCY_WARD: 'emergency_ward'
} as const

export type ConsultationAuditShiftEnum =
  (typeof ConsultationAuditShiftEnum)[keyof typeof ConsultationAuditShiftEnum]

/**
 *
 * @export
 * @interface ConsultationAuditSort
 */
export interface ConsultationAuditSort {
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  assignedToSort: ConsultationAuditSortAssignedToSortEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  createdBySort: ConsultationAuditSortCreatedBySortEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  dateSort: ConsultationAuditSortDateSortEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  deletedBySort: ConsultationAuditSortDeletedBySortEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  requestedBySort: ConsultationAuditSortRequestedBySortEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationAuditSort
   */
  statusSort: ConsultationAuditSortStatusSortEnum
}

export const ConsultationAuditSortAssignedToSortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortAssignedToSortEnum =
  (typeof ConsultationAuditSortAssignedToSortEnum)[keyof typeof ConsultationAuditSortAssignedToSortEnum]
export const ConsultationAuditSortCreatedBySortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortCreatedBySortEnum =
  (typeof ConsultationAuditSortCreatedBySortEnum)[keyof typeof ConsultationAuditSortCreatedBySortEnum]
export const ConsultationAuditSortDateSortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortDateSortEnum =
  (typeof ConsultationAuditSortDateSortEnum)[keyof typeof ConsultationAuditSortDateSortEnum]
export const ConsultationAuditSortDeletedBySortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortDeletedBySortEnum =
  (typeof ConsultationAuditSortDeletedBySortEnum)[keyof typeof ConsultationAuditSortDeletedBySortEnum]
export const ConsultationAuditSortRequestedBySortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortRequestedBySortEnum =
  (typeof ConsultationAuditSortRequestedBySortEnum)[keyof typeof ConsultationAuditSortRequestedBySortEnum]
export const ConsultationAuditSortStatusSortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type ConsultationAuditSortStatusSortEnum =
  (typeof ConsultationAuditSortStatusSortEnum)[keyof typeof ConsultationAuditSortStatusSortEnum]

/**
 *
 * @export
 * @interface ConsultationReportPayloadDTO
 */
export interface ConsultationReportPayloadDTO extends NotificationPayloadDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationReportPayloadDTO
   */
  consultationRequestId: string
  /**
   *
   * @type {string}
   * @memberof ConsultationReportPayloadDTO
   */
  medicalFieldId: string
  /**
   *
   * @type {string}
   * @memberof ConsultationReportPayloadDTO
   */
  question: string
  /**
   *
   * @type {string}
   * @memberof ConsultationReportPayloadDTO
   */
  recommendation: string
  /**
   *
   * @type {CaseDTO}
   * @memberof ConsultationReportPayloadDTO
   */
  case: CaseDTO
}
/**
 *
 * @export
 * @interface ConsultationReportsDTO
 */
export interface ConsultationReportsDTO {
  /**
   *
   * @type {Array<PatientReportFileDTO>}
   * @memberof ConsultationReportsDTO
   */
  reportFiles: Array<PatientReportFileDTO>
  /**
   *
   * @type {Array<UserDetailsDTO>}
   * @memberof ConsultationReportsDTO
   */
  reportParticipants: Array<UserDetailsDTO>
}
/**
 *
 * @export
 * @interface ConsultationRequestAuditDTO
 */
export interface ConsultationRequestAuditDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestAuditDTO
   */
  assignedAt?: string | null
  /**
   *
   * @type {ConsultationRequestAuditDTOAssignedTo}
   * @memberof ConsultationRequestAuditDTO
   */
  assignedTo?: ConsultationRequestAuditDTOAssignedTo
  /**
   *
   * @type {CaseDTO}
   * @memberof ConsultationRequestAuditDTO
   */
  case: CaseDTO
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestAuditDTO
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestAuditDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestAuditDTO
   */
  medicalFieldId: string
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof ConsultationRequestAuditDTO
   */
  requestedBy: UserDetailsDTO
  /**
   *
   * @type {ConsultationRequestStatusDTO}
   * @memberof ConsultationRequestAuditDTO
   */
  status: ConsultationRequestStatusDTO
  /**
   *
   * @type {UrgencyDTO}
   * @memberof ConsultationRequestAuditDTO
   */
  urgency: UrgencyDTO
}

/**
 * @type ConsultationRequestAuditDTOAssignedTo
 * @export
 */
export type ConsultationRequestAuditDTOAssignedTo = UserDTO | any

/**
 *
 * @export
 * @interface ConsultationRequestCreationDTO
 */
export interface ConsultationRequestCreationDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  caseId: string
  /**
   *
   * @type {Array<CustomConsultationFieldDataCreationDTO>}
   * @memberof ConsultationRequestCreationDTO
   */
  customFields: Array<CustomConsultationFieldDataCreationDTO>
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  diagnosis: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  medicalFieldId: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  medicalHistory?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  question: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestCreationDTO
   */
  therapy?: string | null
  /**
   *
   * @type {UrgencyDTO}
   * @memberof ConsultationRequestCreationDTO
   */
  urgency: UrgencyDTO
}

/**
 *
 * @export
 * @interface ConsultationRequestDTO
 */
export interface ConsultationRequestDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  assignedAt?: string | null
  /**
   *
   * @type {ConsultationRequestDTOAssignedTo}
   * @memberof ConsultationRequestDTO
   */
  assignedTo?: ConsultationRequestDTOAssignedTo
  /**
   *
   * @type {CaseDTO}
   * @memberof ConsultationRequestDTO
   */
  case: CaseDTO
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  createdAt: string | null
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof ConsultationRequestDTO
   */
  createdBy: UserDetailsDTO
  /**
   *
   * @type {Array<CustomConsultationFieldDTO>}
   * @memberof ConsultationRequestDTO
   */
  customFields: Array<CustomConsultationFieldDTO>
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  diagnosis: string
  /**
   *
   * @type {EscalationLevelDTO}
   * @memberof ConsultationRequestDTO
   */
  escalationLevel: EscalationLevelDTO
  /**
   *
   * @type {ConsultationRequestDTOEscalationProgress}
   * @memberof ConsultationRequestDTO
   */
  escalationProgress?: ConsultationRequestDTOEscalationProgress
  /**
   *
   * @type {boolean}
   * @memberof ConsultationRequestDTO
   */
  hasActiveCall: boolean
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof ConsultationRequestDTO
   */
  isUserInCall: boolean
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  medicalField: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  medicalHistory?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  nextEscalationAt?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  question: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  receiverJoinedAt?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ConsultationRequestDTO
   */
  recipientsAvailable: boolean
  /**
   *
   * @type {ConsultationRequestUserRelationDTO}
   * @memberof ConsultationRequestDTO
   */
  relationToUser: ConsultationRequestUserRelationDTO
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof ConsultationRequestDTO
   */
  requestedBy: UserDetailsDTO
  /**
   *
   * @type {ConsultationRequestStatusDTO}
   * @memberof ConsultationRequestDTO
   */
  status: ConsultationRequestStatusDTO
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestDTO
   */
  therapy?: string | null
  /**
   *
   * @type {UrgencyDTO}
   * @memberof ConsultationRequestDTO
   */
  urgency: UrgencyDTO
}

/**
 * @type ConsultationRequestDTOAssignedTo
 * @export
 */
export type ConsultationRequestDTOAssignedTo = UserDetailsDTO | any

/**
 * @type ConsultationRequestDTOEscalationProgress
 * @export
 */
export type ConsultationRequestDTOEscalationProgress = EscalationProgressDTO | any

/**
 *
 * @export
 * @interface ConsultationRequestFilterDTO
 */
export interface ConsultationRequestFilterDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  assignedAtFrom?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  assignedAtTo?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  assignedTo?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  caseId?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  createdAtFrom?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  createdAtTo?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  createdBy?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  deletedAtFrom?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  deletedAtTo?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  deletedBy?: string | null
  /**
   *
   * @type {ConsultationRequestFilterDTOEscalationLevel}
   * @memberof ConsultationRequestFilterDTO
   */
  escalationLevel?: ConsultationRequestFilterDTOEscalationLevel
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  id?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  medicalFieldId?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  nextEscalationAtFrom?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  nextEscalationAtTo?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestFilterDTO
   */
  requestedBy?: string | null
  /**
   *
   * @type {ConsultationRequestFilterDTOStatus}
   * @memberof ConsultationRequestFilterDTO
   */
  status?: ConsultationRequestFilterDTOStatus
  /**
   *
   * @type {ConsultationRequestFilterDTOUrgency}
   * @memberof ConsultationRequestFilterDTO
   */
  urgency?: ConsultationRequestFilterDTOUrgency
}
/**
 * @type ConsultationRequestFilterDTOEscalationLevel
 * @export
 */
export type ConsultationRequestFilterDTOEscalationLevel = EscalationLevelDTO | any

/**
 * @type ConsultationRequestFilterDTOStatus
 * @export
 */
export type ConsultationRequestFilterDTOStatus = ConsultationRequestStatusDTO | any

/**
 * @type ConsultationRequestFilterDTOUrgency
 * @export
 */
export type ConsultationRequestFilterDTOUrgency = UrgencyDTO | any

/**
 *
 * @export
 * @interface ConsultationRequestReportDTO
 */
export interface ConsultationRequestReportDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestReportDTO
   */
  fileId?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestReportDTO
   */
  medicalHistory: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestReportDTO
   */
  recommendation: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const ConsultationRequestStatusDTO = {
  CREATED: 'created',
  ACCEPTED: 'accepted',
  IN_PROGRESS: 'in_progress',
  REPORT_PENDING: 'report_pending',
  COMPLETED: 'completed',
  DELETED: 'deleted'
} as const

export type ConsultationRequestStatusDTO =
  (typeof ConsultationRequestStatusDTO)[keyof typeof ConsultationRequestStatusDTO]

/**
 *
 * @export
 * @enum {string}
 */

export const ConsultationRequestUserRelationDTO = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  NONE: 'none'
} as const

export type ConsultationRequestUserRelationDTO =
  (typeof ConsultationRequestUserRelationDTO)[keyof typeof ConsultationRequestUserRelationDTO]

/**
 *
 * @export
 * @interface ConsultationRequestWithCaseDTO
 */
export interface ConsultationRequestWithCaseDTO {
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  assignedAt?: string | null
  /**
   *
   * @type {ConsultationRequestWithCaseDTOAssignedTo}
   * @memberof ConsultationRequestWithCaseDTO
   */
  assignedTo?: ConsultationRequestWithCaseDTOAssignedTo
  /**
   *
   * @type {CaseDTO}
   * @memberof ConsultationRequestWithCaseDTO
   */
  case: CaseDTO
  /**
   *
   * @type {UserName}
   * @memberof ConsultationRequestWithCaseDTO
   */
  createdBy: UserName
  /**
   *
   * @type {Array<CustomConsultationFieldDTO>}
   * @memberof ConsultationRequestWithCaseDTO
   */
  customFields: Array<CustomConsultationFieldDTO>
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  diagnosis: string
  /**
   *
   * @type {EscalationLevelDTO}
   * @memberof ConsultationRequestWithCaseDTO
   */
  escalationLevel: EscalationLevelDTO
  /**
   *
   * @type {boolean}
   * @memberof ConsultationRequestWithCaseDTO
   */
  hasActiveCall: boolean
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof ConsultationRequestWithCaseDTO
   */
  isUserInCall: boolean
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  medicalFieldId: string
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  medicalHistory?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  nextEscalationAt?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  question: string
  /**
   *
   * @type {ConsultationRequestWithCaseDTORelationToUser}
   * @memberof ConsultationRequestWithCaseDTO
   */
  relationToUser?: ConsultationRequestWithCaseDTORelationToUser
  /**
   *
   * @type {UserName}
   * @memberof ConsultationRequestWithCaseDTO
   */
  requestedBy: UserName
  /**
   *
   * @type {ConsultationRequestStatusDTO}
   * @memberof ConsultationRequestWithCaseDTO
   */
  status: ConsultationRequestStatusDTO
  /**
   *
   * @type {string}
   * @memberof ConsultationRequestWithCaseDTO
   */
  therapy?: string | null
  /**
   *
   * @type {UrgencyDTO}
   * @memberof ConsultationRequestWithCaseDTO
   */
  urgency: UrgencyDTO
}

/**
 * @type ConsultationRequestWithCaseDTOAssignedTo
 * @export
 */
export type ConsultationRequestWithCaseDTOAssignedTo = User | any

/**
 * @type ConsultationRequestWithCaseDTORelationToUser
 * @export
 */
export type ConsultationRequestWithCaseDTORelationToUser = ConsultationRequestUserRelationDTO | any

/**
 *
 * @export
 * @enum {string}
 */

export const ConsultationStatusDto = {
  CREATED: 'created',
  ACCEPTED: 'accepted',
  IN_PROGRESS: 'in_progress',
  REPORT_PENDING: 'report_pending',
  COMPLETED: 'completed',
  DELETED: 'deleted',
  CASE_MISSING: 'case_missing',
  REPORTS_COMPLETED: 'reports_completed'
} as const

export type ConsultationStatusDto =
  (typeof ConsultationStatusDto)[keyof typeof ConsultationStatusDto]

/**
 *
 * @export
 * @interface ConsultationSummaryDTO
 */
export interface ConsultationSummaryDTO {
  /**
   *
   * @type {Array<UserDetailsDTO>}
   * @memberof ConsultationSummaryDTO
   */
  acceptedBy: Array<UserDetailsDTO>
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  consultationShareCode?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  consultationShareCodeValidUntil?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  consultationType: ConsultationSummaryDTOConsultationTypeEnum
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  createdAt: string
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof ConsultationSummaryDTO
   */
  createdBy: UserDetailsDTO
  /**
   *
   * @type {Array<CustomConsultationFieldDTO>}
   * @memberof ConsultationSummaryDTO
   */
  customFields: Array<CustomConsultationFieldDTO>
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  deletedAt?: string | null
  /**
   *
   * @type {ConsultationRequestDTOAssignedTo}
   * @memberof ConsultationSummaryDTO
   */
  deletedBy?: ConsultationRequestDTOAssignedTo
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  endedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof ConsultationSummaryDTO
   */
  medicalHistory: string
  /**
   *
   * @type {Array<PatientDTO>}
   * @memberof ConsultationSummaryDTO
   */
  patients: Array<PatientDTO>
  /**
   *
   * @type {ConsultationRequestUserRelationDTO}
   * @memberof ConsultationSummaryDTO
   */
  relationToUser: ConsultationRequestUserRelationDTO
  /**
   *
   * @type {ConsultationReportsDTO}
   * @memberof ConsultationSummaryDTO
   */
  reports: ConsultationReportsDTO
  /**
   *
   * @type {ConsultationStatusDto}
   * @memberof ConsultationSummaryDTO
   */
  status: ConsultationStatusDto
}

export const ConsultationSummaryDTOConsultationTypeEnum = {
  SCHEDULED: 'SCHEDULED',
  DIRECT: 'DIRECT'
} as const

export type ConsultationSummaryDTOConsultationTypeEnum =
  (typeof ConsultationSummaryDTOConsultationTypeEnum)[keyof typeof ConsultationSummaryDTOConsultationTypeEnum]

/**
 *
 * @export
 * @interface CreateDepartmentsRequest
 */
export interface CreateDepartmentsRequest {
  /**
   *
   * @type {Array<DepartmentCreateDTO>}
   * @memberof CreateDepartmentsRequest
   */
  departments: Array<DepartmentCreateDTO>
}
/**
 *
 * @export
 * @interface CreateWardsRequest
 */
export interface CreateWardsRequest {
  /**
   *
   * @type {Array<WardCreateDTO>}
   * @memberof CreateWardsRequest
   */
  wards: Array<WardCreateDTO>
}
/**
 *
 * @export
 * @interface CustomConsultationFieldCreationDTO
 */
export interface CustomConsultationFieldCreationDTO {
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldCreationDTO
   */
  clientId: string
  /**
   *
   * @type {Array<CustomFieldConsultationTypeDTO>}
   * @memberof CustomConsultationFieldCreationDTO
   */
  consultationTypes: Array<CustomFieldConsultationTypeDTO>
  /**
   *
   * @type {CustomConsultationFieldDataTypeDTO}
   * @memberof CustomConsultationFieldCreationDTO
   */
  dataType: CustomConsultationFieldDataTypeDTO
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldCreationDTO
   */
  labelEnglish: string
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldCreationDTO
   */
  labelGerman: string
  /**
   *
   * @type {boolean}
   * @memberof CustomConsultationFieldCreationDTO
   */
  mandatory: boolean
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldCreationDTO
   */
  maxLength?: number | null
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldCreationDTO
   */
  ordinal?: number | null
}

/**
 *
 * @export
 * @interface CustomConsultationFieldDTO
 */
export interface CustomConsultationFieldDTO {
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldDTO
   */
  clientId: string
  /**
   *
   * @type {CustomConsultationFieldDataTypeDTO}
   * @memberof CustomConsultationFieldDTO
   */
  dataType: CustomConsultationFieldDataTypeDTO
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldDTO
   */
  label: string
  /**
   *
   * @type {boolean}
   * @memberof CustomConsultationFieldDTO
   */
  mandatory: boolean
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldDTO
   */
  maxLength?: number | null
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldDTO
   */
  ordinal: number
  /**
   *
   * @type {any}
   * @memberof CustomConsultationFieldDTO
   */
  value?: any | null
}

/**
 *
 * @export
 * @interface CustomConsultationFieldDataCreationDTO
 */
export interface CustomConsultationFieldDataCreationDTO {
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldDataCreationDTO
   */
  customFieldId: string
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldDataCreationDTO
   */
  valueText?: string | null
}
/**
 *
 * @export
 * @enum {string}
 */

export const CustomConsultationFieldDataTypeDTO = {
  TEXT: 'text'
} as const

export type CustomConsultationFieldDataTypeDTO =
  (typeof CustomConsultationFieldDataTypeDTO)[keyof typeof CustomConsultationFieldDataTypeDTO]

/**
 *
 * @export
 * @interface CustomConsultationFieldUpdateDTO
 */
export interface CustomConsultationFieldUpdateDTO {
  /**
   *
   * @type {Array<CustomFieldConsultationTypeDTO>}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  consultationTypes: Array<CustomFieldConsultationTypeDTO>
  /**
   *
   * @type {CustomConsultationFieldDataTypeDTO}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  dataType: CustomConsultationFieldDataTypeDTO
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  labelEnglish: string
  /**
   *
   * @type {string}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  labelGerman: string
  /**
   *
   * @type {boolean}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  mandatory: boolean
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  maxLength?: number | null
  /**
   *
   * @type {number}
   * @memberof CustomConsultationFieldUpdateDTO
   */
  ordinal?: number | null
}

/**
 *
 * @export
 * @enum {string}
 */

export const CustomFieldConsultationTypeDTO = {
  ROUTINE: 'routine',
  URGENT: 'urgent',
  EMERGENCY: 'emergency',
  PATIENT_VISIT: 'patient_visit',
  CONFERENCE: 'conference',
  PATIENT_PRESENTATION: 'patient_presentation'
} as const

export type CustomFieldConsultationTypeDTO =
  (typeof CustomFieldConsultationTypeDTO)[keyof typeof CustomFieldConsultationTypeDTO]

/**
 *
 * @export
 * @interface DateRange
 */
export interface DateRange {
  /**
   *
   * @type {string}
   * @memberof DateRange
   */
  from?: string | null
  /**
   *
   * @type {string}
   * @memberof DateRange
   */
  to?: string | null
}
/**
 *
 * @export
 * @interface DepartmentCreateDTO
 */
export interface DepartmentCreateDTO {
  /**
   *
   * @type {string}
   * @memberof DepartmentCreateDTO
   */
  hospitalId: string
  /**
   *
   * @type {string}
   * @memberof DepartmentCreateDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface DepartmentDTO
 */
export interface DepartmentDTO {
  /**
   *
   * @type {string}
   * @memberof DepartmentDTO
   */
  hospitalId: string
  /**
   *
   * @type {string}
   * @memberof DepartmentDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof DepartmentDTO
   */
  isDeleted: boolean
  /**
   *
   * @type {string}
   * @memberof DepartmentDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface DepartmentFilterOptionDTO
 */
export interface DepartmentFilterOptionDTO {
  /**
   *
   * @type {DepartmentDTO}
   * @memberof DepartmentFilterOptionDTO
   */
  department: DepartmentDTO
  /**
   *
   * @type {number}
   * @memberof DepartmentFilterOptionDTO
   */
  patientCount: number
}
/**
 *
 * @export
 * @interface DepartmentStructureDTO
 */
export interface DepartmentStructureDTO {
  /**
   *
   * @type {string}
   * @memberof DepartmentStructureDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof DepartmentStructureDTO
   */
  isDeleted: boolean
  /**
   *
   * @type {string}
   * @memberof DepartmentStructureDTO
   */
  name: string
  /**
   *
   * @type {Array<WardDTO>}
   * @memberof DepartmentStructureDTO
   */
  wards: Array<WardDTO>
}
/**
 *
 * @export
 * @interface DepartmentWithWardsUpdateDTO
 */
export interface DepartmentWithWardsUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof DepartmentWithWardsUpdateDTO
   */
  departmentId: string
  /**
   *
   * @type {string}
   * @memberof DepartmentWithWardsUpdateDTO
   */
  hospitalId: string
  /**
   *
   * @type {boolean}
   * @memberof DepartmentWithWardsUpdateDTO
   */
  isDeleted?: boolean | null
  /**
   *
   * @type {string}
   * @memberof DepartmentWithWardsUpdateDTO
   */
  name: string
  /**
   *
   * @type {Array<WardUpdateDTO>}
   * @memberof DepartmentWithWardsUpdateDTO
   */
  wards: Array<WardUpdateDTO>
}
/**
 *
 * @export
 * @interface DiagnosisDTO
 */
export interface DiagnosisDTO {
  /**
   *
   * @type {string}
   * @memberof DiagnosisDTO
   */
  date: string
  /**
   *
   * @type {string}
   * @memberof DiagnosisDTO
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof DiagnosisDTO
   */
  id?: string | null
}
/**
 * Direct consultation details
 * @export
 * @interface DirectConsultationSummaryDTO
 */
export interface DirectConsultationSummaryDTO extends ConsultationSummaryDTO {
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfDeletedBy}
   * @memberof DirectConsultationSummaryDTO
   */
  deletedBy?: DirectConsultationSummaryDTOAllOfDeletedBy
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  assignedAt?: string | null
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfAssignedTo}
   * @memberof DirectConsultationSummaryDTO
   */
  assignedTo?: DirectConsultationSummaryDTOAllOfAssignedTo
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfCase}
   * @memberof DirectConsultationSummaryDTO
   */
  case?: DirectConsultationSummaryDTOAllOfCase
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  diagnosis: string
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfEscalationDuration}
   * @memberof DirectConsultationSummaryDTO
   */
  escalationDuration?: DirectConsultationSummaryDTOAllOfEscalationDuration
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfEscalationLevel}
   * @memberof DirectConsultationSummaryDTO
   */
  escalationLevel?: DirectConsultationSummaryDTOAllOfEscalationLevel
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfEscalationProgress}
   * @memberof DirectConsultationSummaryDTO
   */
  escalationProgress?: DirectConsultationSummaryDTOAllOfEscalationProgress
  /**
   *
   * @type {MedicalFieldDTO}
   * @memberof DirectConsultationSummaryDTO
   */
  medicalField: MedicalFieldDTO
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  nextEscalationAt?: string | null
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  question: string
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof DirectConsultationSummaryDTO
   */
  requestedBy: UserDetailsDTO
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  receiverJoinedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof DirectConsultationSummaryDTO
   */
  therapy?: string | null
  /**
   *
   * @type {UrgencyDTO}
   * @memberof DirectConsultationSummaryDTO
   */
  urgency: UrgencyDTO
}

/**
 * @type DirectConsultationSummaryDTOAllOfAssignedTo
 * @export
 */
export type DirectConsultationSummaryDTOAllOfAssignedTo = UserDetailsDTO | any

/**
 * @type DirectConsultationSummaryDTOAllOfCase
 * @export
 */
export type DirectConsultationSummaryDTOAllOfCase = CaseDTO | any

/**
 * @type DirectConsultationSummaryDTOAllOfDeletedBy
 * @export
 */
export type DirectConsultationSummaryDTOAllOfDeletedBy = UserDetailsDTO | any

/**
 * @type DirectConsultationSummaryDTOAllOfEscalationDuration
 * @export
 */
export type DirectConsultationSummaryDTOAllOfEscalationDuration = EscalationDuration | any

/**
 * @type DirectConsultationSummaryDTOAllOfEscalationLevel
 * @export
 */
export type DirectConsultationSummaryDTOAllOfEscalationLevel = EscalationLevelDTO | any

/**
 * @type DirectConsultationSummaryDTOAllOfEscalationProgress
 * @export
 */
export type DirectConsultationSummaryDTOAllOfEscalationProgress = EscalationProgressDTO | any

/**
 *
 * @export
 * @enum {string}
 */

export const Discharge = {
  DEATH: 'DEATH',
  HOME: 'HOME',
  NORMAL_WARD: 'NORMAL_WARD',
  OTHER_ICU: 'OTHER_ICU',
  INTERMEDIATE_CARE: 'INTERMEDIATE_CARE'
} as const

export type Discharge = (typeof Discharge)[keyof typeof Discharge]

/**
 *
 * @export
 * @interface DownloadFileResponse
 */
export interface DownloadFileResponse {
  /**
   *
   * @type {string}
   * @memberof DownloadFileResponse
   */
  downloadUrl: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const EasyRadiologyImagingTypeDTO = {
  CT: 'ct',
  MRI: 'mri',
  ENDOSCOPY: 'endoscopy',
  ULTRASOUND: 'ultrasound'
} as const

export type EasyRadiologyImagingTypeDTO =
  (typeof EasyRadiologyImagingTypeDTO)[keyof typeof EasyRadiologyImagingTypeDTO]

/**
 *
 * @export
 * @interface ErrorResponseDto
 */
export interface ErrorResponseDto {
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  code?: ErrorResponseDtoCodeEnum | null
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  detail?: string | null
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  errorId?: string | null
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  instance?: string | null
  /**
   *
   * @type {number}
   * @memberof ErrorResponseDto
   */
  status?: number | null
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof ErrorResponseDto
   */
  type?: string | null
}

export const ErrorResponseDtoCodeEnum = {
  NOT_FOUND: 'CONSULTATION_DECLINE_NOT_FOUND',
  NO_AVAILABLE_PHYSICIAN: 'CONSULTATION_DECLINE_NO_AVAILABLE_PHYSICIAN',
  VALIDATION_FAILED: 'CONSULTATION_DECLINE_VALIDATION_FAILED'
} as const

export type ErrorResponseDtoCodeEnum =
  (typeof ErrorResponseDtoCodeEnum)[keyof typeof ErrorResponseDtoCodeEnum]

/**
 *
 * @export
 * @interface EscalationChainConfigurationDTO
 */
export interface EscalationChainConfigurationDTO {
  /**
   *
   * @type {EscalationChainDTO}
   * @memberof EscalationChainConfigurationDTO
   */
  escalationChain: EscalationChainDTO
  /**
   *
   * @type {string}
   * @memberof EscalationChainConfigurationDTO
   */
  inheritedFromId?: string | null
  /**
   *
   * @type {EscalationChainConfigurationDTOInheritedFromScope}
   * @memberof EscalationChainConfigurationDTO
   */
  inheritedFromScope?: EscalationChainConfigurationDTOInheritedFromScope
  /**
   *
   * @type {EscalationChainConfigurationStatusDTO}
   * @memberof EscalationChainConfigurationDTO
   */
  status: EscalationChainConfigurationStatusDTO
  /**
   *
   * @type {UrgencyDTO}
   * @memberof EscalationChainConfigurationDTO
   */
  urgency: UrgencyDTO
}

/**
 * @type EscalationChainConfigurationDTOInheritedFromScope
 * @export
 */
export type EscalationChainConfigurationDTOInheritedFromScope = ScopeBoundaryDTO | any

/**
 *
 * @export
 * @enum {string}
 */

export const EscalationChainConfigurationStatusDTO = {
  CUSTOM: 'custom',
  INHERITED: 'inherited',
  NOT_CONFIGURED: 'notConfigured'
} as const

export type EscalationChainConfigurationStatusDTO =
  (typeof EscalationChainConfigurationStatusDTO)[keyof typeof EscalationChainConfigurationStatusDTO]

/**
 *
 * @export
 * @interface EscalationChainCreationDTO
 */
export interface EscalationChainCreationDTO {
  /**
   *
   * @type {string}
   * @memberof EscalationChainCreationDTO
   */
  clientId?: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationChainCreationDTO
   */
  departmentId?: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationChainCreationDTO
   */
  hospitalId?: string | null
  /**
   *
   * @type {boolean}
   * @memberof EscalationChainCreationDTO
   */
  repeatAllInstances: boolean
  /**
   *
   * @type {Array<EscalationChainStepCreationDTO>}
   * @memberof EscalationChainCreationDTO
   */
  steps: Array<EscalationChainStepCreationDTO>
  /**
   *
   * @type {UrgencyDTO}
   * @memberof EscalationChainCreationDTO
   */
  urgency: UrgencyDTO
  /**
   *
   * @type {string}
   * @memberof EscalationChainCreationDTO
   */
  wardId?: string | null
}

/**
 *
 * @export
 * @interface EscalationChainDTO
 */
export interface EscalationChainDTO {
  /**
   *
   * @type {string}
   * @memberof EscalationChainDTO
   */
  clientId: string | null
  /**
   *
   * @type {UserName}
   * @memberof EscalationChainDTO
   */
  createdBy: UserName
  /**
   *
   * @type {string}
   * @memberof EscalationChainDTO
   */
  departmentId: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationChainDTO
   */
  escalationChainId: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainDTO
   */
  hospitalId: string | null
  /**
   *
   * @type {boolean}
   * @memberof EscalationChainDTO
   */
  isCustom: boolean
  /**
   *
   * @type {boolean}
   * @memberof EscalationChainDTO
   */
  repeatAllInstances: boolean
  /**
   *
   * @type {Array<EscalationChainStepDTO>}
   * @memberof EscalationChainDTO
   */
  steps: Array<EscalationChainStepDTO>
  /**
   *
   * @type {ConsultationRequestFilterDTOUrgency}
   * @memberof EscalationChainDTO
   */
  urgency: ConsultationRequestFilterDTOUrgency
  /**
   *
   * @type {string}
   * @memberof EscalationChainDTO
   */
  wardId: string | null
}
/**
 *
 * @export
 * @interface EscalationChainStepAuditDTO
 */
export interface EscalationChainStepAuditDTO {
  /**
   *
   * @type {AssignmentStrategyDTO}
   * @memberof EscalationChainStepAuditDTO
   */
  assignmentStrategy: AssignmentStrategyDTO
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof EscalationChainStepAuditDTO
   */
  destinationHospitals?: Array<HospitalDTO>
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepAuditDTO
   */
  escalationDuration: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepAuditDTO
   */
  escalationStepId: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepAuditDTO
   */
  medicalField?: string | null
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepAuditDTO
   */
  poolSize?: number | null
  /**
   *
   * @type {ScopeBoundaryDTO}
   * @memberof EscalationChainStepAuditDTO
   */
  scopeBoundary: ScopeBoundaryDTO
  /**
   *
   * @type {Array<ShiftTypeDTO>}
   * @memberof EscalationChainStepAuditDTO
   */
  shiftTypes?: Array<ShiftTypeDTO>
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepAuditDTO
   */
  stepOrder: number
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof EscalationChainStepAuditDTO
   */
  userRoles?: Array<UserRightsEnum>
}

/**
 *
 * @export
 * @interface EscalationChainStepCreationDTO
 */
export interface EscalationChainStepCreationDTO {
  /**
   *
   * @type {AssignmentStrategyDTO}
   * @memberof EscalationChainStepCreationDTO
   */
  assignmentStrategy: AssignmentStrategyDTO
  /**
   *
   * @type {Array<string>}
   * @memberof EscalationChainStepCreationDTO
   */
  destinationHospitalIds?: Array<string>
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepCreationDTO
   */
  escalationDuration: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepCreationDTO
   */
  medicalField?: string | null
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepCreationDTO
   */
  poolSize?: number | null
  /**
   *
   * @type {ScopeBoundaryDTO}
   * @memberof EscalationChainStepCreationDTO
   */
  scopeBoundary: ScopeBoundaryDTO
  /**
   *
   * @type {Array<ShiftTypeDTO>}
   * @memberof EscalationChainStepCreationDTO
   */
  shiftTypes?: Array<ShiftTypeDTO>
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepCreationDTO
   */
  stepOrder: number
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof EscalationChainStepCreationDTO
   */
  userRoles?: Array<UserRightsEnum>
}

/**
 *
 * @export
 * @interface EscalationChainStepDTO
 */
export interface EscalationChainStepDTO {
  /**
   *
   * @type {AssignmentStrategyDTO}
   * @memberof EscalationChainStepDTO
   */
  assignmentStrategy: AssignmentStrategyDTO
  /**
   *
   * @type {Array<string>}
   * @memberof EscalationChainStepDTO
   */
  destinationHospitalIds?: Array<string>
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepDTO
   */
  escalationDuration: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepDTO
   */
  escalationStepId: string
  /**
   *
   * @type {string}
   * @memberof EscalationChainStepDTO
   */
  medicalField?: string | null
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepDTO
   */
  poolSize?: number | null
  /**
   *
   * @type {ScopeBoundaryDTO}
   * @memberof EscalationChainStepDTO
   */
  scopeBoundary: ScopeBoundaryDTO
  /**
   *
   * @type {Array<ShiftTypeDTO>}
   * @memberof EscalationChainStepDTO
   */
  shiftTypes?: Array<ShiftTypeDTO>
  /**
   *
   * @type {number}
   * @memberof EscalationChainStepDTO
   */
  stepOrder: number
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof EscalationChainStepDTO
   */
  userRoles?: Array<UserRightsEnum>
}

/**
 *
 * @export
 * @interface EscalationChainUpdateDTO
 */
export interface EscalationChainUpdateDTO {
  /**
   *
   * @type {boolean}
   * @memberof EscalationChainUpdateDTO
   */
  isCustom: boolean
  /**
   *
   * @type {boolean}
   * @memberof EscalationChainUpdateDTO
   */
  repeatAllInstances: boolean
  /**
   *
   * @type {Array<EscalationChainStepCreationDTO>}
   * @memberof EscalationChainUpdateDTO
   */
  steps: Array<EscalationChainStepCreationDTO>
}
/**
 *
 * @export
 * @interface EscalationDuration
 */
export interface EscalationDuration {
  /**
   *
   * @type {number}
   * @memberof EscalationDuration
   */
  hours: number
  /**
   *
   * @type {number}
   * @memberof EscalationDuration
   */
  minutes: number
}
/**
 *
 * @export
 * @interface EscalationExtensionDTO
 */
export interface EscalationExtensionDTO {
  /**
   *
   * @type {string}
   * @memberof EscalationExtensionDTO
   */
  routineDurationExtension?: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationExtensionDTO
   */
  urgentDurationExtension?: string | null
}
/**
 *
 * @export
 * @enum {string}
 */

export const EscalationLevelDTO = {
  CREATED: 'created',
  FIRST_SHIFT: 'first_shift',
  BACKUP_SHIFT: 'backup_shift',
  ALL_IN_HOSPITAL: 'all_in_hospital',
  TCC: 'tcc',
  SENIOR_PHYSICIAN: 'senior_physician',
  EMERGENCY_WARD: 'emergency_ward',
  EMERGENCY_TCC: 'emergency_tcc',
  EMERGENCY_HOSPITAL: 'emergency_hospital',
  EMERGENCY_SENIOR_PHYSICIAN: 'emergency_senior_physician'
} as const

export type EscalationLevelDTO = (typeof EscalationLevelDTO)[keyof typeof EscalationLevelDTO]

/**
 *
 * @export
 * @interface EscalationProgressDTO
 */
export interface EscalationProgressDTO {
  /**
   *
   * @type {number}
   * @memberof EscalationProgressDTO
   */
  currentStepNumber: number
  /**
   *
   * @type {number}
   * @memberof EscalationProgressDTO
   */
  totalSteps: number
}
/**
 *
 * @export
 * @interface EscalationStep
 */
export interface EscalationStep {
  /**
   *
   * @type {EscalationStepChangedBy}
   * @memberof EscalationStep
   */
  changedBy?: EscalationStepChangedBy
  /**
   *
   * @type {string}
   * @memberof EscalationStep
   */
  escalationDuration?: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationStep
   */
  escalationLevel: EscalationStepEscalationLevelEnum
  /**
   *
   * @type {string}
   * @memberof EscalationStep
   */
  id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof EscalationStep
   */
  isFinalStep: boolean
  /**
   *
   * @type {string}
   * @memberof EscalationStep
   */
  lastUpdatedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof EscalationStep
   */
  previousStepId?: string | null
}

export const EscalationStepEscalationLevelEnum = {
  CREATED: 'CREATED',
  FIRST_SHIFT: 'FIRST_SHIFT',
  BACKUP_SHIFT: 'BACKUP_SHIFT',
  ALL_IN_HOSPITAL: 'ALL_IN_HOSPITAL',
  TCC: 'TCC',
  SENIOR_PHYSICIAN: 'SENIOR_PHYSICIAN',
  EMERGENCY_TCC: 'EMERGENCY_TCC',
  EMERGENCY_WARD: 'EMERGENCY_WARD',
  EMERGENCY_HOSPITAL: 'EMERGENCY_HOSPITAL',
  EMERGENCY_SENIOR_PHYSICIAN: 'EMERGENCY_SENIOR_PHYSICIAN'
} as const

export type EscalationStepEscalationLevelEnum =
  (typeof EscalationStepEscalationLevelEnum)[keyof typeof EscalationStepEscalationLevelEnum]

/**
 * @type EscalationStepChangedBy
 * @export
 */
export type EscalationStepChangedBy = UserName | any

/**
 *
 * @export
 * @interface EscalationStepDTO
 */
export interface EscalationStepDTO {
  /**
   *
   * @type {string}
   * @memberof EscalationStepDTO
   */
  escalationDuration?: string | null
  /**
   *
   * @type {EscalationLevelDTO}
   * @memberof EscalationStepDTO
   */
  escalationLevel: EscalationLevelDTO
}

/**
 *
 * @export
 * @interface ExportSummaryRequest
 */
export interface ExportSummaryRequest {
  /**
   *
   * @type {FilteringOptions}
   * @memberof ExportSummaryRequest
   */
  filter: FilteringOptions
}
/**
 *
 * @export
 * @interface FileDTO
 */
export interface FileDTO {
  /**
   *
   * @type {string}
   * @memberof FileDTO
   */
  id: string
  /**
   *
   * @type {FileKindEnum}
   * @memberof FileDTO
   */
  kind: FileKindEnum
  /**
   *
   * @type {string}
   * @memberof FileDTO
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof FileDTO
   */
  uploadedAt: string
  /**
   *
   * @type {UserDTO}
   * @memberof FileDTO
   */
  uploadedBy: UserDTO
}

/**
 *
 * @export
 * @enum {string}
 */

export const FileKindEnum = {
  MEDICAL_REPORT: 'MEDICAL_REPORT',
  CONSULTATION_REPORT: 'CONSULTATION_REPORT',
  DOCUMENTS: 'DOCUMENTS',
  SCHEDULED_CONSULTATION_REPORT: 'SCHEDULED_CONSULTATION_REPORT'
} as const

export type FileKindEnum = (typeof FileKindEnum)[keyof typeof FileKindEnum]

/**
 *
 * @export
 * @interface FileUploadRequestDTO
 */
export interface FileUploadRequestDTO {
  /**
   *
   * @type {FileKindEnum}
   * @memberof FileUploadRequestDTO
   */
  kind: FileKindEnum
  /**
   *
   * @type {string}
   * @memberof FileUploadRequestDTO
   */
  name: string
}

/**
 *
 * @export
 * @interface FilteringOptions
 */
export interface FilteringOptions {
  /**
   *
   * @type {DateRange}
   * @memberof FilteringOptions
   */
  createdAt?: DateRange
  /**
   *
   * @type {Array<string>}
   * @memberof FilteringOptions
   */
  patients?: Array<string>
}
/**
 *
 * @export
 * @interface FullCustomConsultationFieldDTO
 */
export interface FullCustomConsultationFieldDTO {
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  clientId: string
  /**
   *
   * @type {Array<CustomFieldConsultationTypeDTO>}
   * @memberof FullCustomConsultationFieldDTO
   */
  consultationTypes: Array<CustomFieldConsultationTypeDTO>
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  createdAt?: string | null
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  createdBy?: string | null
  /**
   *
   * @type {CustomConsultationFieldDataTypeDTO}
   * @memberof FullCustomConsultationFieldDTO
   */
  dataType: CustomConsultationFieldDataTypeDTO
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  labelEnglish: string
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  labelGerman: string
  /**
   *
   * @type {boolean}
   * @memberof FullCustomConsultationFieldDTO
   */
  mandatory: boolean
  /**
   *
   * @type {number}
   * @memberof FullCustomConsultationFieldDTO
   */
  maxLength?: number | null
  /**
   *
   * @type {number}
   * @memberof FullCustomConsultationFieldDTO
   */
  ordinal: number
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  updatedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof FullCustomConsultationFieldDTO
   */
  updatedBy?: string | null
}

/**
 *
 * @export
 * @enum {string}
 */

export const GenderDTO = {
  MALE: 'male',
  FEMALE: 'female',
  VARIOUS: 'various',
  NOT_DEFINED: 'not_defined'
} as const

export type GenderDTO = (typeof GenderDTO)[keyof typeof GenderDTO]

/**
 *
 * @export
 * @interface GetAdminConsultationRequestDetailsResponse
 */
export interface GetAdminConsultationRequestDetailsResponse {
  /**
   *
   * @type {ConsultationRequestAuditDTO}
   * @memberof GetAdminConsultationRequestDetailsResponse
   */
  consultationRequest: ConsultationRequestAuditDTO
  /**
   *
   * @type {GetAdminConsultationRequestDetailsResponseRoutingExecution}
   * @memberof GetAdminConsultationRequestDetailsResponse
   */
  routingExecution?: GetAdminConsultationRequestDetailsResponseRoutingExecution
}
/**
 * @type GetAdminConsultationRequestDetailsResponseRoutingExecution
 * @export
 */
export type GetAdminConsultationRequestDetailsResponseRoutingExecution =
  | RoutingExecutionAuditDTO
  | any

/**
 *
 * @export
 * @interface GetAssignedHospitalsResponse
 */
export interface GetAssignedHospitalsResponse {
  /**
   *
   * @type {Array<DepartmentDTO>}
   * @memberof GetAssignedHospitalsResponse
   */
  departments?: Array<DepartmentDTO>
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof GetAssignedHospitalsResponse
   */
  hospitals?: Array<HospitalDTO>
  /**
   *
   * @type {Array<WardDTO>}
   * @memberof GetAssignedHospitalsResponse
   */
  wards?: Array<WardDTO>
}
/**
 *
 * @export
 * @interface GetCaseResponse
 */
export interface GetCaseResponse {
  /**
   *
   * @type {CaseUpdateDTODiagnosis}
   * @memberof GetCaseResponse
   */
  admissionDiagnosis?: CaseUpdateDTODiagnosis
  /**
   *
   * @type {CaseDTO}
   * @memberof GetCaseResponse
   */
  case: CaseDTO
  /**
   *
   * @type {Array<GetCaseResponseConsultationsInner>}
   * @memberof GetCaseResponse
   */
  consultations: Array<GetCaseResponseConsultationsInner>
  /**
   *
   * @type {Array<DiagnosisDTO>}
   * @memberof GetCaseResponse
   */
  diagnoses: Array<DiagnosisDTO>
  /**
   *
   * @type {Array<FileDTO>}
   * @memberof GetCaseResponse
   */
  files: Array<FileDTO>
  /**
   *
   * @type {PatientDetailsDTO}
   * @memberof GetCaseResponse
   */
  patientDetails: PatientDetailsDTO
  /**
   *
   * @type {Array<PreExistingConditionDTO>}
   * @memberof GetCaseResponse
   */
  preExistingConditions: Array<PreExistingConditionDTO>
  /**
   *
   * @type {Array<TherapyLimitationDTO>}
   * @memberof GetCaseResponse
   */
  therapyLimitations: Array<TherapyLimitationDTO>
}
/**
 * @type GetCaseResponseConsultationsInner
 * @export
 */
export type GetCaseResponseConsultationsInner =
  | DirectConsultationSummaryDTO
  | ScheduledConsultationSummaryDTO

/**
 *
 * @export
 * @interface GetCasesResponse
 */
export interface GetCasesResponse {
  /**
   *
   * @type {Array<CaseDTO>}
   * @memberof GetCasesResponse
   */
  items: Array<CaseDTO>
  /**
   *
   * @type {number}
   * @memberof GetCasesResponse
   */
  total: number
}
/**
 *
 * @export
 * @interface GetClientsResponse
 */
export interface GetClientsResponse {
  /**
   *
   * @type {Array<ClientWithTotalsDTO>}
   * @memberof GetClientsResponse
   */
  items: Array<ClientWithTotalsDTO>
  /**
   *
   * @type {number}
   * @memberof GetClientsResponse
   */
  total: number
}
/**
 *
 * @export
 * @interface GetConsultationRequestReportResponse
 */
export interface GetConsultationRequestReportResponse {
  /**
   *
   * @type {GetConsultationRequestReportResponseReport}
   * @memberof GetConsultationRequestReportResponse
   */
  report?: GetConsultationRequestReportResponseReport
}
/**
 * @type GetConsultationRequestReportResponseReport
 * @export
 */
export type GetConsultationRequestReportResponseReport = ConsultationRequestReportDTO | any

/**
 *
 * @export
 * @interface GetConsultationRequestShareCodeResponse
 */
export interface GetConsultationRequestShareCodeResponse {
  /**
   *
   * @type {string}
   * @memberof GetConsultationRequestShareCodeResponse
   */
  consultationShareCode: string
}
/**
 *
 * @export
 * @interface GetConsultationRequestsWithCaseResponse
 */
export interface GetConsultationRequestsWithCaseResponse {
  /**
   *
   * @type {Array<ConsultationRequestWithCaseDTO>}
   * @memberof GetConsultationRequestsWithCaseResponse
   */
  consultationRequestsWithCase: Array<ConsultationRequestWithCaseDTO>
}
/**
 *
 * @export
 * @interface GetEscalationChainConfigurationResponse
 */
export interface GetEscalationChainConfigurationResponse {
  /**
   *
   * @type {string}
   * @memberof GetEscalationChainConfigurationResponse
   */
  clientId: string | null
  /**
   *
   * @type {Array<EscalationChainConfigurationDTO>}
   * @memberof GetEscalationChainConfigurationResponse
   */
  configurations: Array<EscalationChainConfigurationDTO>
  /**
   *
   * @type {string}
   * @memberof GetEscalationChainConfigurationResponse
   */
  departmentId: string | null
  /**
   *
   * @type {string}
   * @memberof GetEscalationChainConfigurationResponse
   */
  hospitalId: string | null
  /**
   *
   * @type {string}
   * @memberof GetEscalationChainConfigurationResponse
   */
  wardId: string | null
}
/**
 *
 * @export
 * @interface GetHospitalAdminsResponse
 */
export interface GetHospitalAdminsResponse {
  /**
   *
   * @type {Array<UserDTO>}
   * @memberof GetHospitalAdminsResponse
   */
  hospitalAdmins: Array<UserDTO>
}
/**
 *
 * @export
 * @interface GetHospitalSettingsResponse
 */
export interface GetHospitalSettingsResponse {
  /**
   *
   * @type {boolean}
   * @memberof GetHospitalSettingsResponse
   */
  vitalSignsEnabled: boolean
}
/**
 *
 * @export
 * @interface GetHospitalsResponse
 */
export interface GetHospitalsResponse {
  /**
   *
   * @type {Array<HospitalWithTotalsDTO>}
   * @memberof GetHospitalsResponse
   */
  items: Array<HospitalWithTotalsDTO>
  /**
   *
   * @type {number}
   * @memberof GetHospitalsResponse
   */
  total: number
}
/**
 *
 * @export
 * @interface GetLinkedHospitalsResponse
 */
export interface GetLinkedHospitalsResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetLinkedHospitalsResponse
   */
  items: Array<string>
}
/**
 *
 * @export
 * @interface GetMedicalFieldsResponse
 */
export interface GetMedicalFieldsResponse {
  /**
   *
   * @type {Array<MedicalFieldDTO>}
   * @memberof GetMedicalFieldsResponse
   */
  medicalFields: Array<MedicalFieldDTO>
}
/**
 *
 * @export
 * @interface GetMedicalTitlesResponse
 */
export interface GetMedicalTitlesResponse {
  /**
   *
   * @type {Array<MedicalTitle>}
   * @memberof GetMedicalTitlesResponse
   */
  medicalTitles: Array<MedicalTitle>
}
/**
 *
 * @export
 * @interface GetNotificationsResponseDTO
 */
export interface GetNotificationsResponseDTO {
  /**
   *
   * @type {Array<NotificationDTO>}
   * @memberof GetNotificationsResponseDTO
   */
  notifications: Array<NotificationDTO>
}
/**
 *
 * @export
 * @interface GetPaginatedAdminConsultationsRequestsResponse
 */
export interface GetPaginatedAdminConsultationsRequestsResponse {
  /**
   *
   * @type {Array<ConsultationRequestAuditDTO>}
   * @memberof GetPaginatedAdminConsultationsRequestsResponse
   */
  consultationRequests: Array<ConsultationRequestAuditDTO>
  /**
   *
   * @type {number}
   * @memberof GetPaginatedAdminConsultationsRequestsResponse
   */
  totalConsultationRequests: number
}
/**
 *
 * @export
 * @interface GetPaginatedConsultationsRequestsResponse
 */
export interface GetPaginatedConsultationsRequestsResponse {
  /**
   *
   * @type {Array<ConsultationRequestDTO>}
   * @memberof GetPaginatedConsultationsRequestsResponse
   */
  consultationRequests: Array<ConsultationRequestDTO>
  /**
   *
   * @type {Array<ScheduledConsultationDTO>}
   * @memberof GetPaginatedConsultationsRequestsResponse
   */
  scheduledConsultationRequests: Array<ScheduledConsultationDTO>
  /**
   *
   * @type {number}
   * @memberof GetPaginatedConsultationsRequestsResponse
   */
  totalConsultationRequests: number
  /**
   *
   * @type {number}
   * @memberof GetPaginatedConsultationsRequestsResponse
   */
  totalScheduledConsultationRequests: number
}
/**
 *
 * @export
 * @interface GetPaginatedVitalSignsResponse
 */
export interface GetPaginatedVitalSignsResponse {
  /**
   *
   * @type {Array<VitalSignsWithTypeKeyDTO>}
   * @memberof GetPaginatedVitalSignsResponse
   */
  items: Array<VitalSignsWithTypeKeyDTO>
  /**
   *
   * @type {number}
   * @memberof GetPaginatedVitalSignsResponse
   */
  total: number
}
/**
 *
 * @export
 * @interface GetScheduledConsultationReportResponse
 */
export interface GetScheduledConsultationReportResponse {
  /**
   *
   * @type {Array<ScheduledConsultationCaseReportDTO>}
   * @memberof GetScheduledConsultationReportResponse
   */
  caseReports: Array<ScheduledConsultationCaseReportDTO>
}
/**
 *
 * @export
 * @interface GetUserRightsResponse
 */
export interface GetUserRightsResponse {
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof GetUserRightsResponse
   */
  userRights: Array<UserRightsEnum>
}
/**
 *
 * @export
 * @interface GetUserSettingsResponse
 */
export interface GetUserSettingsResponse {
  /**
   *
   * @type {SystemSettingsDTO}
   * @memberof GetUserSettingsResponse
   */
  systemSettings: SystemSettingsDTO
  /**
   *
   * @type {UserSettingsDTO}
   * @memberof GetUserSettingsResponse
   */
  userSettings: UserSettingsDTO
}
/**
 *
 * @export
 * @interface GetVentilationResponse
 */
export interface GetVentilationResponse {
  /**
   *
   * @type {Array<VentilationWithTypeKey>}
   * @memberof GetVentilationResponse
   */
  items: Array<VentilationWithTypeKey>
  /**
   *
   * @type {number}
   * @memberof GetVentilationResponse
   */
  total: number
}
/**
 *
 * @export
 * @interface GetVitalSignsResponse
 */
export interface GetVitalSignsResponse {
  /**
   *
   * @type {Array<VitalSignsWithTypeKeyDTO>}
   * @memberof GetVitalSignsResponse
   */
  items: Array<VitalSignsWithTypeKeyDTO>
}
/**
 *
 * @export
 * @interface HospitalActiveEscalationSteps
 */
export interface HospitalActiveEscalationSteps {
  /**
   *
   * @type {Array<EscalationStep>}
   * @memberof HospitalActiveEscalationSteps
   */
  emergencyConsultationSteps: Array<EscalationStep>
  /**
   *
   * @type {any}
   * @memberof HospitalActiveEscalationSteps
   */
  routineConsultationSteps: any
  /**
   *
   * @type {any}
   * @memberof HospitalActiveEscalationSteps
   */
  urgentConsultationSteps: any
}
/**
 *
 * @export
 * @interface HospitalAdminsUpdateDTO
 */
export interface HospitalAdminsUpdateDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof HospitalAdminsUpdateDTO
   */
  userNames: Array<string>
}
/**
 *
 * @export
 * @interface HospitalAuditSort
 */
export interface HospitalAuditSort {
  /**
   *
   * @type {string}
   * @memberof HospitalAuditSort
   */
  changedAtSort: HospitalAuditSortChangedAtSortEnum
}

export const HospitalAuditSortChangedAtSortEnum = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type HospitalAuditSortChangedAtSortEnum =
  (typeof HospitalAuditSortChangedAtSortEnum)[keyof typeof HospitalAuditSortChangedAtSortEnum]

/**
 *
 * @export
 * @interface HospitalCreateDTO
 */
export interface HospitalCreateDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalCreateDTO
   */
  alias?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalCreateDTO
   */
  clientId: string
  /**
   *
   * @type {string}
   * @memberof HospitalCreateDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface HospitalDTO
 */
export interface HospitalDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalDTO
   */
  alias?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof HospitalDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface HospitalDetailsDTO
 */
export interface HospitalDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalDetailsDTO
   */
  alias?: string | null
  /**
   *
   * @type {Array<DepartmentDTO>}
   * @memberof HospitalDetailsDTO
   */
  departments: Array<DepartmentDTO>
  /**
   *
   * @type {Array<UserDTO>}
   * @memberof HospitalDetailsDTO
   */
  hospitalAdmins: Array<UserDTO>
  /**
   *
   * @type {string}
   * @memberof HospitalDetailsDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof HospitalDetailsDTO
   */
  isRoutingV2Enabled: boolean
  /**
   *
   * @type {string}
   * @memberof HospitalDetailsDTO
   */
  name: string
  /**
   *
   * @type {HospitalStatusDTO}
   * @memberof HospitalDetailsDTO
   */
  status: HospitalStatusDTO
  /**
   *
   * @type {string}
   * @memberof HospitalDetailsDTO
   */
  updatedAt: string
  /**
   *
   * @type {Array<WardDTO>}
   * @memberof HospitalDetailsDTO
   */
  wards: Array<WardDTO>
}

/**
 *
 * @export
 * @interface HospitalEscalationAudit
 */
export interface HospitalEscalationAudit {
  /**
   *
   * @type {number}
   * @memberof HospitalEscalationAudit
   */
  auditId?: number | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationAudit
   */
  changed?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationAudit
   */
  changedBy?: string | null
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfEscalationDuration}
   * @memberof HospitalEscalationAudit
   */
  currentEscalationDuration?: DirectConsultationSummaryDTOAllOfEscalationDuration
  /**
   *
   * @type {Array<string>}
   * @memberof HospitalEscalationAudit
   */
  currentEscalationSteps?: Array<HospitalEscalationAuditCurrentEscalationStepsEnum>
  /**
   *
   * @type {boolean}
   * @memberof HospitalEscalationAudit
   */
  currentRoutingEnabled?: boolean | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationAudit
   */
  hospitalId?: string | null
  /**
   *
   * @type {DirectConsultationSummaryDTOAllOfEscalationDuration}
   * @memberof HospitalEscalationAudit
   */
  previousEscalationDuration?: DirectConsultationSummaryDTOAllOfEscalationDuration
  /**
   *
   * @type {Array<string>}
   * @memberof HospitalEscalationAudit
   */
  previousEscalationSteps?: Array<HospitalEscalationAuditPreviousEscalationStepsEnum>
  /**
   *
   * @type {boolean}
   * @memberof HospitalEscalationAudit
   */
  previousRoutingEnabled?: boolean | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationAudit
   */
  urgency?: HospitalEscalationAuditUrgencyEnum | null
}

export const HospitalEscalationAuditCurrentEscalationStepsEnum = {
  CREATED: 'CREATED',
  FIRST_SHIFT: 'FIRST_SHIFT',
  BACKUP_SHIFT: 'BACKUP_SHIFT',
  ALL_IN_HOSPITAL: 'ALL_IN_HOSPITAL',
  TCC: 'TCC',
  SENIOR_PHYSICIAN: 'SENIOR_PHYSICIAN',
  EMERGENCY_TCC: 'EMERGENCY_TCC',
  EMERGENCY_WARD: 'EMERGENCY_WARD',
  EMERGENCY_HOSPITAL: 'EMERGENCY_HOSPITAL',
  EMERGENCY_SENIOR_PHYSICIAN: 'EMERGENCY_SENIOR_PHYSICIAN'
} as const

export type HospitalEscalationAuditCurrentEscalationStepsEnum =
  (typeof HospitalEscalationAuditCurrentEscalationStepsEnum)[keyof typeof HospitalEscalationAuditCurrentEscalationStepsEnum]
export const HospitalEscalationAuditPreviousEscalationStepsEnum = {
  CREATED: 'CREATED',
  FIRST_SHIFT: 'FIRST_SHIFT',
  BACKUP_SHIFT: 'BACKUP_SHIFT',
  ALL_IN_HOSPITAL: 'ALL_IN_HOSPITAL',
  TCC: 'TCC',
  SENIOR_PHYSICIAN: 'SENIOR_PHYSICIAN',
  EMERGENCY_TCC: 'EMERGENCY_TCC',
  EMERGENCY_WARD: 'EMERGENCY_WARD',
  EMERGENCY_HOSPITAL: 'EMERGENCY_HOSPITAL',
  EMERGENCY_SENIOR_PHYSICIAN: 'EMERGENCY_SENIOR_PHYSICIAN'
} as const

export type HospitalEscalationAuditPreviousEscalationStepsEnum =
  (typeof HospitalEscalationAuditPreviousEscalationStepsEnum)[keyof typeof HospitalEscalationAuditPreviousEscalationStepsEnum]
export const HospitalEscalationAuditUrgencyEnum = {
  EMERGENCY: 'EMERGENCY',
  URGENT: 'URGENT',
  ROUTINE: 'ROUTINE',
  FOLLOW_UP: 'FOLLOW_UP'
} as const

export type HospitalEscalationAuditUrgencyEnum =
  (typeof HospitalEscalationAuditUrgencyEnum)[keyof typeof HospitalEscalationAuditUrgencyEnum]

/**
 *
 * @export
 * @interface HospitalEscalationSettings
 */
export interface HospitalEscalationSettings {
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  emergencyEscalationDisabledAt?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  emergencyEscalationDuration: string
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  lastChangedBy?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  lastUpdatedAt: string
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  routineEscalationDisabledAt?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  routineEscalationDuration: string
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  routineEscalationExtension?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  urgentEscalationDisabledAt?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  urgentEscalationDuration: string
  /**
   *
   * @type {string}
   * @memberof HospitalEscalationSettings
   */
  urgentEscalationExtension?: string | null
}
/**
 *
 * @export
 * @interface HospitalFilterOptionDTO
 */
export interface HospitalFilterOptionDTO {
  /**
   *
   * @type {HospitalDTO}
   * @memberof HospitalFilterOptionDTO
   */
  hospital: HospitalDTO
  /**
   *
   * @type {number}
   * @memberof HospitalFilterOptionDTO
   */
  patientCount: number
}
/**
 *
 * @export
 * @interface HospitalHubCreationDTO
 */
export interface HospitalHubCreationDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof HospitalHubCreationDTO
   */
  partnerHospitalIds: Array<string>
  /**
   *
   * @type {string}
   * @memberof HospitalHubCreationDTO
   */
  sourceHospitalId: string
}
/**
 *
 * @export
 * @interface HospitalHubDTO
 */
export interface HospitalHubDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalHubDTO
   */
  createdAt: string
  /**
   *
   * @type {UserName}
   * @memberof HospitalHubDTO
   */
  createdBy: UserName
  /**
   *
   * @type {boolean}
   * @memberof HospitalHubDTO
   */
  isActive: boolean
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof HospitalHubDTO
   */
  partnerHospitals: Array<HospitalDTO>
  /**
   *
   * @type {string}
   * @memberof HospitalHubDTO
   */
  sourceHospitalId: string
  /**
   *
   * @type {string}
   * @memberof HospitalHubDTO
   */
  updatedAt: string
  /**
   *
   * @type {UserName}
   * @memberof HospitalHubDTO
   */
  updatedBy: UserName
}
/**
 *
 * @export
 * @interface HospitalSettingsDTO
 */
export interface HospitalSettingsDTO {
  /**
   *
   * @type {boolean}
   * @memberof HospitalSettingsDTO
   */
  vitalSignsEnabled: boolean
}
/**
 *
 * @export
 * @enum {string}
 */

export const HospitalStatusDTO = {
  CREATED: 'created',
  DELETED: 'deleted'
} as const

export type HospitalStatusDTO = (typeof HospitalStatusDTO)[keyof typeof HospitalStatusDTO]

/**
 *
 * @export
 * @interface HospitalStructureDTO
 */
export interface HospitalStructureDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalStructureDTO
   */
  alias?: string | null
  /**
   *
   * @type {Array<DepartmentStructureDTO>}
   * @memberof HospitalStructureDTO
   */
  departments: Array<DepartmentStructureDTO>
  /**
   *
   * @type {string}
   * @memberof HospitalStructureDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof HospitalStructureDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface HospitalUpdateDTO
 */
export interface HospitalUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalUpdateDTO
   */
  alias?: string | null
  /**
   *
   * @type {boolean}
   * @memberof HospitalUpdateDTO
   */
  isDeleted?: boolean | null
  /**
   *
   * @type {string}
   * @memberof HospitalUpdateDTO
   */
  name: string
}
/**
 *
 * @export
 * @interface HospitalWithTotalsDTO
 */
export interface HospitalWithTotalsDTO {
  /**
   *
   * @type {string}
   * @memberof HospitalWithTotalsDTO
   */
  alias?: string | null
  /**
   *
   * @type {string}
   * @memberof HospitalWithTotalsDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof HospitalWithTotalsDTO
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof HospitalWithTotalsDTO
   */
  totalCases: number
  /**
   *
   * @type {number}
   * @memberof HospitalWithTotalsDTO
   */
  totalDepartments: number
  /**
   *
   * @type {number}
   * @memberof HospitalWithTotalsDTO
   */
  totalLinkedHospitals: number
  /**
   *
   * @type {number}
   * @memberof HospitalWithTotalsDTO
   */
  totalUsers: number
  /**
   *
   * @type {number}
   * @memberof HospitalWithTotalsDTO
   */
  totalWards: number
}
/**
 *
 * @export
 * @enum {string}
 */

export const LaboratoryTypeKey = {
  ALAT: 'ALAT',
  ALB: 'ALB',
  AP: 'AP',
  AT3_ACT: 'AT3ACT',
  ASAT: 'ASAT',
  BASO: 'BASO',
  BIDI: 'BIDI',
  BILI: 'BILI',
  BILI_OVER: 'BILI-OVER',
  CRP: 'CRP',
  CA: 'CA',
  CL: 'CL',
  CK: 'CK',
  CK_MB: 'CK-MB',
  CREA: 'CREA',
  HHB: 'HHB',
  EOS: 'EOS',
  ERY: 'Ery',
  FERRITIN: 'FERRITIN',
  GGT: 'GGT',
  GFR: 'GFR',
  GLU: 'GLU',
  HBA1_C: 'HBA1C',
  HCO3_STD: 'HCO3STD',
  HCT: 'HCT',
  HB: 'HB',
  IL6: 'IL6',
  INR: 'INR',
  LACTATE: 'LACTATE',
  LDH: 'LDH',
  LEUK: 'LEUK',
  LIP: 'LIP',
  LYMPH: 'LYMPH',
  MG: 'MG',
  MCH: 'MCH',
  MCHC: 'MCHC',
  MCV: 'MCV',
  MONO: 'MONO',
  NEUT: 'NEUT',
  PTT: 'PTT',
  PH: 'PH',
  K: 'K',
  PCT: 'PCT',
  QUICK: 'QUICK',
  RDW: 'RDW',
  SERUM_LACTAT: 'SERUM_LACTAT',
  NA: 'NA',
  THROM: 'THROM',
  TSH: 'TSH',
  THB: 'THB',
  TP: 'TP',
  TRIGLYCERIDE: 'TRIGLYCERIDE',
  TROPONIN: 'TROPONIN',
  TROPONIN_I: 'TROPONIN_I',
  TROPONIN_T: 'TROPONIN_T',
  HARN: 'HARN',
  HARN_STICK: 'HARN-STICK'
} as const

export type LaboratoryTypeKey = (typeof LaboratoryTypeKey)[keyof typeof LaboratoryTypeKey]

/**
 *
 * @export
 * @interface ListUsersResponse
 */
export interface ListUsersResponse {
  /**
   *
   * @type {Array<UserDetailsDTO>}
   * @memberof ListUsersResponse
   */
  users: Array<UserDetailsDTO>
}
/**
 *
 * @export
 * @interface LoginDTO
 */
export interface LoginDTO {
  /**
   *
   * @type {string}
   * @memberof LoginDTO
   */
  notificationToken?: string | null
}
/**
 *
 * @export
 * @interface LogoutDTO
 */
export interface LogoutDTO {
  /**
   *
   * @type {string}
   * @memberof LogoutDTO
   */
  notificationToken?: string | null
}
/**
 *
 * @export
 * @interface MedicalFieldDTO
 */
export interface MedicalFieldDTO {
  /**
   *
   * @type {string}
   * @memberof MedicalFieldDTO
   */
  id: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const MedicalTitle = {
  PROF: 'Prof.',
  PROF__DR: 'Prof. Dr.',
  DR: 'Dr.',
  DR__MED: 'Dr. med.',
  DR__MED__DENT: 'Dr. med. dent.',
  DIPL__MED: 'Dipl.-Med.',
  PD: 'PD',
  APL__PROF: 'apl. Prof.',
  M_D: 'M.D.',
  PH_D: 'Ph.D.'
} as const

export type MedicalTitle = (typeof MedicalTitle)[keyof typeof MedicalTitle]

/**
 *
 * @export
 * @interface NotificationAuditRequest
 */
export interface NotificationAuditRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationAuditRequest
   */
  appState: NotificationAuditRequestAppStateEnum
  /**
   *
   * @type {string}
   * @memberof NotificationAuditRequest
   */
  deviceToken?: string | null
  /**
   *
   * @type {string}
   * @memberof NotificationAuditRequest
   */
  eventType: NotificationAuditRequestEventTypeEnum
  /**
   *
   * @type {string}
   * @memberof NotificationAuditRequest
   */
  notificationId: string
  /**
   *
   * @type {string}
   * @memberof NotificationAuditRequest
   */
  platform: NotificationAuditRequestPlatformEnum
}

export const NotificationAuditRequestAppStateEnum = {
  FOREGROUND: 'FOREGROUND',
  BACKGROUND: 'BACKGROUND',
  BACKEND: 'BACKEND'
} as const

export type NotificationAuditRequestAppStateEnum =
  (typeof NotificationAuditRequestAppStateEnum)[keyof typeof NotificationAuditRequestAppStateEnum]
export const NotificationAuditRequestEventTypeEnum = {
  SENT: 'SENT',
  SEND_FAILED: 'SEND_FAILED',
  RECEIVED: 'RECEIVED',
  TAPPED: 'TAPPED',
  DISMISSED: 'DISMISSED'
} as const

export type NotificationAuditRequestEventTypeEnum =
  (typeof NotificationAuditRequestEventTypeEnum)[keyof typeof NotificationAuditRequestEventTypeEnum]
export const NotificationAuditRequestPlatformEnum = {
  WEB_BROWSER: 'WEB_BROWSER',
  BACKEND: 'BACKEND'
} as const

export type NotificationAuditRequestPlatformEnum =
  (typeof NotificationAuditRequestPlatformEnum)[keyof typeof NotificationAuditRequestPlatformEnum]

/**
 *
 * @export
 * @interface NotificationDTO
 */
export interface NotificationDTO {
  /**
   *
   * @type {string}
   * @memberof NotificationDTO
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof NotificationDTO
   */
  id: string
  /**
   *
   * @type {NotificationDTOPayload}
   * @memberof NotificationDTO
   */
  payload?: NotificationDTOPayload
  /**
   *
   * @type {NotificationStatusDTO}
   * @memberof NotificationDTO
   */
  status: NotificationStatusDTO
  /**
   *
   * @type {NotificationTypeDTO}
   * @memberof NotificationDTO
   */
  type: NotificationTypeDTO
  /**
   *
   * @type {string}
   * @memberof NotificationDTO
   */
  userName: string
}

/**
 * @type NotificationDTOPayload
 * @export
 */
export type NotificationDTOPayload =
  | ConsultationReportPayloadDTO
  | ScheduledConsultationReportPayloadDTO
  | ScheduledConsultationReportsCompletedPayloadDTO
  | ShiftEndingPayloadDTO

/**
 *
 * @export
 * @interface NotificationPayloadDTO
 */
export interface NotificationPayloadDTO {
  /**
   *
   * @type {string}
   * @memberof NotificationPayloadDTO
   */
  type: string
}
/**
 *
 * @export
 * @interface NotificationSettingsDTO
 */
export interface NotificationSettingsDTO {
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  apiKey: string
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  appId: string
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  authDomain: string
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  messagingSenderId: string
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  projectId: string
  /**
   *
   * @type {string}
   * @memberof NotificationSettingsDTO
   */
  vapidKey: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const NotificationStatusDTO = {
  UNREAD: 'unread',
  READ: 'read'
} as const

export type NotificationStatusDTO =
  (typeof NotificationStatusDTO)[keyof typeof NotificationStatusDTO]

/**
 *
 * @export
 * @enum {string}
 */

export const NotificationTypeDTO = {
  CONSULTATION_REPORT_CREATED: 'consultation_report_created',
  SHIFT_ENDING: 'shift_ending',
  SCHEDULED_CONSULTATION_REPORT_CREATED: 'scheduled_consultation_report_created',
  SCHEDULED_CONSULTATION_REPORTS_COMPLETED: 'scheduled_consultation_reports_completed'
} as const

export type NotificationTypeDTO = (typeof NotificationTypeDTO)[keyof typeof NotificationTypeDTO]

/**
 *
 * @export
 * @interface OrganSupportDTO
 */
export interface OrganSupportDTO {
  /**
   *
   * @type {boolean}
   * @memberof OrganSupportDTO
   */
  dialysis?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof OrganSupportDTO
   */
  ecmo?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof OrganSupportDTO
   */
  impella?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof OrganSupportDTO
   */
  vasopressors?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof OrganSupportDTO
   */
  ventilation?: boolean | null
}
/**
 *
 * @export
 * @enum {string}
 */

export const OutputTypeKey = {
  URINE: 'URINE'
} as const

export type OutputTypeKey = (typeof OutputTypeKey)[keyof typeof OutputTypeKey]

/**
 *
 * @export
 * @interface PagePluginLicenseDTO
 */
export interface PagePluginLicenseDTO {
  /**
   *
   * @type {Array<PluginLicenseDTO>}
   * @memberof PagePluginLicenseDTO
   */
  content?: Array<PluginLicenseDTO>
  /**
   *
   * @type {boolean}
   * @memberof PagePluginLicenseDTO
   */
  empty?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PagePluginLicenseDTO
   */
  first?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PagePluginLicenseDTO
   */
  last?: boolean
  /**
   *
   * @type {number}
   * @memberof PagePluginLicenseDTO
   */
  number?: number
  /**
   *
   * @type {number}
   * @memberof PagePluginLicenseDTO
   */
  numberOfElements?: number
  /**
   *
   * @type {PageableObject}
   * @memberof PagePluginLicenseDTO
   */
  pageable?: PageableObject
  /**
   *
   * @type {number}
   * @memberof PagePluginLicenseDTO
   */
  size?: number
  /**
   *
   * @type {SortObject}
   * @memberof PagePluginLicenseDTO
   */
  sort?: SortObject
  /**
   *
   * @type {number}
   * @memberof PagePluginLicenseDTO
   */
  totalElements?: number
  /**
   *
   * @type {number}
   * @memberof PagePluginLicenseDTO
   */
  totalPages?: number
}
/**
 *
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageNumber?: number
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageSize?: number
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  paged?: boolean
  /**
   *
   * @type {SortObject}
   * @memberof PageableObject
   */
  sort?: SortObject
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  unpaged?: boolean
}
/**
 *
 * @export
 * @interface PaginatedCaseWithPatientV3
 */
export interface PaginatedCaseWithPatientV3 {
  /**
   *
   * @type {Array<CaseWithPatientV3>}
   * @memberof PaginatedCaseWithPatientV3
   */
  items: Array<CaseWithPatientV3>
  /**
   *
   * @type {number}
   * @memberof PaginatedCaseWithPatientV3
   */
  total: number
}
/**
 *
 * @export
 * @interface PaginatedResponseCaseWithVitalSignsDTO
 */
export interface PaginatedResponseCaseWithVitalSignsDTO {
  /**
   *
   * @type {Array<CaseWithVitalSignsDTO>}
   * @memberof PaginatedResponseCaseWithVitalSignsDTO
   */
  items: Array<CaseWithVitalSignsDTO>
  /**
   *
   * @type {number}
   * @memberof PaginatedResponseCaseWithVitalSignsDTO
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof PaginatedResponseCaseWithVitalSignsDTO
   */
  totalResults: number
}
/**
 *
 * @export
 * @interface PaginatedResponseConsultationSummaryDTO
 */
export interface PaginatedResponseConsultationSummaryDTO {
  /**
   *
   * @type {Array<PaginatedResponseConsultationSummaryDTOItemsInner>}
   * @memberof PaginatedResponseConsultationSummaryDTO
   */
  items: Array<PaginatedResponseConsultationSummaryDTOItemsInner>
  /**
   *
   * @type {number}
   * @memberof PaginatedResponseConsultationSummaryDTO
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof PaginatedResponseConsultationSummaryDTO
   */
  totalResults: number
}
/**
 * @type PaginatedResponseConsultationSummaryDTOItemsInner
 * @export
 */
export type PaginatedResponseConsultationSummaryDTOItemsInner =
  | DirectConsultationSummaryDTO
  | ScheduledConsultationSummaryDTO

/**
 *
 * @export
 * @interface PairingStatusByEmailResponse
 */
export interface PairingStatusByEmailResponse {
  /**
   *
   * @type {boolean}
   * @memberof PairingStatusByEmailResponse
   */
  emailPaired: boolean
  /**
   *
   * @type {boolean}
   * @memberof PairingStatusByEmailResponse
   */
  pendingConfirmation: boolean
}
/**
 *
 * @export
 * @interface PatientDTO
 */
export interface PatientDTO {
  /**
   *
   * @type {string}
   * @memberof PatientDTO
   */
  dateOfBirth?: string | null
  /**
   *
   * @type {string}
   * @memberof PatientDTO
   */
  externalId?: string | null
  /**
   *
   * @type {string}
   * @memberof PatientDTO
   */
  firstName?: string | null
  /**
   *
   * @type {GenderDTO}
   * @memberof PatientDTO
   */
  gender: GenderDTO
  /**
   *
   * @type {string}
   * @memberof PatientDTO
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof PatientDTO
   */
  lastName: string
}

/**
 *
 * @export
 * @interface PatientDetailsDTO
 */
export interface PatientDetailsDTO {
  /**
   *
   * @type {string}
   * @memberof PatientDetailsDTO
   */
  externalId: string
}
/**
 *
 * @export
 * @interface PatientReportFileDTO
 */
export interface PatientReportFileDTO {
  /**
   *
   * @type {string}
   * @memberof PatientReportFileDTO
   */
  id: string
  /**
   *
   * @type {FileKindEnum}
   * @memberof PatientReportFileDTO
   */
  kind: FileKindEnum
  /**
   *
   * @type {string}
   * @memberof PatientReportFileDTO
   */
  name: string
  /**
   *
   * @type {PatientReportFileDTOPatient}
   * @memberof PatientReportFileDTO
   */
  patient?: PatientReportFileDTOPatient
  /**
   *
   * @type {string}
   * @memberof PatientReportFileDTO
   */
  uploadedAt: string
  /**
   *
   * @type {UserDetailsDTO}
   * @memberof PatientReportFileDTO
   */
  uploadedBy: UserDetailsDTO
}

/**
 * @type PatientReportFileDTOPatient
 * @export
 */
export type PatientReportFileDTOPatient = PatientDTO | any

/**
 *
 * @export
 * @interface PatientV3
 */
export interface PatientV3 {
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  created: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  datasource_id: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  date_of_birth: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  external_id: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  first_name: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  gender: PatientV3GenderEnum
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof PatientV3
   */
  is_deleted: boolean
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  last_name: string
  /**
   *
   * @type {string}
   * @memberof PatientV3
   */
  updated: string
}

export const PatientV3GenderEnum = {
  MALE: 'male',
  FEMALE: 'female',
  VARIOUS: 'various',
  NOT_DEFINED: 'not_defined'
} as const

export type PatientV3GenderEnum = (typeof PatientV3GenderEnum)[keyof typeof PatientV3GenderEnum]

/**
 *
 * @export
 * @interface PatientWithOptionalCaseResponse
 */
export interface PatientWithOptionalCaseResponse {
  /**
   *
   * @type {string}
   * @memberof PatientWithOptionalCaseResponse
   */
  caseId?: string | null
  /**
   *
   * @type {PatientReportFileDTOPatient}
   * @memberof PatientWithOptionalCaseResponse
   */
  patient?: PatientReportFileDTOPatient
  /**
   *
   * @type {string}
   * @memberof PatientWithOptionalCaseResponse
   */
  wardId?: string | null
}
/**
 *
 * @export
 * @interface PluginAcceptanceRequest
 */
export interface PluginAcceptanceRequest {
  /**
   *
   * @type {string}
   * @memberof PluginAcceptanceRequest
   */
  scope: string
  /**
   *
   * @type {string}
   * @memberof PluginAcceptanceRequest
   */
  version: string
}
/**
 *
 * @export
 * @interface PluginContraindicationAcceptanceDto
 */
export interface PluginContraindicationAcceptanceDto {
  /**
   *
   * @type {string}
   * @memberof PluginContraindicationAcceptanceDto
   */
  acceptedAt: string
  /**
   *
   * @type {PluginKey}
   * @memberof PluginContraindicationAcceptanceDto
   */
  pluginKey: PluginKey
  /**
   *
   * @type {string}
   * @memberof PluginContraindicationAcceptanceDto
   */
  scope: string
  /**
   *
   * @type {string}
   * @memberof PluginContraindicationAcceptanceDto
   */
  version: string
}

/**
 *
 * @export
 * @enum {string}
 */

export const PluginKey = {
  AKI: 'AKI',
  CONNECT: 'CONNECT',
  EDS: 'EDS'
} as const

export type PluginKey = (typeof PluginKey)[keyof typeof PluginKey]

/**
 *
 * @export
 * @interface PluginLicenseDTO
 */
export interface PluginLicenseDTO {
  /**
   *
   * @type {string}
   * @memberof PluginLicenseDTO
   */
  activeFrom: string
  /**
   *
   * @type {string}
   * @memberof PluginLicenseDTO
   */
  activeUntil?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginLicenseDTO
   */
  clientId: string
  /**
   *
   * @type {boolean}
   * @memberof PluginLicenseDTO
   */
  isActive: boolean
  /**
   *
   * @type {PluginKey}
   * @memberof PluginLicenseDTO
   */
  pluginKey: PluginKey
}

/**
 *
 * @export
 * @interface PluginUdiDto
 */
export interface PluginUdiDto {
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  address?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  caution?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  ceMark?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  countryOfManufacture?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  dateOfManufacture?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  instructionsForUse?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  labelIdentification?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  manufacturer?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  productName?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  type?: string | null
  /**
   *
   * @type {string}
   * @memberof PluginUdiDto
   */
  udi?: string | null
}
/**
 *
 * @export
 * @interface PreExistingConditionDTO
 */
export interface PreExistingConditionDTO {
  /**
   *
   * @type {string}
   * @memberof PreExistingConditionDTO
   */
  id?: string | null
  /**
   *
   * @type {string}
   * @memberof PreExistingConditionDTO
   */
  preExistingCondition: string
}
/**
 *
 * @export
 * @interface PredictionInputsDTO
 */
export interface PredictionInputsDTO {
  /**
   *
   * @type {AkiDemographyDTO}
   * @memberof PredictionInputsDTO
   */
  demography: AkiDemographyDTO
  /**
   *
   * @type {AkiLaboratoryDTO}
   * @memberof PredictionInputsDTO
   */
  laboratory: AkiLaboratoryDTO
  /**
   *
   * @type {AkiVitalSignsDTO}
   * @memberof PredictionInputsDTO
   */
  vitalSigns: AkiVitalSignsDTO
}
/**
 *
 * @export
 * @interface PredictionResultDTO
 */
export interface PredictionResultDTO {
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  errorCode?: PredictionResultDTOErrorCodeEnum | null
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  errorMessage?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PredictionResultDTO
   */
  isSuccessful: boolean
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  probability?: PredictionResultDTOProbabilityEnum | null
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  probabilityColorCode?: PredictionResultDTOProbabilityColorCodeEnum | null
  /**
   *
   * @type {string}
   * @memberof PredictionResultDTO
   */
  probabilityTimestamp?: string | null
}

export const PredictionResultDTOErrorCodeEnum = {
  EXTERNAL_ENGINE_ERROR: 'EXTERNAL_ENGINE_ERROR',
  MISSING_PARAMS: 'MISSING_PARAMS',
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
  STALE_DATA: 'STALE_DATA',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  VALUES_OUT_OF_RANGE: 'VALUES_OUT_OF_RANGE',
  WARD_EXCLUDED: 'WARD_EXCLUDED',
  MISSING_DATA: 'MISSING_DATA',
  SCHEMA_INCORRECT: 'SCHEMA_INCORRECT',
  PLUGIN_DISABLED: 'PLUGIN_DISABLED'
} as const

export type PredictionResultDTOErrorCodeEnum =
  (typeof PredictionResultDTOErrorCodeEnum)[keyof typeof PredictionResultDTOErrorCodeEnum]
export const PredictionResultDTOProbabilityEnum = {
  MEDIUM_HIGH: 'MEDIUM_HIGH',
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH'
} as const

export type PredictionResultDTOProbabilityEnum =
  (typeof PredictionResultDTOProbabilityEnum)[keyof typeof PredictionResultDTOProbabilityEnum]
export const PredictionResultDTOProbabilityColorCodeEnum = {
  FF9900: '#FF9900',
  E71010: '#E71010'
} as const

export type PredictionResultDTOProbabilityColorCodeEnum =
  (typeof PredictionResultDTOProbabilityColorCodeEnum)[keyof typeof PredictionResultDTOProbabilityColorCodeEnum]

/**
 *
 * @export
 * @interface ProblemDetail
 */
export interface ProblemDetail {
  /**
   *
   * @type {string}
   * @memberof ProblemDetail
   */
  detail?: string | null
  /**
   *
   * @type {string}
   * @memberof ProblemDetail
   */
  instance?: string | null
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProblemDetail
   */
  properties?: { [key: string]: any }
  /**
   *
   * @type {number}
   * @memberof ProblemDetail
   */
  status?: number
  /**
   *
   * @type {string}
   * @memberof ProblemDetail
   */
  title?: string | null
  /**
   *
   * @type {string}
   * @memberof ProblemDetail
   */
  type?: string
}
/**
 *
 * @export
 * @interface RadiologyImageMetadataDTO
 */
export interface RadiologyImageMetadataDTO {
  /**
   *
   * @type {string}
   * @memberof RadiologyImageMetadataDTO
   */
  examinationDate?: string | null
  /**
   *
   * @type {string}
   * @memberof RadiologyImageMetadataDTO
   */
  imageUrl: string
  /**
   *
   * @type {EasyRadiologyImagingTypeDTO}
   * @memberof RadiologyImageMetadataDTO
   */
  imagingType: EasyRadiologyImagingTypeDTO
  /**
   *
   * @type {string}
   * @memberof RadiologyImageMetadataDTO
   */
  uploadDate: string
}

/**
 *
 * @export
 * @interface RadiologyImageMetadataResponse
 */
export interface RadiologyImageMetadataResponse {
  /**
   *
   * @type {Array<RadiologyImageMetadataDTO>}
   * @memberof RadiologyImageMetadataResponse
   */
  items: Array<RadiologyImageMetadataDTO>
}
/**
 *
 * @export
 * @interface RangeFilterDTO
 */
export interface RangeFilterDTO {
  /**
   *
   * @type {number}
   * @memberof RangeFilterDTO
   */
  max: number
  /**
   *
   * @type {number}
   * @memberof RangeFilterDTO
   */
  min: number
}
/**
 *
 * @export
 * @interface RoutingAuditFilterOptionsResponse
 */
export interface RoutingAuditFilterOptionsResponse {
  /**
   *
   * @type {Array<UserDTO>}
   * @memberof RoutingAuditFilterOptionsResponse
   */
  creators: Array<UserDTO>
  /**
   *
   * @type {Array<MedicalFieldDTO>}
   * @memberof RoutingAuditFilterOptionsResponse
   */
  medicalFields: Array<MedicalFieldDTO>
  /**
   *
   * @type {Array<PatientDTO>}
   * @memberof RoutingAuditFilterOptionsResponse
   */
  patients: Array<PatientDTO>
}
/**
 *
 * @export
 * @interface RoutingCandidateAuditDTO
 */
export interface RoutingCandidateAuditDTO {
  /**
   *
   * @type {string}
   * @memberof RoutingCandidateAuditDTO
   */
  candidateStatus: RoutingCandidateAuditDTOCandidateStatusEnum
  /**
   *
   * @type {string}
   * @memberof RoutingCandidateAuditDTO
   */
  updatedAt: string
  /**
   *
   * @type {UserDTO}
   * @memberof RoutingCandidateAuditDTO
   */
  user: UserDTO
}

export const RoutingCandidateAuditDTOCandidateStatusEnum = {
  ELIGIBLE: 'eligible',
  FOUND: 'found',
  NOTIFIED: 'notified',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  TIMEOUT: 'timeout',
  FAILED: 'failed'
} as const

export type RoutingCandidateAuditDTOCandidateStatusEnum =
  (typeof RoutingCandidateAuditDTOCandidateStatusEnum)[keyof typeof RoutingCandidateAuditDTOCandidateStatusEnum]

/**
 *
 * @export
 * @interface RoutingCycleAuditDTO
 */
export interface RoutingCycleAuditDTO {
  /**
   *
   * @type {number}
   * @memberof RoutingCycleAuditDTO
   */
  cycleNumber: number
  /**
   *
   * @type {Array<RoutingStepAuditDTO>}
   * @memberof RoutingCycleAuditDTO
   */
  steps: Array<RoutingStepAuditDTO>
}
/**
 *
 * @export
 * @interface RoutingExecutionAuditDTO
 */
export interface RoutingExecutionAuditDTO {
  /**
   *
   * @type {string}
   * @memberof RoutingExecutionAuditDTO
   */
  completedAt?: string | null
  /**
   *
   * @type {Array<RoutingCycleAuditDTO>}
   * @memberof RoutingExecutionAuditDTO
   */
  cycles: Array<RoutingCycleAuditDTO>
  /**
   *
   * @type {string}
   * @memberof RoutingExecutionAuditDTO
   */
  errorMessage?: string | null
  /**
   *
   * @type {string}
   * @memberof RoutingExecutionAuditDTO
   */
  executionId: string
  /**
   *
   * @type {string}
   * @memberof RoutingExecutionAuditDTO
   */
  executionStatus: RoutingExecutionAuditDTOExecutionStatusEnum
  /**
   *
   * @type {string}
   * @memberof RoutingExecutionAuditDTO
   */
  startedAt: string
}

export const RoutingExecutionAuditDTOExecutionStatusEnum = {
  SUCCESS: 'success',
  FAILED: 'failed',
  IN_PROGRESS: 'inProgress',
  SKIPPED: 'skipped',
  TIMEOUT: 'timeout',
  UNKNOWN: 'unknown'
} as const

export type RoutingExecutionAuditDTOExecutionStatusEnum =
  (typeof RoutingExecutionAuditDTOExecutionStatusEnum)[keyof typeof RoutingExecutionAuditDTOExecutionStatusEnum]

/**
 *
 * @export
 * @interface RoutingStepAuditDTO
 */
export interface RoutingStepAuditDTO {
  /**
   *
   * @type {string}
   * @memberof RoutingStepAuditDTO
   */
  assignmentResult: RoutingStepAuditDTOAssignmentResultEnum | null
  /**
   *
   * @type {string}
   * @memberof RoutingStepAuditDTO
   */
  completedAt: string | null
  /**
   *
   * @type {EscalationChainStepAuditDTO}
   * @memberof RoutingStepAuditDTO
   */
  configuration: EscalationChainStepAuditDTO
  /**
   *
   * @type {Array<RoutingCandidateAuditDTO>}
   * @memberof RoutingStepAuditDTO
   */
  contactedUsers: Array<RoutingCandidateAuditDTO>
  /**
   *
   * @type {Array<RoutingCandidateAuditDTO>}
   * @memberof RoutingStepAuditDTO
   */
  eligibleUsers: Array<RoutingCandidateAuditDTO>
  /**
   *
   * @type {string}
   * @memberof RoutingStepAuditDTO
   */
  errorMessage?: string | null
  /**
   *
   * @type {string}
   * @memberof RoutingStepAuditDTO
   */
  executionStatus: RoutingStepAuditDTOExecutionStatusEnum | null
  /**
   *
   * @type {string}
   * @memberof RoutingStepAuditDTO
   */
  startedAt: string | null
  /**
   *
   * @type {number}
   * @memberof RoutingStepAuditDTO
   */
  stepOrder: number
}

export const RoutingStepAuditDTOAssignmentResultEnum = {
  ASSIGNED: 'assigned',
  POOLED: 'pooled',
  NO_USERS: 'noUsers'
} as const

export type RoutingStepAuditDTOAssignmentResultEnum =
  (typeof RoutingStepAuditDTOAssignmentResultEnum)[keyof typeof RoutingStepAuditDTOAssignmentResultEnum]
export const RoutingStepAuditDTOExecutionStatusEnum = {
  SUCCESS: 'success',
  FAILED: 'failed',
  IN_PROGRESS: 'inProgress',
  SKIPPED: 'skipped',
  TIMEOUT: 'timeout',
  UNKNOWN: 'unknown'
} as const

export type RoutingStepAuditDTOExecutionStatusEnum =
  (typeof RoutingStepAuditDTOExecutionStatusEnum)[keyof typeof RoutingStepAuditDTOExecutionStatusEnum]

/**
 *
 * @export
 * @enum {string}
 */

export const SampleLocationDTO = {
  ARTERIAL: 'arterial',
  VENOUS: 'venous',
  CAPILLARY: 'capillary'
} as const

export type SampleLocationDTO = (typeof SampleLocationDTO)[keyof typeof SampleLocationDTO]

/**
 *
 * @export
 * @interface ScheduledCallAccessDTO
 */
export interface ScheduledCallAccessDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledCallAccessDTO
   */
  accessToken: string
  /**
   *
   * @type {number}
   * @memberof ScheduledCallAccessDTO
   */
  roomId: number
  /**
   *
   * @type {string}
   * @memberof ScheduledCallAccessDTO
   */
  scheduledConsultationRequestId: string
}
/**
 *
 * @export
 * @interface ScheduledConsultationCaseReportDTO
 */
export interface ScheduledConsultationCaseReportDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCaseReportDTO
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCaseReportDTO
   */
  downloadUrl?: string | null
  /**
   *
   * @type {Array<ScheduledConsultationReportDTO>}
   * @memberof ScheduledConsultationCaseReportDTO
   */
  reports: Array<ScheduledConsultationReportDTO>
}
/**
 *
 * @export
 * @interface ScheduledConsultationCreationDTO
 */
export interface ScheduledConsultationCreationDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ScheduledConsultationCreationDTO
   */
  caseIds: Array<string>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  conferenceDescription?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  conferenceTopic?: string | null
  /**
   *
   * @type {Array<CustomConsultationFieldDataCreationDTO>}
   * @memberof ScheduledConsultationCreationDTO
   */
  customFields: Array<CustomConsultationFieldDataCreationDTO>
  /**
   *
   * @type {Array<UpdateScheduledConsultationParticipantDTO>}
   * @memberof ScheduledConsultationCreationDTO
   */
  participants: Array<UpdateScheduledConsultationParticipantDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  patientPresentationComment?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  patientPresentationDiagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  patientPresentationMedicalHistory?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationCreationDTO
   */
  requesterShouldWriteReport?: boolean | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  scheduledEndTime: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationCreationDTO
   */
  scheduledStartTime: string
  /**
   *
   * @type {ScheduledConsultationTypeDTO}
   * @memberof ScheduledConsultationCreationDTO
   */
  type: ScheduledConsultationTypeDTO
}

/**
 *
 * @export
 * @interface ScheduledConsultationDTO
 */
export interface ScheduledConsultationDTO {
  /**
   *
   * @type {Array<CaseDTO>}
   * @memberof ScheduledConsultationDTO
   */
  cases: Array<CaseDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  conferenceDescription?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  conferenceTopic?: string | null
  /**
   *
   * @type {Array<CustomConsultationFieldDTO>}
   * @memberof ScheduledConsultationDTO
   */
  customFields: Array<CustomConsultationFieldDTO>
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationDTO
   */
  hasActiveCall: boolean
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationDTO
   */
  isUserInCall: boolean
  /**
   *
   * @type {Array<ScheduledConsultationUserDetailsDTO>}
   * @memberof ScheduledConsultationDTO
   */
  participants: Array<ScheduledConsultationUserDetailsDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  patientPresentationComment?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  patientPresentationDiagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  patientPresentationMedicalHistory?: string | null
  /**
   *
   * @type {ConsultationRequestWithCaseDTORelationToUser}
   * @memberof ScheduledConsultationDTO
   */
  relationToUser?: ConsultationRequestWithCaseDTORelationToUser
  /**
   *
   * @type {ScheduledConsultationUserDetailsDTO}
   * @memberof ScheduledConsultationDTO
   */
  requestedBy: ScheduledConsultationUserDetailsDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  scheduledEndTime: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationDTO
   */
  scheduledStartTime: string
  /**
   *
   * @type {ScheduledConsultationStatusDTO}
   * @memberof ScheduledConsultationDTO
   */
  status: ScheduledConsultationStatusDTO
  /**
   *
   * @type {ScheduledConsultationTypeDTO}
   * @memberof ScheduledConsultationDTO
   */
  type: ScheduledConsultationTypeDTO
}

/**
 *
 * @export
 * @enum {string}
 */

export const ScheduledConsultationParticipantStatusDTO = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  NOT_PARTICIPATED: 'not_participated',
  DELETED: 'deleted'
} as const

export type ScheduledConsultationParticipantStatusDTO =
  (typeof ScheduledConsultationParticipantStatusDTO)[keyof typeof ScheduledConsultationParticipantStatusDTO]

/**
 *
 * @export
 * @interface ScheduledConsultationReportDTO
 */
export interface ScheduledConsultationReportDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  createdBy: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  finalizedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  medicalHistory: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  recommendation: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportDTO
   */
  updatedAt: string
}
/**
 *
 * @export
 * @interface ScheduledConsultationReportPayloadDTO
 */
export interface ScheduledConsultationReportPayloadDTO extends NotificationPayloadDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  scheduledConsultationRequestId: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  caseId: string
  /**
   *
   * @type {UserDTO}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  reportCreatedBy: UserDTO
  /**
   *
   * @type {ScheduledConsultationTypeDTO}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  consultationType: ScheduledConsultationTypeDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  scheduledStartTime: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  conferenceTopic?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  hospitalName: string
  /**
   *
   * @type {Array<string>}
   * @memberof ScheduledConsultationReportPayloadDTO
   */
  medicalFields?: Array<string>
}

/**
 *
 * @export
 * @interface ScheduledConsultationReportsCompletedPayloadDTO
 */
export interface ScheduledConsultationReportsCompletedPayloadDTO extends NotificationPayloadDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportsCompletedPayloadDTO
   */
  scheduledConsultationRequestId: string
  /**
   *
   * @type {ScheduledConsultationTypeDTO}
   * @memberof ScheduledConsultationReportsCompletedPayloadDTO
   */
  consultationType: ScheduledConsultationTypeDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportsCompletedPayloadDTO
   */
  scheduledStartTime: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationReportsCompletedPayloadDTO
   */
  conferenceTopic?: string | null
}

/**
 *
 * @export
 * @interface ScheduledConsultationRequestReportDTO
 */
export interface ScheduledConsultationRequestReportDTO {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationRequestReportDTO
   */
  medicalHistory: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationRequestReportDTO
   */
  recommendation: string
}
/**
 *
 * @export
 * @interface ScheduledConsultationRequestShareCodeResponse
 */
export interface ScheduledConsultationRequestShareCodeResponse {
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationRequestShareCodeResponse
   */
  consultationShareCode: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const ScheduledConsultationStatusDTO = {
  CREATED: 'created',
  IN_PROGRESS: 'in_progress',
  REPORT_PENDING: 'report_pending',
  COMPLETED: 'completed',
  DELETED: 'deleted',
  REPORTS_COMPLETED: 'reports_completed'
} as const

export type ScheduledConsultationStatusDTO =
  (typeof ScheduledConsultationStatusDTO)[keyof typeof ScheduledConsultationStatusDTO]

/**
 * Scheduled consultation details
 * @export
 * @interface ScheduledConsultationSummaryDTO
 */
export interface ScheduledConsultationSummaryDTO extends ConsultationSummaryDTO {
  /**
   *
   * @type {ScheduledConsultationSummaryDTOAllOfDeletedBy}
   * @memberof ScheduledConsultationSummaryDTO
   */
  deletedBy?: ScheduledConsultationSummaryDTOAllOfDeletedBy
  /**
   *
   * @type {Array<CaseDTO>}
   * @memberof ScheduledConsultationSummaryDTO
   */
  cases: Array<CaseDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  conferenceDescription?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  conferenceTopic?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationSummaryDTO
   */
  userInCall: boolean
  /**
   *
   * @type {Array<ScheduledConsultationUserDetailsDTO>}
   * @memberof ScheduledConsultationSummaryDTO
   */
  participants: Array<ScheduledConsultationUserDetailsDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  patientPresentationComment?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  patientPresentationDiagnosis?: string | null
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  patientPresentationMedicalHistory?: string | null
  /**
   *
   * @type {ScheduledConsultationUserDetailsDTO}
   * @memberof ScheduledConsultationSummaryDTO
   */
  requestedBy: ScheduledConsultationUserDetailsDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  requesterJoinedCallAt?: string | null
  /**
   *
   * @type {ScheduledConsultationSummaryDTOAllOfRequesterStatus}
   * @memberof ScheduledConsultationSummaryDTO
   */
  requesterStatus?: ScheduledConsultationSummaryDTOAllOfRequesterStatus
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  scheduledEndTime: string
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  scheduledStartTime: string
  /**
   *
   * @type {ScheduledConsultationTypeDTO}
   * @memberof ScheduledConsultationSummaryDTO
   */
  scheduledType: ScheduledConsultationTypeDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationSummaryDTO
   */
  updatedAt?: string | null
}

/**
 * @type ScheduledConsultationSummaryDTOAllOfDeletedBy
 * @export
 */
export type ScheduledConsultationSummaryDTOAllOfDeletedBy = UserDetailsDTO | any

/**
 * @type ScheduledConsultationSummaryDTOAllOfRequesterStatus
 * @export
 */
export type ScheduledConsultationSummaryDTOAllOfRequesterStatus =
  | ScheduledConsultationParticipantStatusDTO
  | any

/**
 *
 * @export
 * @enum {string}
 */

export const ScheduledConsultationTypeDTO = {
  PATIENT_VISIT: 'patient_visit',
  CONFERENCE: 'conference',
  PATIENT_PRESENTATION: 'patient_presentation'
} as const

export type ScheduledConsultationTypeDTO =
  (typeof ScheduledConsultationTypeDTO)[keyof typeof ScheduledConsultationTypeDTO]

/**
 *
 * @export
 * @interface ScheduledConsultationUserDetailsDTO
 */
export interface ScheduledConsultationUserDetailsDTO {
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  archived?: boolean | null
  /**
   *
   * @type {Array<DepartmentDTO>}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  departments: Array<DepartmentDTO>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  email: string
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  enabled?: boolean | null
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  hospitals: Array<HospitalDTO>
  /**
   *
   * @type {UserName}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  invitedBy: UserName
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  isUserInCall: boolean
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  joinedCallAt?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  medicalFields?: Array<string>
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  mobile?: string | null
  /**
   *
   * @type {ScheduledConsultationParticipantStatusDTO}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  participationStatus: ScheduledConsultationParticipantStatusDTO
  /**
   *
   * @type {string}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  phone?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  reportFinalized?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  shouldWriteReport?: boolean | null
  /**
   *
   * @type {UserDTO}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  user: UserDTO
  /**
   *
   * @type {Array<string>}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  userRoles: Array<string>
  /**
   *
   * @type {Array<WardDTO>}
   * @memberof ScheduledConsultationUserDetailsDTO
   */
  wards: Array<WardDTO>
}

/**
 *
 * @export
 * @enum {string}
 */

export const ScopeBoundaryDTO = {
  WARD: 'ward',
  DEPARTMENT: 'department',
  HOSPITAL: 'hospital',
  HOSPITAL_HUB: 'hospitalHub',
  CLIENT: 'client'
} as const

export type ScopeBoundaryDTO = (typeof ScopeBoundaryDTO)[keyof typeof ScopeBoundaryDTO]

/**
 *
 * @export
 * @enum {string}
 */

export const SearchUsersFilterDTO = {
  HANDOVER: 'handover'
} as const

export type SearchUsersFilterDTO = (typeof SearchUsersFilterDTO)[keyof typeof SearchUsersFilterDTO]

/**
 *
 * @export
 * @interface SearchUsersResponse
 */
export interface SearchUsersResponse {
  /**
   *
   * @type {Array<UserDTO>}
   * @memberof SearchUsersResponse
   */
  users: Array<UserDTO>
}
/**
 *
 * @export
 * @interface ShiftDTO
 */
export interface ShiftDTO {
  /**
   *
   * @type {string}
   * @memberof ShiftDTO
   */
  end?: string | null
  /**
   *
   * @type {ShiftTypeDTO}
   * @memberof ShiftDTO
   */
  type: ShiftTypeDTO
  /**
   *
   * @type {string}
   * @memberof ShiftDTO
   */
  userName: string
}

/**
 *
 * @export
 * @interface ShiftEndingPayloadDTO
 */
export interface ShiftEndingPayloadDTO extends NotificationPayloadDTO {
  /**
   *
   * @type {UserName}
   * @memberof ShiftEndingPayloadDTO
   */
  userName: UserName
  /**
   *
   * @type {ShiftTypeDTO}
   * @memberof ShiftEndingPayloadDTO
   */
  shiftType: ShiftTypeDTO
  /**
   *
   * @type {string}
   * @memberof ShiftEndingPayloadDTO
   */
  shiftEnd: string
}

/**
 *
 * @export
 * @interface ShiftExtendDTO
 */
export interface ShiftExtendDTO {
  /**
   *
   * @type {string}
   * @memberof ShiftExtendDTO
   */
  endTime: string
}
/**
 *
 * @export
 * @interface ShiftHandoverDTO
 */
export interface ShiftHandoverDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ShiftHandoverDTO
   */
  deleteConsultationRequests?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof ShiftHandoverDTO
   */
  handoverConsultationRequests?: Array<string>
  /**
   *
   * @type {string}
   * @memberof ShiftHandoverDTO
   */
  to?: string | null
}
/**
 *
 * @export
 * @enum {string}
 */

export const ShiftTypeDTO = {
  FIRST_SHIFT: 'firstShift',
  BACKUP_SHIFT: 'backupShift',
  NO_SHIFT: 'noShift',
  GOD_MODE: 'godMode',
  CHIEF_PHYSICIAN: 'chiefPhysician'
} as const

export type ShiftTypeDTO = (typeof ShiftTypeDTO)[keyof typeof ShiftTypeDTO]

/**
 *
 * @export
 * @interface SortObject
 */
export interface SortObject {
  /**
   *
   * @type {boolean}
   * @memberof SortObject
   */
  empty?: boolean
  /**
   *
   * @type {boolean}
   * @memberof SortObject
   */
  sorted?: boolean
  /**
   *
   * @type {boolean}
   * @memberof SortObject
   */
  unsorted?: boolean
}
/**
 *
 * @export
 * @interface SseEmitter
 */
export interface SseEmitter {
  /**
   *
   * @type {number}
   * @memberof SseEmitter
   */
  timeout?: number | null
}
/**
 *
 * @export
 * @interface StringArrayValueDTO
 */
export interface StringArrayValueDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof StringArrayValueDTO
   */
  value?: Array<string>
}
/**
 *
 * @export
 * @interface StringValueDTO
 */
export interface StringValueDTO {
  /**
   *
   * @type {string}
   * @memberof StringValueDTO
   */
  value?: string | null
}
/**
 *
 * @export
 * @interface SystemSettingsDTO
 */
export interface SystemSettingsDTO {
  /**
   *
   * @type {NotificationSettingsDTO}
   * @memberof SystemSettingsDTO
   */
  notification: NotificationSettingsDTO
  /**
   *
   * @type {boolean}
   * @memberof SystemSettingsDTO
   */
  notificationAppEnabled: boolean
}
/**
 *
 * @export
 * @interface TherapyLimitationDTO
 */
export interface TherapyLimitationDTO {
  /**
   *
   * @type {string}
   * @memberof TherapyLimitationDTO
   */
  limitation: string
  /**
   *
   * @type {string}
   * @memberof TherapyLimitationDTO
   */
  measurementDate: string
}
/**
 *
 * @export
 * @interface TrendResultDTO
 */
export interface TrendResultDTO {
  /**
   *
   * @type {string}
   * @memberof TrendResultDTO
   */
  caseId: string
  /**
   *
   * @type {string}
   * @memberof TrendResultDTO
   */
  errorCode?: TrendResultDTOErrorCodeEnum | null
  /**
   *
   * @type {string}
   * @memberof TrendResultDTO
   */
  errorMessage?: string | null
  /**
   *
   * @type {boolean}
   * @memberof TrendResultDTO
   */
  isSuccessful: boolean
  /**
   *
   * @type {string}
   * @memberof TrendResultDTO
   */
  trend?: TrendResultDTOTrendEnum | null
  /**
   *
   * @type {string}
   * @memberof TrendResultDTO
   */
  trendTimestamp?: string | null
}

export const TrendResultDTOErrorCodeEnum = {
  EXTERNAL_ENGINE_ERROR: 'EXTERNAL_ENGINE_ERROR',
  MISSING_PARAMS: 'MISSING_PARAMS',
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
  STALE_DATA: 'STALE_DATA',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  VALUES_OUT_OF_RANGE: 'VALUES_OUT_OF_RANGE',
  WARD_EXCLUDED: 'WARD_EXCLUDED',
  MISSING_DATA: 'MISSING_DATA',
  SCHEMA_INCORRECT: 'SCHEMA_INCORRECT',
  PLUGIN_DISABLED: 'PLUGIN_DISABLED'
} as const

export type TrendResultDTOErrorCodeEnum =
  (typeof TrendResultDTOErrorCodeEnum)[keyof typeof TrendResultDTOErrorCodeEnum]
export const TrendResultDTOTrendEnum = {
  UP: 'UP',
  DOWN: 'DOWN',
  STEADY: 'STEADY'
} as const

export type TrendResultDTOTrendEnum =
  (typeof TrendResultDTOTrendEnum)[keyof typeof TrendResultDTOTrendEnum]

/**
 *
 * @export
 * @interface UUIDArrayValueDTO
 */
export interface UUIDArrayValueDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof UUIDArrayValueDTO
   */
  value?: Array<string>
}
/**
 *
 * @export
 * @interface UUIDValueDTO
 */
export interface UUIDValueDTO {
  /**
   *
   * @type {string}
   * @memberof UUIDValueDTO
   */
  value?: string | null
}
/**
 *
 * @export
 * @interface UpdateDepartmentsWithWardsRequest
 */
export interface UpdateDepartmentsWithWardsRequest {
  /**
   *
   * @type {Array<DepartmentWithWardsUpdateDTO>}
   * @memberof UpdateDepartmentsWithWardsRequest
   */
  departments: Array<DepartmentWithWardsUpdateDTO>
}
/**
 *
 * @export
 * @interface UpdateScheduledConsultationCasesDTO
 */
export interface UpdateScheduledConsultationCasesDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateScheduledConsultationCasesDTO
   */
  caseIds: Array<string>
}
/**
 *
 * @export
 * @interface UpdateScheduledConsultationParticipantDTO
 */
export interface UpdateScheduledConsultationParticipantDTO {
  /**
   *
   * @type {string}
   * @memberof UpdateScheduledConsultationParticipantDTO
   */
  participantId: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateScheduledConsultationParticipantDTO
   */
  shouldWriteReport?: boolean | null
}
/**
 *
 * @export
 * @interface UpdateScheduledConsultationRequestRecipientsDTO
 */
export interface UpdateScheduledConsultationRequestRecipientsDTO {
  /**
   *
   * @type {Array<UpdateScheduledConsultationParticipantDTO>}
   * @memberof UpdateScheduledConsultationRequestRecipientsDTO
   */
  participants: Array<UpdateScheduledConsultationParticipantDTO>
  /**
   *
   * @type {boolean}
   * @memberof UpdateScheduledConsultationRequestRecipientsDTO
   */
  requesterShouldWriteReport: boolean
}
/**
 *
 * @export
 * @interface UploadFileResponse
 */
export interface UploadFileResponse {
  /**
   *
   * @type {string}
   * @memberof UploadFileResponse
   */
  fileId: string
  /**
   *
   * @type {string}
   * @memberof UploadFileResponse
   */
  uploadUrl: string
}
/**
 *
 * @export
 * @interface UpsertLinkedHospitalsDTO
 */
export interface UpsertLinkedHospitalsDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof UpsertLinkedHospitalsDTO
   */
  linkedHospitalIds: Array<string>
}
/**
 *
 * @export
 * @enum {string}
 */

export const UrgencyDTO = {
  EMERGENCY: 'emergency',
  URGENT: 'urgent',
  ROUTINE: 'routine',
  FOLLOW_UP: 'followUp'
} as const

export type UrgencyDTO = (typeof UrgencyDTO)[keyof typeof UrgencyDTO]

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {Array<string>}
   * @memberof User
   */
  adminHospitalIds: Array<string>
  /**
   *
   * @type {string}
   * @memberof User
   */
  clientId?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  email?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  firstName?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof User
   */
  groups: Array<string>
  /**
   *
   * @type {string}
   * @memberof User
   */
  id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isAdmin: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isChiefPhysician: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isEasyRadiology: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isEnabled?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isHospitalIT: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isHospitalPhysician: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isHubUser: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isMockUser?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isPhysician: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isSpokeUser: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isTccIT: boolean
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isTccPhysician: boolean
  /**
   *
   * @type {string}
   * @memberof User
   */
  lastName?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  mobile?: string | null
  /**
   *
   * @type {string}
   * @memberof User
   */
  phone?: string | null
  /**
   *
   * @type {AssignableUserDTOTitle}
   * @memberof User
   */
  title?: AssignableUserDTOTitle
  /**
   *
   * @type {UserName}
   * @memberof User
   */
  userName: UserName
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof User
   */
  userRights: Array<UserRightsEnum>
}
/**
 *
 * @export
 * @interface UserAttributesDto
 */
export interface UserAttributesDto {
  /**
   *
   * @type {string}
   * @memberof UserAttributesDto
   */
  accessAttribute: UserAttributesDtoAccessAttributeEnum
  /**
   *
   * @type {Array<string>}
   * @memberof UserAttributesDto
   */
  hospitalIds: Array<string>
  /**
   *
   * @type {UserName}
   * @memberof UserAttributesDto
   */
  userName: UserName
  /**
   *
   * @type {Array<string>}
   * @memberof UserAttributesDto
   */
  wardIds: Array<string>
}

export const UserAttributesDtoAccessAttributeEnum = {
  CREATE_CONSULTATIONS_IN_HOSPITALS: 'CAN_CREATE_CONSULTATIONS_IN_HOSPITALS',
  RECEIVE_CONSULTATIONS_IN_HOSPITALS: 'CAN_RECEIVE_CONSULTATIONS_IN_HOSPITALS',
  CREATE_CONSULTATIONS_IN_WARDS: 'CAN_CREATE_CONSULTATIONS_IN_WARDS',
  RECEIVE_CONSULTATIONS_IN_WARDS: 'CAN_RECEIVE_CONSULTATIONS_IN_WARDS',
  RECEIVE_CONSULTATIONS_WHEN_NO_SHIFT_IS_SELECTED:
    'CAN_RECEIVE_CONSULTATIONS_WHEN_NO_SHIFT_IS_SELECTED',
  LIST_PATIENTS_IN_WARDS: 'CAN_LIST_PATIENTS_IN_WARDS',
  CREATE_PATIENTS: 'CAN_CREATE_PATIENTS'
} as const

export type UserAttributesDtoAccessAttributeEnum =
  (typeof UserAttributesDtoAccessAttributeEnum)[keyof typeof UserAttributesDtoAccessAttributeEnum]

/**
 *
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
  /**
   *
   * @type {string}
   * @memberof UserDTO
   */
  firstName?: string | null
  /**
   *
   * @type {string}
   * @memberof UserDTO
   */
  lastName?: string | null
  /**
   *
   * @type {AssignableUserDTOTitle}
   * @memberof UserDTO
   */
  title?: AssignableUserDTOTitle
  /**
   *
   * @type {string}
   * @memberof UserDTO
   */
  userName: string
}
/**
 *
 * @export
 * @interface UserDetailsDTO
 */
export interface UserDetailsDTO {
  /**
   *
   * @type {boolean}
   * @memberof UserDetailsDTO
   */
  archived?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserDetailsDTO
   */
  canCreatePatients?: boolean | null
  /**
   *
   * @type {Array<DepartmentDTO>}
   * @memberof UserDetailsDTO
   */
  departments: Array<DepartmentDTO>
  /**
   *
   * @type {string}
   * @memberof UserDetailsDTO
   */
  email: string
  /**
   *
   * @type {boolean}
   * @memberof UserDetailsDTO
   */
  enabled?: boolean | null
  /**
   *
   * @type {Array<HospitalDTO>}
   * @memberof UserDetailsDTO
   */
  hospitals: Array<HospitalDTO>
  /**
   *
   * @type {Array<string>}
   * @memberof UserDetailsDTO
   */
  medicalFields?: Array<string>
  /**
   *
   * @type {string}
   * @memberof UserDetailsDTO
   */
  mobile?: string | null
  /**
   *
   * @type {string}
   * @memberof UserDetailsDTO
   */
  password?: string | null
  /**
   *
   * @type {string}
   * @memberof UserDetailsDTO
   */
  phone?: string | null
  /**
   *
   * @type {UserDTO}
   * @memberof UserDetailsDTO
   */
  user: UserDTO
  /**
   *
   * @type {Array<string>}
   * @memberof UserDetailsDTO
   */
  userRoles: Array<string>
  /**
   *
   * @type {Array<WardDTO>}
   * @memberof UserDetailsDTO
   */
  wards: Array<WardDTO>
}
/**
 *
 * @export
 * @interface UserName
 */
export interface UserName {
  /**
   *
   * @type {string}
   * @memberof UserName
   */
  value: string
}
/**
 *
 * @export
 * @enum {string}
 */

export const UserRightsEnum = {
  HOSPITAL_IT: 'hospital-it',
  HOSPITAL_PHYSICIAN: 'hospital-physician',
  TCC_IT: 'tcc-it',
  TCC_PHYSICIAN: 'tcc-physician',
  GOD_MODE: 'god-mode',
  CHIEF_PHYSICIAN: 'chief-physician',
  EASY_RADIOLOGY: 'easy-radiology',
  SPOKE: 'spoke',
  HUB: 'hub'
} as const

export type UserRightsEnum = (typeof UserRightsEnum)[keyof typeof UserRightsEnum]

/**
 *
 * @export
 * @interface UserSettingsDTO
 */
export interface UserSettingsDTO {
  /**
   *
   * @type {boolean}
   * @memberof UserSettingsDTO
   */
  canCreateConsultations?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettingsDTO
   */
  canCreatePatients?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettingsDTO
   */
  canListPatients?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettingsDTO
   */
  canReceiveConsultations?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettingsDTO
   */
  isRoutingV2Enabled: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettingsDTO
   */
  language?: string | null
  /**
   *
   * @type {UserSettingsDTOLatestAkiAcceptance}
   * @memberof UserSettingsDTO
   */
  latestAkiAcceptance?: UserSettingsDTOLatestAkiAcceptance
  /**
   *
   * @type {UserSettingsDTOLatestAkiAcceptance}
   * @memberof UserSettingsDTO
   */
  latestEdsAcceptance?: UserSettingsDTOLatestAkiAcceptance
  /**
   *
   * @type {Array<string>}
   * @memberof UserSettingsDTO
   */
  medicalFields?: Array<string>
  /**
   *
   * @type {UserSettingsDTOShift}
   * @memberof UserSettingsDTO
   */
  shift?: UserSettingsDTOShift
  /**
   *
   * @type {string}
   * @memberof UserSettingsDTO
   */
  userName: string
  /**
   *
   * @type {Array<UserRightsEnum>}
   * @memberof UserSettingsDTO
   */
  userRights?: Array<UserRightsEnum>
}
/**
 * @type UserSettingsDTOLatestAkiAcceptance
 * @export
 */
export type UserSettingsDTOLatestAkiAcceptance = PluginContraindicationAcceptanceDto | any

/**
 * @type UserSettingsDTOShift
 * @export
 */
export type UserSettingsDTOShift = ShiftDTO | any

/**
 *
 * @export
 * @interface UserSettingsUpdateDTO
 */
export interface UserSettingsUpdateDTO {
  /**
   *
   * @type {UserSettingsUpdateDTOHospitals}
   * @memberof UserSettingsUpdateDTO
   */
  hospitals?: UserSettingsUpdateDTOHospitals
  /**
   *
   * @type {UserSettingsUpdateDTOLanguage}
   * @memberof UserSettingsUpdateDTO
   */
  language?: UserSettingsUpdateDTOLanguage
  /**
   *
   * @type {UserSettingsUpdateDTOMedicalFields}
   * @memberof UserSettingsUpdateDTO
   */
  medicalFields?: UserSettingsUpdateDTOMedicalFields
  /**
   *
   * @type {UserSettingsUpdateDTOSeniorPhysicianAtHospital}
   * @memberof UserSettingsUpdateDTO
   */
  seniorPhysicianAtHospital?: UserSettingsUpdateDTOSeniorPhysicianAtHospital
  /**
   *
   * @type {UserSettingsUpdateDTOHospitals}
   * @memberof UserSettingsUpdateDTO
   */
  wards?: UserSettingsUpdateDTOHospitals
}
/**
 * @type UserSettingsUpdateDTOHospitals
 * @export
 */
export type UserSettingsUpdateDTOHospitals = UUIDArrayValueDTO | any

/**
 * @type UserSettingsUpdateDTOLanguage
 * @export
 */
export type UserSettingsUpdateDTOLanguage = StringValueDTO | any

/**
 * @type UserSettingsUpdateDTOMedicalFields
 * @export
 */
export type UserSettingsUpdateDTOMedicalFields = StringArrayValueDTO | any

/**
 * @type UserSettingsUpdateDTOSeniorPhysicianAtHospital
 * @export
 */
export type UserSettingsUpdateDTOSeniorPhysicianAtHospital = UUIDValueDTO | any

/**
 *
 * @export
 * @interface VentilationWithTypeKey
 */
export interface VentilationWithTypeKey {
  /**
   *
   * @type {string}
   * @memberof VentilationWithTypeKey
   */
  measurementDate: string
  /**
   *
   * @type {string}
   * @memberof VentilationWithTypeKey
   */
  unit?: string | null
  /**
   *
   * @type {number}
   * @memberof VentilationWithTypeKey
   */
  valueNumber?: number | null
  /**
   *
   * @type {string}
   * @memberof VentilationWithTypeKey
   */
  valueText?: string | null
  /**
   *
   * @type {string}
   * @memberof VentilationWithTypeKey
   */
  ventilationMode: string
  /**
   *
   * @type {string}
   * @memberof VentilationWithTypeKey
   */
  ventilationTypeId: string
}
/**
 *
 * @export
 * @interface VitalSignItemDTO
 */
export interface VitalSignItemDTO {
  /**
   *
   * @type {string}
   * @memberof VitalSignItemDTO
   */
  measurementDate: string
  /**
   *
   * @type {number}
   * @memberof VitalSignItemDTO
   */
  numericValue: number
  /**
   *
   * @type {VitalSignItemDTOSampleLocation}
   * @memberof VitalSignItemDTO
   */
  sampleLocation?: VitalSignItemDTOSampleLocation
  /**
   *
   * @type {string}
   * @memberof VitalSignItemDTO
   */
  typeKey: string
  /**
   *
   * @type {string}
   * @memberof VitalSignItemDTO
   */
  unit?: string | null
}
/**
 * @type VitalSignItemDTOSampleLocation
 * @export
 */
export type VitalSignItemDTOSampleLocation = SampleLocationDTO | any

/**
 *
 * @export
 * @enum {string}
 */

export const VitalSignTypeKey = {
  HEART_RATE: 'HEART_RATE',
  INV_D_BP: 'INV_D_BP',
  INV_M_BP: 'INV_M_BP',
  INV_S_BP: 'INV_S_BP',
  NON_INV_D_BP: 'NON_INV_D_BP',
  NON_INV_M_BP: 'NON_INV_M_BP',
  NON_INV_S_BP: 'NON_INV_S_BP',
  PULSE_RATE: 'PULSE_RATE',
  RR: 'RR',
  RR_M: 'RR_M',
  SPO2: 'SPO2',
  TEMP: 'TEMP'
} as const

export type VitalSignTypeKey = (typeof VitalSignTypeKey)[keyof typeof VitalSignTypeKey]

/**
 *
 * @export
 * @interface VitalSignTypeKeyLike
 */
export interface VitalSignTypeKeyLike {
  /**
   *
   * @type {string}
   * @memberof VitalSignTypeKeyLike
   */
  value: string
}
/**
 *
 * @export
 * @interface VitalSignsFiltersDTO
 */
export interface VitalSignsFiltersDTO {
  /**
   *
   * @type {Array<any>}
   * @memberof VitalSignsFiltersDTO
   */
  vitalSigns?: Array<any>
}
/**
 *
 * @export
 * @interface VitalSignsWithTypeKeyDTO
 */
export interface VitalSignsWithTypeKeyDTO {
  /**
   *
   * @type {string}
   * @memberof VitalSignsWithTypeKeyDTO
   */
  typeKey: string
  /**
   *
   * @type {Array<VitalSignItemDTO>}
   * @memberof VitalSignsWithTypeKeyDTO
   */
  vitalSigns: Array<VitalSignItemDTO>
}
/**
 *
 * @export
 * @enum {string}
 */

export const VitalsPeriod = {
  LATEST: 'LATEST',
  DAY: 'DAY',
  TWO_DAYS: 'TWO_DAYS',
  THREE_DAYS: 'THREE_DAYS',
  WEEK: 'WEEK',
  ALL_TIME: 'ALL_TIME'
} as const

export type VitalsPeriod = (typeof VitalsPeriod)[keyof typeof VitalsPeriod]

/**
 *
 * @export
 * @interface WardCreateDTO
 */
export interface WardCreateDTO {
  /**
   *
   * @type {string}
   * @memberof WardCreateDTO
   */
  departmentId: string
  /**
   *
   * @type {string}
   * @memberof WardCreateDTO
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof WardCreateDTO
   */
  tccBooked: boolean
  /**
   *
   * @type {WardTypeDTO}
   * @memberof WardCreateDTO
   */
  wardType: WardTypeDTO
}

/**
 *
 * @export
 * @interface WardDTO
 */
export interface WardDTO {
  /**
   *
   * @type {string}
   * @memberof WardDTO
   */
  departmentId: string
  /**
   *
   * @type {boolean}
   * @memberof WardDTO
   */
  hasPDMS?: boolean | null
  /**
   *
   * @type {string}
   * @memberof WardDTO
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof WardDTO
   */
  isDeleted: boolean
  /**
   *
   * @type {string}
   * @memberof WardDTO
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof WardDTO
   */
  tccBooked: boolean
  /**
   *
   * @type {WardTypeDTO}
   * @memberof WardDTO
   */
  wardType: WardTypeDTO
}

/**
 * The new exclusion status for the ward
 * @export
 * @interface WardExclusionStatusRequestDTO
 */
export interface WardExclusionStatusRequestDTO {
  /**
   *
   * @type {boolean}
   * @memberof WardExclusionStatusRequestDTO
   */
  isExcluded: boolean
}
/**
 *
 * @export
 * @interface WardFilterOptionDTO
 */
export interface WardFilterOptionDTO {
  /**
   *
   * @type {number}
   * @memberof WardFilterOptionDTO
   */
  patientCount: number
  /**
   *
   * @type {WardDTO}
   * @memberof WardFilterOptionDTO
   */
  ward: WardDTO
}
/**
 *
 * @export
 * @enum {string}
 */

export const WardTypeDTO = {
  ICU: 'ICU',
  IMC: 'IMC',
  OR: 'OR',
  STROKE: 'Stroke',
  WEANING: 'Weaning',
  OP: 'OP'
} as const

export type WardTypeDTO = (typeof WardTypeDTO)[keyof typeof WardTypeDTO]

/**
 *
 * @export
 * @interface WardUpdateDTO
 */
export interface WardUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof WardUpdateDTO
   */
  departmentId: string
  /**
   *
   * @type {boolean}
   * @memberof WardUpdateDTO
   */
  isDeleted?: boolean | null
  /**
   *
   * @type {string}
   * @memberof WardUpdateDTO
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof WardUpdateDTO
   */
  tccBooked: boolean
  /**
   *
   * @type {string}
   * @memberof WardUpdateDTO
   */
  wardId: string
  /**
   *
   * @type {WardTypeDTO}
   * @memberof WardUpdateDTO
   */
  wardType: WardTypeDTO
}

/**
 * AKIAcceptancesApi - axios parameter creator
 * @export
 */
export const AKIAcceptancesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of AKI contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for AKI contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accept1: async (
      pluginAcceptanceRequest: PluginAcceptanceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pluginAcceptanceRequest' is not null or undefined
      assertParamExists('accept1', 'pluginAcceptanceRequest', pluginAcceptanceRequest)
      const localVarPath = `/aki/acceptance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        pluginAcceptanceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AKIAcceptancesApi - functional programming interface
 * @export
 */
export const AKIAcceptancesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AKIAcceptancesApiAxiosParamCreator(configuration)
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of AKI contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for AKI contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accept1(
      pluginAcceptanceRequest: PluginAcceptanceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accept1(
        pluginAcceptanceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AKIAcceptancesApi.accept1']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AKIAcceptancesApi - factory interface
 * @export
 */
export const AKIAcceptancesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AKIAcceptancesApiFp(configuration)
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of AKI contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for AKI contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accept1(pluginAcceptanceRequest: PluginAcceptanceRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .accept1(pluginAcceptanceRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AKIAcceptancesApi - object-oriented interface
 * @export
 * @class AKIAcceptancesApi
 * @extends {BaseAPI}
 */
export class AKIAcceptancesApi extends BaseAPI {
  /**
   * Persists the explicit user acceptance for a specific version and scope of AKI contraindications. This acts as an append-only audit log required for MDR compliance.
   * @summary Record user acceptance for AKI contraindications
   * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AKIAcceptancesApi
   */
  public accept1(
    pluginAcceptanceRequest: PluginAcceptanceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AKIAcceptancesApiFp(this.configuration)
      .accept1(pluginAcceptanceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AKIAcuteKidneyInjuryPluginApi - axios parameter creator
 * @export
 */
export const AKIAcuteKidneyInjuryPluginApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI prediction results.
     * @summary Calculate Bulk Clinical Level Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalLevelPredictionsBatch: async (
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchPredictionRequestItemDTO' is not null or undefined
      assertParamExists(
        'getClinicalLevelPredictionsBatch',
        'batchPredictionRequestItemDTO',
        batchPredictionRequestItemDTO
      )
      const localVarPath = `/aki/prediction/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        batchPredictionRequestItemDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI trend results.
     * @summary Calculate Bulk Trend Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrendPredictionsBatch: async (
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchPredictionRequestItemDTO' is not null or undefined
      assertParamExists(
        'getTrendPredictionsBatch',
        'batchPredictionRequestItemDTO',
        batchPredictionRequestItemDTO
      )
      const localVarPath = `/aki/trend/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        batchPredictionRequestItemDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the AKI medical device.
     * @summary Get AKI UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUdi1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/aki/udi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AKIAcuteKidneyInjuryPluginApi - functional programming interface
 * @export
 */
export const AKIAcuteKidneyInjuryPluginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AKIAcuteKidneyInjuryPluginApiAxiosParamCreator(configuration)
  return {
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI prediction results.
     * @summary Calculate Bulk Clinical Level Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClinicalLevelPredictionsBatch(
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PredictionResultDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalLevelPredictionsBatch(
        batchPredictionRequestItemDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AKIAcuteKidneyInjuryPluginApi.getClinicalLevelPredictionsBatch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI trend results.
     * @summary Calculate Bulk Trend Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTrendPredictionsBatch(
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrendResultDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTrendPredictionsBatch(
        batchPredictionRequestItemDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AKIAcuteKidneyInjuryPluginApi.getTrendPredictionsBatch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the AKI medical device.
     * @summary Get AKI UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUdi1(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PluginUdiDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUdi1(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AKIAcuteKidneyInjuryPluginApi.getUdi1']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AKIAcuteKidneyInjuryPluginApi - factory interface
 * @export
 */
export const AKIAcuteKidneyInjuryPluginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AKIAcuteKidneyInjuryPluginApiFp(configuration)
  return {
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI prediction results.
     * @summary Calculate Bulk Clinical Level Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalLevelPredictionsBatch(
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options?: any
    ): AxiosPromise<PredictionResultDTO> {
      return localVarFp
        .getClinicalLevelPredictionsBatch(batchPredictionRequestItemDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI trend results.
     * @summary Calculate Bulk Trend Predictions
     * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrendPredictionsBatch(
      batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
      options?: any
    ): AxiosPromise<TrendResultDTO> {
      return localVarFp
        .getTrendPredictionsBatch(batchPredictionRequestItemDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the AKI medical device.
     * @summary Get AKI UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUdi1(options?: any): AxiosPromise<PluginUdiDto> {
      return localVarFp.getUdi1(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * AKIAcuteKidneyInjuryPluginApi - object-oriented interface
 * @export
 * @class AKIAcuteKidneyInjuryPluginApi
 * @extends {BaseAPI}
 */
export class AKIAcuteKidneyInjuryPluginApi extends BaseAPI {
  /**
   * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI prediction results.
   * @summary Calculate Bulk Clinical Level Predictions
   * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AKIAcuteKidneyInjuryPluginApi
   */
  public getClinicalLevelPredictionsBatch(
    batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
    options?: RawAxiosRequestConfig
  ) {
    return AKIAcuteKidneyInjuryPluginApiFp(this.configuration)
      .getClinicalLevelPredictionsBatch(batchPredictionRequestItemDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Evaluates the patients\' current vital signs and laboratory data along with demography data to computethe AKI trend results.
   * @summary Calculate Bulk Trend Predictions
   * @param {Array<BatchPredictionRequestItemDTO>} batchPredictionRequestItemDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AKIAcuteKidneyInjuryPluginApi
   */
  public getTrendPredictionsBatch(
    batchPredictionRequestItemDTO: Array<BatchPredictionRequestItemDTO>,
    options?: RawAxiosRequestConfig
  ) {
    return AKIAcuteKidneyInjuryPluginApiFp(this.configuration)
      .getTrendPredictionsBatch(batchPredictionRequestItemDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves Unique Device Identification (UDI) data for the AKI medical device.
   * @summary Get AKI UDI Information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AKIAcuteKidneyInjuryPluginApi
   */
  public getUdi1(options?: RawAxiosRequestConfig) {
    return AKIAcuteKidneyInjuryPluginApiFp(this.configuration)
      .getUdi1(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminCaseApi - axios parameter creator
 * @export
 */
export const AdminCaseApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Archives a Case object
     * @param {string} caseId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveCase: async (
      caseId: string,
      body: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('archiveCase', 'caseId', caseId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('archiveCase', 'body', body)
      const localVarPath = `/admin/case/{caseId}/archive`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates a Case object
     * @param {CaseCreateDTO} caseCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCase: async (
      caseCreateDTO: CaseCreateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseCreateDTO' is not null or undefined
      assertParamExists('createCase', 'caseCreateDTO', caseCreateDTO)
      const localVarPath = `/admin/case`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        caseCreateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of Cases objects for a given Hospital
     * @param {Array<string>} hospitalIds
     * @param {number} offset
     * @param {number} limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesByHospitalId: async (
      hospitalIds: Array<string>,
      offset: number,
      limit: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalIds' is not null or undefined
      assertParamExists('getCasesByHospitalId', 'hospitalIds', hospitalIds)
      // verify required parameter 'offset' is not null or undefined
      assertParamExists('getCasesByHospitalId', 'offset', offset)
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('getCasesByHospitalId', 'limit', limit)
      const localVarPath = `/admin/case/{hospitalIds}`.replace(
        `{${'hospitalIds'}}`,
        encodeURIComponent(String(hospitalIds))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves patient data with optional case and ward IDs if it has any active case
     * @param {string} externalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPatientWithOptionalCase: async (
      externalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'externalId' is not null or undefined
      assertParamExists('getPatientWithOptionalCase', 'externalId', externalId)
      const localVarPath = `/admin/case/by-patient-number/{externalId}`.replace(
        `{${'externalId'}}`,
        encodeURIComponent(String(externalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates multiple Case objects with payload provided in a CSV file
     * @param {File} [file] CSV file with cases data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importCasesFromCSV: async (
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/case/import`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)()

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (file !== undefined) {
        localVarFormParams.append('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a Case object
     * @param {string} caseId
     * @param {CaseUpdateDTO} caseUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCase: async (
      caseId: string,
      caseUpdateDTO: CaseUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('updateCase', 'caseId', caseId)
      // verify required parameter 'caseUpdateDTO' is not null or undefined
      assertParamExists('updateCase', 'caseUpdateDTO', caseUpdateDTO)
      const localVarPath = `/admin/case/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        caseUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminCaseApi - functional programming interface
 * @export
 */
export const AdminCaseApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminCaseApiAxiosParamCreator(configuration)
  return {
    /**
     * Archives a Case object
     * @param {string} caseId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveCase(
      caseId: string,
      body: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCase(caseId, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.archiveCase']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates a Case object
     * @param {CaseCreateDTO} caseCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCase(
      caseCreateDTO: CaseCreateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCase(caseCreateDTO, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.createCase']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of Cases objects for a given Hospital
     * @param {Array<string>} hospitalIds
     * @param {number} offset
     * @param {number} limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCasesByHospitalId(
      hospitalIds: Array<string>,
      offset: number,
      limit: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCaseWithPatientV3>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCasesByHospitalId(
        hospitalIds,
        offset,
        limit,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.getCasesByHospitalId']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves patient data with optional case and ward IDs if it has any active case
     * @param {string} externalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPatientWithOptionalCase(
      externalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientWithOptionalCaseResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPatientWithOptionalCase(
        externalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.getPatientWithOptionalCase']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates multiple Case objects with payload provided in a CSV file
     * @param {File} [file] CSV file with cases data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async importCasesFromCSV(
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importCasesFromCSV(file, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.importCasesFromCSV']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a Case object
     * @param {string} caseId
     * @param {CaseUpdateDTO} caseUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCase(
      caseId: string,
      caseUpdateDTO: CaseUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCase(
        caseId,
        caseUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminCaseApi.updateCase']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminCaseApi - factory interface
 * @export
 */
export const AdminCaseApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminCaseApiFp(configuration)
  return {
    /**
     * Archives a Case object
     * @param {string} caseId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveCase(caseId: string, body: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .archiveCase(caseId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates a Case object
     * @param {CaseCreateDTO} caseCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCase(caseCreateDTO: CaseCreateDTO, options?: any): AxiosPromise<string> {
      return localVarFp
        .createCase(caseCreateDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of Cases objects for a given Hospital
     * @param {Array<string>} hospitalIds
     * @param {number} offset
     * @param {number} limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesByHospitalId(
      hospitalIds: Array<string>,
      offset: number,
      limit: number,
      options?: any
    ): AxiosPromise<PaginatedCaseWithPatientV3> {
      return localVarFp
        .getCasesByHospitalId(hospitalIds, offset, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves patient data with optional case and ward IDs if it has any active case
     * @param {string} externalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPatientWithOptionalCase(
      externalId: string,
      options?: any
    ): AxiosPromise<PatientWithOptionalCaseResponse> {
      return localVarFp
        .getPatientWithOptionalCase(externalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates multiple Case objects with payload provided in a CSV file
     * @param {File} [file] CSV file with cases data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importCasesFromCSV(file?: File, options?: any): AxiosPromise<void> {
      return localVarFp
        .importCasesFromCSV(file, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a Case object
     * @param {string} caseId
     * @param {CaseUpdateDTO} caseUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCase(caseId: string, caseUpdateDTO: CaseUpdateDTO, options?: any): AxiosPromise<void> {
      return localVarFp
        .updateCase(caseId, caseUpdateDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminCaseApi - object-oriented interface
 * @export
 * @class AdminCaseApi
 * @extends {BaseAPI}
 */
export class AdminCaseApi extends BaseAPI {
  /**
   * Archives a Case object
   * @param {string} caseId
   * @param {string} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public archiveCase(caseId: string, body: string, options?: RawAxiosRequestConfig) {
    return AdminCaseApiFp(this.configuration)
      .archiveCase(caseId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates a Case object
   * @param {CaseCreateDTO} caseCreateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public createCase(caseCreateDTO: CaseCreateDTO, options?: RawAxiosRequestConfig) {
    return AdminCaseApiFp(this.configuration)
      .createCase(caseCreateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of Cases objects for a given Hospital
   * @param {Array<string>} hospitalIds
   * @param {number} offset
   * @param {number} limit
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public getCasesByHospitalId(
    hospitalIds: Array<string>,
    offset: number,
    limit: number,
    options?: RawAxiosRequestConfig
  ) {
    return AdminCaseApiFp(this.configuration)
      .getCasesByHospitalId(hospitalIds, offset, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves patient data with optional case and ward IDs if it has any active case
   * @param {string} externalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public getPatientWithOptionalCase(externalId: string, options?: RawAxiosRequestConfig) {
    return AdminCaseApiFp(this.configuration)
      .getPatientWithOptionalCase(externalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates multiple Case objects with payload provided in a CSV file
   * @param {File} [file] CSV file with cases data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public importCasesFromCSV(file?: File, options?: RawAxiosRequestConfig) {
    return AdminCaseApiFp(this.configuration)
      .importCasesFromCSV(file, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a Case object
   * @param {string} caseId
   * @param {CaseUpdateDTO} caseUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminCaseApi
   */
  public updateCase(caseId: string, caseUpdateDTO: CaseUpdateDTO, options?: RawAxiosRequestConfig) {
    return AdminCaseApiFp(this.configuration)
      .updateCase(caseId, caseUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminClientApi - axios parameter creator
 * @export
 */
export const AdminClientApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates a Client object
     * @param {ClientCreateDTO} clientCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createClient: async (
      clientCreateDTO: ClientCreateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientCreateDTO' is not null or undefined
      assertParamExists('createClient', 'clientCreateDTO', clientCreateDTO)
      const localVarPath = `/admin/client`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        clientCreateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of Client objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients: async (
      offset: number,
      limit: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'offset' is not null or undefined
      assertParamExists('getClients', 'offset', offset)
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('getClients', 'limit', limit)
      const localVarPath = `/admin/client`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a Client object
     * @param {string} clientId
     * @param {ClientUpdateDTO} clientUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateClient: async (
      clientId: string,
      clientUpdateDTO: ClientUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('updateClient', 'clientId', clientId)
      // verify required parameter 'clientUpdateDTO' is not null or undefined
      assertParamExists('updateClient', 'clientUpdateDTO', clientUpdateDTO)
      const localVarPath = `/admin/client/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        clientUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminClientApi - functional programming interface
 * @export
 */
export const AdminClientApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminClientApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates a Client object
     * @param {ClientCreateDTO} clientCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createClient(
      clientCreateDTO: ClientCreateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(
        clientCreateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminClientApi.createClient']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of Client objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClients(
      offset: number,
      limit: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClientsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(offset, limit, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminClientApi.getClients']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a Client object
     * @param {string} clientId
     * @param {ClientUpdateDTO} clientUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateClient(
      clientId: string,
      clientUpdateDTO: ClientUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(
        clientId,
        clientUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminClientApi.updateClient']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminClientApi - factory interface
 * @export
 */
export const AdminClientApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminClientApiFp(configuration)
  return {
    /**
     * Creates a Client object
     * @param {ClientCreateDTO} clientCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createClient(clientCreateDTO: ClientCreateDTO, options?: any): AxiosPromise<string> {
      return localVarFp
        .createClient(clientCreateDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of Client objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClients(offset: number, limit: number, options?: any): AxiosPromise<GetClientsResponse> {
      return localVarFp
        .getClients(offset, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a Client object
     * @param {string} clientId
     * @param {ClientUpdateDTO} clientUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateClient(
      clientId: string,
      clientUpdateDTO: ClientUpdateDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateClient(clientId, clientUpdateDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminClientApi - object-oriented interface
 * @export
 * @class AdminClientApi
 * @extends {BaseAPI}
 */
export class AdminClientApi extends BaseAPI {
  /**
   * Creates a Client object
   * @param {ClientCreateDTO} clientCreateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminClientApi
   */
  public createClient(clientCreateDTO: ClientCreateDTO, options?: RawAxiosRequestConfig) {
    return AdminClientApiFp(this.configuration)
      .createClient(clientCreateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of Client objects
   * @param {number} offset page offset
   * @param {number} limit page limit
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminClientApi
   */
  public getClients(offset: number, limit: number, options?: RawAxiosRequestConfig) {
    return AdminClientApiFp(this.configuration)
      .getClients(offset, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a Client object
   * @param {string} clientId
   * @param {ClientUpdateDTO} clientUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminClientApi
   */
  public updateClient(
    clientId: string,
    clientUpdateDTO: ClientUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminClientApiFp(this.configuration)
      .updateClient(clientId, clientUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminConsultationFieldApi - axios parameter creator
 * @export
 */
export const AdminConsultationFieldApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates a custom consultation field definition
     * @param {CustomConsultationFieldCreationDTO} customConsultationFieldCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomConsultationField: async (
      customConsultationFieldCreationDTO: CustomConsultationFieldCreationDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'customConsultationFieldCreationDTO' is not null or undefined
      assertParamExists(
        'createCustomConsultationField',
        'customConsultationFieldCreationDTO',
        customConsultationFieldCreationDTO
      )
      const localVarPath = `/admin/consultation-field`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        customConsultationFieldCreationDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves all custom consultation fields for given client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomConsultationFieldsByClientId: async (
      clientId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('getCustomConsultationFieldsByClientId', 'clientId', clientId)
      const localVarPath = `/admin/client/{clientId}/consultation-field`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a custom consultation field definition
     * @param {string} fieldId
     * @param {CustomConsultationFieldUpdateDTO} customConsultationFieldUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomConsultationField: async (
      fieldId: string,
      customConsultationFieldUpdateDTO: CustomConsultationFieldUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fieldId' is not null or undefined
      assertParamExists('updateCustomConsultationField', 'fieldId', fieldId)
      // verify required parameter 'customConsultationFieldUpdateDTO' is not null or undefined
      assertParamExists(
        'updateCustomConsultationField',
        'customConsultationFieldUpdateDTO',
        customConsultationFieldUpdateDTO
      )
      const localVarPath = `/admin/consultation-field/{fieldId}`.replace(
        `{${'fieldId'}}`,
        encodeURIComponent(String(fieldId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        customConsultationFieldUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminConsultationFieldApi - functional programming interface
 * @export
 */
export const AdminConsultationFieldApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminConsultationFieldApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates a custom consultation field definition
     * @param {CustomConsultationFieldCreationDTO} customConsultationFieldCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCustomConsultationField(
      customConsultationFieldCreationDTO: CustomConsultationFieldCreationDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullCustomConsultationFieldDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomConsultationField(
        customConsultationFieldCreationDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminConsultationFieldApi.createCustomConsultationField']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves all custom consultation fields for given client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomConsultationFieldsByClientId(
      clientId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<FullCustomConsultationFieldDTO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCustomConsultationFieldsByClientId(clientId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminConsultationFieldApi.getCustomConsultationFieldsByClientId']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a custom consultation field definition
     * @param {string} fieldId
     * @param {CustomConsultationFieldUpdateDTO} customConsultationFieldUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCustomConsultationField(
      fieldId: string,
      customConsultationFieldUpdateDTO: CustomConsultationFieldUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FullCustomConsultationFieldDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomConsultationField(
        fieldId,
        customConsultationFieldUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminConsultationFieldApi.updateCustomConsultationField']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminConsultationFieldApi - factory interface
 * @export
 */
export const AdminConsultationFieldApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminConsultationFieldApiFp(configuration)
  return {
    /**
     * Creates a custom consultation field definition
     * @param {CustomConsultationFieldCreationDTO} customConsultationFieldCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCustomConsultationField(
      customConsultationFieldCreationDTO: CustomConsultationFieldCreationDTO,
      options?: any
    ): AxiosPromise<FullCustomConsultationFieldDTO> {
      return localVarFp
        .createCustomConsultationField(customConsultationFieldCreationDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves all custom consultation fields for given client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomConsultationFieldsByClientId(
      clientId: string,
      options?: any
    ): AxiosPromise<Array<FullCustomConsultationFieldDTO>> {
      return localVarFp
        .getCustomConsultationFieldsByClientId(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a custom consultation field definition
     * @param {string} fieldId
     * @param {CustomConsultationFieldUpdateDTO} customConsultationFieldUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCustomConsultationField(
      fieldId: string,
      customConsultationFieldUpdateDTO: CustomConsultationFieldUpdateDTO,
      options?: any
    ): AxiosPromise<FullCustomConsultationFieldDTO> {
      return localVarFp
        .updateCustomConsultationField(fieldId, customConsultationFieldUpdateDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminConsultationFieldApi - object-oriented interface
 * @export
 * @class AdminConsultationFieldApi
 * @extends {BaseAPI}
 */
export class AdminConsultationFieldApi extends BaseAPI {
  /**
   * Creates a custom consultation field definition
   * @param {CustomConsultationFieldCreationDTO} customConsultationFieldCreationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminConsultationFieldApi
   */
  public createCustomConsultationField(
    customConsultationFieldCreationDTO: CustomConsultationFieldCreationDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminConsultationFieldApiFp(this.configuration)
      .createCustomConsultationField(customConsultationFieldCreationDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves all custom consultation fields for given client
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminConsultationFieldApi
   */
  public getCustomConsultationFieldsByClientId(clientId: string, options?: RawAxiosRequestConfig) {
    return AdminConsultationFieldApiFp(this.configuration)
      .getCustomConsultationFieldsByClientId(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a custom consultation field definition
   * @param {string} fieldId
   * @param {CustomConsultationFieldUpdateDTO} customConsultationFieldUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminConsultationFieldApi
   */
  public updateCustomConsultationField(
    fieldId: string,
    customConsultationFieldUpdateDTO: CustomConsultationFieldUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminConsultationFieldApiFp(this.configuration)
      .updateCustomConsultationField(fieldId, customConsultationFieldUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminDepartmentApi - axios parameter creator
 * @export
 */
export const AdminDepartmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates multiple Department objects
     * @param {CreateDepartmentsRequest} createDepartmentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDepartments: async (
      createDepartmentsRequest: CreateDepartmentsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createDepartmentsRequest' is not null or undefined
      assertParamExists('createDepartments', 'createDepartmentsRequest', createDepartmentsRequest)
      const localVarPath = `/admin/department`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createDepartmentsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Modifies multiple Department and Ward objects
     * @param {UpdateDepartmentsWithWardsRequest} updateDepartmentsWithWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDepartmentsWithWards: async (
      updateDepartmentsWithWardsRequest: UpdateDepartmentsWithWardsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateDepartmentsWithWardsRequest' is not null or undefined
      assertParamExists(
        'updateDepartmentsWithWards',
        'updateDepartmentsWithWardsRequest',
        updateDepartmentsWithWardsRequest
      )
      const localVarPath = `/admin/departments-with-wards`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateDepartmentsWithWardsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminDepartmentApi - functional programming interface
 * @export
 */
export const AdminDepartmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminDepartmentApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates multiple Department objects
     * @param {CreateDepartmentsRequest} createDepartmentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createDepartments(
      createDepartmentsRequest: CreateDepartmentsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartments(
        createDepartmentsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminDepartmentApi.createDepartments']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Modifies multiple Department and Ward objects
     * @param {UpdateDepartmentsWithWardsRequest} updateDepartmentsWithWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDepartmentsWithWards(
      updateDepartmentsWithWardsRequest: UpdateDepartmentsWithWardsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartmentsWithWards(
        updateDepartmentsWithWardsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminDepartmentApi.updateDepartmentsWithWards']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminDepartmentApi - factory interface
 * @export
 */
export const AdminDepartmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminDepartmentApiFp(configuration)
  return {
    /**
     * Creates multiple Department objects
     * @param {CreateDepartmentsRequest} createDepartmentsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDepartments(
      createDepartmentsRequest: CreateDepartmentsRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .createDepartments(createDepartmentsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Modifies multiple Department and Ward objects
     * @param {UpdateDepartmentsWithWardsRequest} updateDepartmentsWithWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDepartmentsWithWards(
      updateDepartmentsWithWardsRequest: UpdateDepartmentsWithWardsRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateDepartmentsWithWards(updateDepartmentsWithWardsRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminDepartmentApi - object-oriented interface
 * @export
 * @class AdminDepartmentApi
 * @extends {BaseAPI}
 */
export class AdminDepartmentApi extends BaseAPI {
  /**
   * Creates multiple Department objects
   * @param {CreateDepartmentsRequest} createDepartmentsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminDepartmentApi
   */
  public createDepartments(
    createDepartmentsRequest: CreateDepartmentsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AdminDepartmentApiFp(this.configuration)
      .createDepartments(createDepartmentsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Modifies multiple Department and Ward objects
   * @param {UpdateDepartmentsWithWardsRequest} updateDepartmentsWithWardsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminDepartmentApi
   */
  public updateDepartmentsWithWards(
    updateDepartmentsWithWardsRequest: UpdateDepartmentsWithWardsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AdminDepartmentApiFp(this.configuration)
      .updateDepartmentsWithWards(updateDepartmentsWithWardsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminEscalationChainApi - axios parameter creator
 * @export
 */
export const AdminEscalationChainApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates a custom Escalation Chain that takes precedence over the inherited ones
     * @param {EscalationChainCreationDTO} escalationChainCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEscalationChain: async (
      escalationChainCreationDTO: EscalationChainCreationDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'escalationChainCreationDTO' is not null or undefined
      assertParamExists(
        'createEscalationChain',
        'escalationChainCreationDTO',
        escalationChainCreationDTO
      )
      const localVarPath = `/admin/escalation-chains`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        escalationChainCreationDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves aggregated configuration (Emergency, Urgent, Routine) for a specific organizational unit
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConfiguration: async (
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/escalation-chains/configuration`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      if (departmentId !== undefined) {
        localVarQueryParameter['departmentId'] = departmentId
      }

      if (wardId !== undefined) {
        localVarQueryParameter['wardId'] = wardId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves the global default escalation chain configuration
     * @param {UrgencyDTO} urgency
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDefaultConfiguration: async (
      urgency: UrgencyDTO,
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'urgency' is not null or undefined
      assertParamExists('getDefaultConfiguration', 'urgency', urgency)
      const localVarPath = `/admin/escalation-chains/configuration/default`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      if (departmentId !== undefined) {
        localVarQueryParameter['departmentId'] = departmentId
      }

      if (wardId !== undefined) {
        localVarQueryParameter['wardId'] = wardId
      }

      if (urgency !== undefined) {
        localVarQueryParameter['urgency'] = urgency
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates an existing Escalation Chain
     * @param {string} id
     * @param {EscalationChainUpdateDTO} escalationChainUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEscalationChain: async (
      id: string,
      escalationChainUpdateDTO: EscalationChainUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updateEscalationChain', 'id', id)
      // verify required parameter 'escalationChainUpdateDTO' is not null or undefined
      assertParamExists(
        'updateEscalationChain',
        'escalationChainUpdateDTO',
        escalationChainUpdateDTO
      )
      const localVarPath = `/admin/escalation-chains/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        escalationChainUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminEscalationChainApi - functional programming interface
 * @export
 */
export const AdminEscalationChainApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminEscalationChainApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates a custom Escalation Chain that takes precedence over the inherited ones
     * @param {EscalationChainCreationDTO} escalationChainCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEscalationChain(
      escalationChainCreationDTO: EscalationChainCreationDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationChainConfigurationDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEscalationChain(
        escalationChainCreationDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminEscalationChainApi.createEscalationChain']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves aggregated configuration (Emergency, Urgent, Routine) for a specific organizational unit
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConfiguration(
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetEscalationChainConfigurationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguration(
        clientId,
        hospitalId,
        departmentId,
        wardId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminEscalationChainApi.getConfiguration']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves the global default escalation chain configuration
     * @param {UrgencyDTO} urgency
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDefaultConfiguration(
      urgency: UrgencyDTO,
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationChainConfigurationDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultConfiguration(
        urgency,
        clientId,
        hospitalId,
        departmentId,
        wardId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminEscalationChainApi.getDefaultConfiguration']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates an existing Escalation Chain
     * @param {string} id
     * @param {EscalationChainUpdateDTO} escalationChainUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEscalationChain(
      id: string,
      escalationChainUpdateDTO: EscalationChainUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationChainConfigurationDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEscalationChain(
        id,
        escalationChainUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminEscalationChainApi.updateEscalationChain']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminEscalationChainApi - factory interface
 * @export
 */
export const AdminEscalationChainApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminEscalationChainApiFp(configuration)
  return {
    /**
     * Creates a custom Escalation Chain that takes precedence over the inherited ones
     * @param {EscalationChainCreationDTO} escalationChainCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEscalationChain(
      escalationChainCreationDTO: EscalationChainCreationDTO,
      options?: any
    ): AxiosPromise<EscalationChainConfigurationDTO> {
      return localVarFp
        .createEscalationChain(escalationChainCreationDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves aggregated configuration (Emergency, Urgent, Routine) for a specific organizational unit
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConfiguration(
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options?: any
    ): AxiosPromise<GetEscalationChainConfigurationResponse> {
      return localVarFp
        .getConfiguration(clientId, hospitalId, departmentId, wardId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves the global default escalation chain configuration
     * @param {UrgencyDTO} urgency
     * @param {string} [clientId]
     * @param {string} [hospitalId]
     * @param {string} [departmentId]
     * @param {string} [wardId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDefaultConfiguration(
      urgency: UrgencyDTO,
      clientId?: string,
      hospitalId?: string,
      departmentId?: string,
      wardId?: string,
      options?: any
    ): AxiosPromise<EscalationChainConfigurationDTO> {
      return localVarFp
        .getDefaultConfiguration(urgency, clientId, hospitalId, departmentId, wardId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates an existing Escalation Chain
     * @param {string} id
     * @param {EscalationChainUpdateDTO} escalationChainUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEscalationChain(
      id: string,
      escalationChainUpdateDTO: EscalationChainUpdateDTO,
      options?: any
    ): AxiosPromise<EscalationChainConfigurationDTO> {
      return localVarFp
        .updateEscalationChain(id, escalationChainUpdateDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminEscalationChainApi - object-oriented interface
 * @export
 * @class AdminEscalationChainApi
 * @extends {BaseAPI}
 */
export class AdminEscalationChainApi extends BaseAPI {
  /**
   * Creates a custom Escalation Chain that takes precedence over the inherited ones
   * @param {EscalationChainCreationDTO} escalationChainCreationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminEscalationChainApi
   */
  public createEscalationChain(
    escalationChainCreationDTO: EscalationChainCreationDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminEscalationChainApiFp(this.configuration)
      .createEscalationChain(escalationChainCreationDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves aggregated configuration (Emergency, Urgent, Routine) for a specific organizational unit
   * @param {string} [clientId]
   * @param {string} [hospitalId]
   * @param {string} [departmentId]
   * @param {string} [wardId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminEscalationChainApi
   */
  public getConfiguration(
    clientId?: string,
    hospitalId?: string,
    departmentId?: string,
    wardId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AdminEscalationChainApiFp(this.configuration)
      .getConfiguration(clientId, hospitalId, departmentId, wardId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves the global default escalation chain configuration
   * @param {UrgencyDTO} urgency
   * @param {string} [clientId]
   * @param {string} [hospitalId]
   * @param {string} [departmentId]
   * @param {string} [wardId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminEscalationChainApi
   */
  public getDefaultConfiguration(
    urgency: UrgencyDTO,
    clientId?: string,
    hospitalId?: string,
    departmentId?: string,
    wardId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AdminEscalationChainApiFp(this.configuration)
      .getDefaultConfiguration(urgency, clientId, hospitalId, departmentId, wardId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates an existing Escalation Chain
   * @param {string} id
   * @param {EscalationChainUpdateDTO} escalationChainUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminEscalationChainApi
   */
  public updateEscalationChain(
    id: string,
    escalationChainUpdateDTO: EscalationChainUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminEscalationChainApiFp(this.configuration)
      .updateEscalationChain(id, escalationChainUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminHospitalApi - axios parameter creator
 * @export
 */
export const AdminHospitalApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates a Hospital object
     * @param {HospitalCreateDTO} hospitalCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHospital: async (
      hospitalCreateDTO: HospitalCreateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalCreateDTO' is not null or undefined
      assertParamExists('createHospital', 'hospitalCreateDTO', hospitalCreateDTO)
      const localVarPath = `/admin/hospital`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        hospitalCreateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a Hospital object by ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospital: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospital', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Returns users from a hospital who can be assigned as admins
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalAdminCandidates: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospitalAdminCandidates', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital/{hospitalId}/admin-candidates`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of Hospital objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitals: async (
      offset: number,
      limit: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'offset' is not null or undefined
      assertParamExists('getHospitals', 'offset', offset)
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('getHospitals', 'limit', limit)
      const localVarPath = `/admin/hospital`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves the IDs of hospitals linked to the specified hospital ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLinkedHospitals: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getLinkedHospitals', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital/{hospitalId}/linked-hospitals`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a Hospital object
     * @param {string} hospitalId
     * @param {HospitalUpdateDTO} hospitalUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospital: async (
      hospitalId: string,
      hospitalUpdateDTO: HospitalUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('updateHospital', 'hospitalId', hospitalId)
      // verify required parameter 'hospitalUpdateDTO' is not null or undefined
      assertParamExists('updateHospital', 'hospitalUpdateDTO', hospitalUpdateDTO)
      const localVarPath = `/admin/hospital/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        hospitalUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Assigns or removes hospital admins for the specified hospital
     * @param {string} hospitalId
     * @param {HospitalAdminsUpdateDTO} hospitalAdminsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalAdmins: async (
      hospitalId: string,
      hospitalAdminsUpdateDTO: HospitalAdminsUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('updateHospitalAdmins', 'hospitalId', hospitalId)
      // verify required parameter 'hospitalAdminsUpdateDTO' is not null or undefined
      assertParamExists('updateHospitalAdmins', 'hospitalAdminsUpdateDTO', hospitalAdminsUpdateDTO)
      const localVarPath = `/admin/hospital/{hospitalId}/admins`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        hospitalAdminsUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates or overwrites the list of linked hospital IDs for a given hospital ID
     * @param {string} hospitalId
     * @param {UpsertLinkedHospitalsDTO} upsertLinkedHospitalsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLinkedHospitals: async (
      hospitalId: string,
      upsertLinkedHospitalsDTO: UpsertLinkedHospitalsDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('updateLinkedHospitals', 'hospitalId', hospitalId)
      // verify required parameter 'upsertLinkedHospitalsDTO' is not null or undefined
      assertParamExists(
        'updateLinkedHospitals',
        'upsertLinkedHospitalsDTO',
        upsertLinkedHospitalsDTO
      )
      const localVarPath = `/admin/hospital/{hospitalId}/linked-hospitals`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertLinkedHospitalsDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Uploads or overwrites the hospital logo (PNG/JPEG)
     * @param {string} hospitalId
     * @param {File} file Logo file (PNG, JPEG)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadHospitalLogo: async (
      hospitalId: string,
      file: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('uploadHospitalLogo', 'hospitalId', hospitalId)
      // verify required parameter 'file' is not null or undefined
      assertParamExists('uploadHospitalLogo', 'file', file)
      const localVarPath = `/admin/hospital/{hospitalId}/logo`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)()

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (file !== undefined) {
        localVarFormParams.append('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminHospitalApi - functional programming interface
 * @export
 */
export const AdminHospitalApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminHospitalApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates a Hospital object
     * @param {HospitalCreateDTO} hospitalCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHospital(
      hospitalCreateDTO: HospitalCreateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createHospital(
        hospitalCreateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.createHospital']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a Hospital object by ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospital(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalDetailsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospital(hospitalId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.getHospital']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Returns users from a hospital who can be assigned as admins
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitalAdminCandidates(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHospitalAdminsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalAdminCandidates(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.getHospitalAdminCandidates']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of Hospital objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitals(
      offset: number,
      limit: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHospitalsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitals(offset, limit, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.getHospitals']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves the IDs of hospitals linked to the specified hospital ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLinkedHospitals(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLinkedHospitalsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkedHospitals(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.getLinkedHospitals']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a Hospital object
     * @param {string} hospitalId
     * @param {HospitalUpdateDTO} hospitalUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHospital(
      hospitalId: string,
      hospitalUpdateDTO: HospitalUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospital(
        hospitalId,
        hospitalUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.updateHospital']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Assigns or removes hospital admins for the specified hospital
     * @param {string} hospitalId
     * @param {HospitalAdminsUpdateDTO} hospitalAdminsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHospitalAdmins(
      hospitalId: string,
      hospitalAdminsUpdateDTO: HospitalAdminsUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalAdmins(
        hospitalId,
        hospitalAdminsUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.updateHospitalAdmins']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates or overwrites the list of linked hospital IDs for a given hospital ID
     * @param {string} hospitalId
     * @param {UpsertLinkedHospitalsDTO} upsertLinkedHospitalsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLinkedHospitals(
      hospitalId: string,
      upsertLinkedHospitalsDTO: UpsertLinkedHospitalsDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateLinkedHospitals(
        hospitalId,
        upsertLinkedHospitalsDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.updateLinkedHospitals']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Uploads or overwrites the hospital logo (PNG/JPEG)
     * @param {string} hospitalId
     * @param {File} file Logo file (PNG, JPEG)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadHospitalLogo(
      hospitalId: string,
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadHospitalLogo(
        hospitalId,
        file,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalApi.uploadHospitalLogo']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminHospitalApi - factory interface
 * @export
 */
export const AdminHospitalApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminHospitalApiFp(configuration)
  return {
    /**
     * Creates a Hospital object
     * @param {HospitalCreateDTO} hospitalCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHospital(hospitalCreateDTO: HospitalCreateDTO, options?: any): AxiosPromise<string> {
      return localVarFp
        .createHospital(hospitalCreateDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a Hospital object by ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospital(hospitalId: string, options?: any): AxiosPromise<HospitalDetailsDTO> {
      return localVarFp.getHospital(hospitalId, options).then((request) => request(axios, basePath))
    },
    /**
     * Returns users from a hospital who can be assigned as admins
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalAdminCandidates(
      hospitalId: string,
      options?: any
    ): AxiosPromise<GetHospitalAdminsResponse> {
      return localVarFp
        .getHospitalAdminCandidates(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of Hospital objects
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitals(offset: number, limit: number, options?: any): AxiosPromise<GetHospitalsResponse> {
      return localVarFp
        .getHospitals(offset, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves the IDs of hospitals linked to the specified hospital ID
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLinkedHospitals(
      hospitalId: string,
      options?: any
    ): AxiosPromise<GetLinkedHospitalsResponse> {
      return localVarFp
        .getLinkedHospitals(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a Hospital object
     * @param {string} hospitalId
     * @param {HospitalUpdateDTO} hospitalUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospital(
      hospitalId: string,
      hospitalUpdateDTO: HospitalUpdateDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateHospital(hospitalId, hospitalUpdateDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Assigns or removes hospital admins for the specified hospital
     * @param {string} hospitalId
     * @param {HospitalAdminsUpdateDTO} hospitalAdminsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalAdmins(
      hospitalId: string,
      hospitalAdminsUpdateDTO: HospitalAdminsUpdateDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateHospitalAdmins(hospitalId, hospitalAdminsUpdateDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates or overwrites the list of linked hospital IDs for a given hospital ID
     * @param {string} hospitalId
     * @param {UpsertLinkedHospitalsDTO} upsertLinkedHospitalsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLinkedHospitals(
      hospitalId: string,
      upsertLinkedHospitalsDTO: UpsertLinkedHospitalsDTO,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .updateLinkedHospitals(hospitalId, upsertLinkedHospitalsDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Uploads or overwrites the hospital logo (PNG/JPEG)
     * @param {string} hospitalId
     * @param {File} file Logo file (PNG, JPEG)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadHospitalLogo(hospitalId: string, file: File, options?: any): AxiosPromise<void> {
      return localVarFp
        .uploadHospitalLogo(hospitalId, file, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminHospitalApi - object-oriented interface
 * @export
 * @class AdminHospitalApi
 * @extends {BaseAPI}
 */
export class AdminHospitalApi extends BaseAPI {
  /**
   * Creates a Hospital object
   * @param {HospitalCreateDTO} hospitalCreateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public createHospital(hospitalCreateDTO: HospitalCreateDTO, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .createHospital(hospitalCreateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a Hospital object by ID
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public getHospital(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .getHospital(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Returns users from a hospital who can be assigned as admins
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public getHospitalAdminCandidates(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .getHospitalAdminCandidates(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of Hospital objects
   * @param {number} offset page offset
   * @param {number} limit page limit
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public getHospitals(offset: number, limit: number, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .getHospitals(offset, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves the IDs of hospitals linked to the specified hospital ID
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public getLinkedHospitals(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .getLinkedHospitals(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a Hospital object
   * @param {string} hospitalId
   * @param {HospitalUpdateDTO} hospitalUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public updateHospital(
    hospitalId: string,
    hospitalUpdateDTO: HospitalUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminHospitalApiFp(this.configuration)
      .updateHospital(hospitalId, hospitalUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Assigns or removes hospital admins for the specified hospital
   * @param {string} hospitalId
   * @param {HospitalAdminsUpdateDTO} hospitalAdminsUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public updateHospitalAdmins(
    hospitalId: string,
    hospitalAdminsUpdateDTO: HospitalAdminsUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminHospitalApiFp(this.configuration)
      .updateHospitalAdmins(hospitalId, hospitalAdminsUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates or overwrites the list of linked hospital IDs for a given hospital ID
   * @param {string} hospitalId
   * @param {UpsertLinkedHospitalsDTO} upsertLinkedHospitalsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public updateLinkedHospitals(
    hospitalId: string,
    upsertLinkedHospitalsDTO: UpsertLinkedHospitalsDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminHospitalApiFp(this.configuration)
      .updateLinkedHospitals(hospitalId, upsertLinkedHospitalsDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Uploads or overwrites the hospital logo (PNG/JPEG)
   * @param {string} hospitalId
   * @param {File} file Logo file (PNG, JPEG)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalApi
   */
  public uploadHospitalLogo(hospitalId: string, file: File, options?: RawAxiosRequestConfig) {
    return AdminHospitalApiFp(this.configuration)
      .uploadHospitalLogo(hospitalId, file, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminHospitalHubApi - axios parameter creator
 * @export
 */
export const AdminHospitalHubApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Configures a new or existing Hospital Hub
     * @param {HospitalHubCreationDTO} hospitalHubCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrUpdateHospitalHub: async (
      hospitalHubCreationDTO: HospitalHubCreationDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalHubCreationDTO' is not null or undefined
      assertParamExists(
        'createOrUpdateHospitalHub',
        'hospitalHubCreationDTO',
        hospitalHubCreationDTO
      )
      const localVarPath = `/admin/hospital-hub`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        hospitalHubCreationDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Deletes Hub for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHospitalHub: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('deleteHospitalHub', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital-hub/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves Hub configuration for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalHub: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospitalHub', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital-hub/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves IDs of Hospitals combined in a Hub configured for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnerHospitalsInHub: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getPartnerHospitalsInHub', 'hospitalId', hospitalId)
      const localVarPath = `/admin/hospital-hub/{hospitalId}/hospitals`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminHospitalHubApi - functional programming interface
 * @export
 */
export const AdminHospitalHubApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminHospitalHubApiAxiosParamCreator(configuration)
  return {
    /**
     * Configures a new or existing Hospital Hub
     * @param {HospitalHubCreationDTO} hospitalHubCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createOrUpdateHospitalHub(
      hospitalHubCreationDTO: HospitalHubCreationDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalHubDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateHospitalHub(
        hospitalHubCreationDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalHubApi.createOrUpdateHospitalHub']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Deletes Hub for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHospitalHub(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHospitalHub(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalHubApi.deleteHospitalHub']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves Hub configuration for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitalHub(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalHubDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalHub(hospitalId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalHubApi.getHospitalHub']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves IDs of Hospitals combined in a Hub configured for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPartnerHospitalsInHub(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerHospitalsInHub(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminHospitalHubApi.getPartnerHospitalsInHub']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminHospitalHubApi - factory interface
 * @export
 */
export const AdminHospitalHubApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminHospitalHubApiFp(configuration)
  return {
    /**
     * Configures a new or existing Hospital Hub
     * @param {HospitalHubCreationDTO} hospitalHubCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOrUpdateHospitalHub(
      hospitalHubCreationDTO: HospitalHubCreationDTO,
      options?: any
    ): AxiosPromise<HospitalHubDTO> {
      return localVarFp
        .createOrUpdateHospitalHub(hospitalHubCreationDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes Hub for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHospitalHub(hospitalId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteHospitalHub(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves Hub configuration for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalHub(hospitalId: string, options?: any): AxiosPromise<HospitalHubDTO> {
      return localVarFp
        .getHospitalHub(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves IDs of Hospitals combined in a Hub configured for Hospital
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnerHospitalsInHub(hospitalId: string, options?: any): AxiosPromise<Array<string>> {
      return localVarFp
        .getPartnerHospitalsInHub(hospitalId, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminHospitalHubApi - object-oriented interface
 * @export
 * @class AdminHospitalHubApi
 * @extends {BaseAPI}
 */
export class AdminHospitalHubApi extends BaseAPI {
  /**
   * Configures a new or existing Hospital Hub
   * @param {HospitalHubCreationDTO} hospitalHubCreationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalHubApi
   */
  public createOrUpdateHospitalHub(
    hospitalHubCreationDTO: HospitalHubCreationDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminHospitalHubApiFp(this.configuration)
      .createOrUpdateHospitalHub(hospitalHubCreationDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes Hub for Hospital
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalHubApi
   */
  public deleteHospitalHub(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalHubApiFp(this.configuration)
      .deleteHospitalHub(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves Hub configuration for Hospital
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalHubApi
   */
  public getHospitalHub(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalHubApiFp(this.configuration)
      .getHospitalHub(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves IDs of Hospitals combined in a Hub configured for Hospital
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminHospitalHubApi
   */
  public getPartnerHospitalsInHub(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminHospitalHubApiFp(this.configuration)
      .getPartnerHospitalsInHub(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminPluginApi - axios parameter creator
 * @export
 */
export const AdminPluginApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Disables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disablePlugin: async (
      clientId: string,
      pluginKey: PluginKey,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('disablePlugin', 'clientId', clientId)
      // verify required parameter 'pluginKey' is not null or undefined
      assertParamExists('disablePlugin', 'pluginKey', pluginKey)
      const localVarPath = `/admin/plugins/clients/{clientId}/disable/{pluginKey}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'pluginKey'}}`, encodeURIComponent(String(pluginKey)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Enables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {string} [until]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enablePlugin: async (
      clientId: string,
      pluginKey: PluginKey,
      until?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('enablePlugin', 'clientId', clientId)
      // verify required parameter 'pluginKey' is not null or undefined
      assertParamExists('enablePlugin', 'pluginKey', pluginKey)
      const localVarPath = `/admin/plugins/clients/{clientId}/enable/{pluginKey}`
        .replace(`{${'clientId'}}`, encodeURIComponent(String(clientId)))
        .replace(`{${'pluginKey'}}`, encodeURIComponent(String(pluginKey)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (until !== undefined) {
        localVarQueryParameter['until'] =
          (until as any) instanceof Date ? (until as any).toISOString() : until
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of all active plugin licenses for a client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listActivePluginLicenses: async (
      clientId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('listActivePluginLicenses', 'clientId', clientId)
      const localVarPath = `/admin/plugins/clients/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of all plugin licenses
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAllPluginLicenses: async (
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/plugins`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminPluginApi - functional programming interface
 * @export
 */
export const AdminPluginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminPluginApiAxiosParamCreator(configuration)
  return {
    /**
     * Disables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disablePlugin(
      clientId: string,
      pluginKey: PluginKey,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PluginLicenseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disablePlugin(
        clientId,
        pluginKey,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminPluginApi.disablePlugin']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Enables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {string} [until]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enablePlugin(
      clientId: string,
      pluginKey: PluginKey,
      until?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PluginLicenseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.enablePlugin(
        clientId,
        pluginKey,
        until,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminPluginApi.enablePlugin']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of all active plugin licenses for a client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listActivePluginLicenses(
      clientId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PluginLicenseDTO>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listActivePluginLicenses(
        clientId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminPluginApi.listActivePluginLicenses']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of all plugin licenses
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAllPluginLicenses(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePluginLicenseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listAllPluginLicenses(
        page,
        size,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminPluginApi.listAllPluginLicenses']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminPluginApi - factory interface
 * @export
 */
export const AdminPluginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminPluginApiFp(configuration)
  return {
    /**
     * Disables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disablePlugin(
      clientId: string,
      pluginKey: PluginKey,
      options?: any
    ): AxiosPromise<PluginLicenseDTO> {
      return localVarFp
        .disablePlugin(clientId, pluginKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Enables a plugin for a client
     * @param {string} clientId
     * @param {PluginKey} pluginKey
     * @param {string} [until]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enablePlugin(
      clientId: string,
      pluginKey: PluginKey,
      until?: string,
      options?: any
    ): AxiosPromise<PluginLicenseDTO> {
      return localVarFp
        .enablePlugin(clientId, pluginKey, until, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of all active plugin licenses for a client
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listActivePluginLicenses(
      clientId: string,
      options?: any
    ): AxiosPromise<Array<PluginLicenseDTO>> {
      return localVarFp
        .listActivePluginLicenses(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of all plugin licenses
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAllPluginLicenses(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<PagePluginLicenseDTO> {
      return localVarFp
        .listAllPluginLicenses(page, size, sort, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminPluginApi - object-oriented interface
 * @export
 * @class AdminPluginApi
 * @extends {BaseAPI}
 */
export class AdminPluginApi extends BaseAPI {
  /**
   * Disables a plugin for a client
   * @param {string} clientId
   * @param {PluginKey} pluginKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminPluginApi
   */
  public disablePlugin(clientId: string, pluginKey: PluginKey, options?: RawAxiosRequestConfig) {
    return AdminPluginApiFp(this.configuration)
      .disablePlugin(clientId, pluginKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Enables a plugin for a client
   * @param {string} clientId
   * @param {PluginKey} pluginKey
   * @param {string} [until]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminPluginApi
   */
  public enablePlugin(
    clientId: string,
    pluginKey: PluginKey,
    until?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AdminPluginApiFp(this.configuration)
      .enablePlugin(clientId, pluginKey, until, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of all active plugin licenses for a client
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminPluginApi
   */
  public listActivePluginLicenses(clientId: string, options?: RawAxiosRequestConfig) {
    return AdminPluginApiFp(this.configuration)
      .listActivePluginLicenses(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of all plugin licenses
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminPluginApi
   */
  public listAllPluginLicenses(
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return AdminPluginApiFp(this.configuration)
      .listAllPluginLicenses(page, size, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminRoutingAuditApi - axios parameter creator
 * @export
 */
export const AdminRoutingAuditApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves a paginated list of consultations managed by Routing V2 for the admin audit panel.
     * @param {string} hospitalId The ID of the hospital to filter consultations by
     * @param {Array<UrgencyDTO>} [urgencies]
     * @param {Array<ConsultationRequestStatusDTO>} [statuses]
     * @param {Array<string>} [specialities]
     * @param {Array<string>} [creators]
     * @param {Array<string>} [patients]
     * @param {string} [createdAtFrom]
     * @param {string} [createdAtTo]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminConsultationsList: async (
      hospitalId: string,
      urgencies?: Array<UrgencyDTO>,
      statuses?: Array<ConsultationRequestStatusDTO>,
      specialities?: Array<string>,
      creators?: Array<string>,
      patients?: Array<string>,
      createdAtFrom?: string,
      createdAtTo?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getAdminConsultationsList', 'hospitalId', hospitalId)
      const localVarPath = `/admin/routing/consultations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      if (urgencies) {
        localVarQueryParameter['urgencies'] = urgencies
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (specialities) {
        localVarQueryParameter['specialities'] = specialities
      }

      if (creators) {
        localVarQueryParameter['creators'] = creators
      }

      if (patients) {
        localVarQueryParameter['patients'] = patients
      }

      if (createdAtFrom !== undefined) {
        localVarQueryParameter['createdAtFrom'] =
          (createdAtFrom as any) instanceof Date
            ? (createdAtFrom as any).toISOString()
            : createdAtFrom
      }

      if (createdAtTo !== undefined) {
        localVarQueryParameter['createdAtTo'] =
          (createdAtTo as any) instanceof Date ? (createdAtTo as any).toISOString() : createdAtTo
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves detailed routing v2 audit information for a specific consultation request.
     * @param {string} consultationRequestId The ID of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminRoutingAuditDetails: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'getAdminRoutingAuditDetails',
        'consultationRequestId',
        consultationRequestId
      )
      const localVarPath = `/admin/routing/consultations/{consultationRequestId}`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves available filter options for routing audit in a given hospital.
     * @param {string} hospitalId The ID of the hospital
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoutingAuditFilterOptions: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getRoutingAuditFilterOptions', 'hospitalId', hospitalId)
      const localVarPath = `/admin/routing/consultations/filters/options`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminRoutingAuditApi - functional programming interface
 * @export
 */
export const AdminRoutingAuditApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminRoutingAuditApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves a paginated list of consultations managed by Routing V2 for the admin audit panel.
     * @param {string} hospitalId The ID of the hospital to filter consultations by
     * @param {Array<UrgencyDTO>} [urgencies]
     * @param {Array<ConsultationRequestStatusDTO>} [statuses]
     * @param {Array<string>} [specialities]
     * @param {Array<string>} [creators]
     * @param {Array<string>} [patients]
     * @param {string} [createdAtFrom]
     * @param {string} [createdAtTo]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAdminConsultationsList(
      hospitalId: string,
      urgencies?: Array<UrgencyDTO>,
      statuses?: Array<ConsultationRequestStatusDTO>,
      specialities?: Array<string>,
      creators?: Array<string>,
      patients?: Array<string>,
      createdAtFrom?: string,
      createdAtTo?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetPaginatedAdminConsultationsRequestsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminConsultationsList(
        hospitalId,
        urgencies,
        statuses,
        specialities,
        creators,
        patients,
        createdAtFrom,
        createdAtTo,
        page,
        size,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminRoutingAuditApi.getAdminConsultationsList']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves detailed routing v2 audit information for a specific consultation request.
     * @param {string} consultationRequestId The ID of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAdminRoutingAuditDetails(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetAdminConsultationRequestDetailsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminRoutingAuditDetails(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminRoutingAuditApi.getAdminRoutingAuditDetails']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves available filter options for routing audit in a given hospital.
     * @param {string} hospitalId The ID of the hospital
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoutingAuditFilterOptions(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoutingAuditFilterOptionsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoutingAuditFilterOptions(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminRoutingAuditApi.getRoutingAuditFilterOptions']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminRoutingAuditApi - factory interface
 * @export
 */
export const AdminRoutingAuditApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminRoutingAuditApiFp(configuration)
  return {
    /**
     * Retrieves a paginated list of consultations managed by Routing V2 for the admin audit panel.
     * @param {string} hospitalId The ID of the hospital to filter consultations by
     * @param {Array<UrgencyDTO>} [urgencies]
     * @param {Array<ConsultationRequestStatusDTO>} [statuses]
     * @param {Array<string>} [specialities]
     * @param {Array<string>} [creators]
     * @param {Array<string>} [patients]
     * @param {string} [createdAtFrom]
     * @param {string} [createdAtTo]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminConsultationsList(
      hospitalId: string,
      urgencies?: Array<UrgencyDTO>,
      statuses?: Array<ConsultationRequestStatusDTO>,
      specialities?: Array<string>,
      creators?: Array<string>,
      patients?: Array<string>,
      createdAtFrom?: string,
      createdAtTo?: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<GetPaginatedAdminConsultationsRequestsResponse> {
      return localVarFp
        .getAdminConsultationsList(
          hospitalId,
          urgencies,
          statuses,
          specialities,
          creators,
          patients,
          createdAtFrom,
          createdAtTo,
          page,
          size,
          sort,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves detailed routing v2 audit information for a specific consultation request.
     * @param {string} consultationRequestId The ID of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminRoutingAuditDetails(
      consultationRequestId: string,
      options?: any
    ): AxiosPromise<GetAdminConsultationRequestDetailsResponse> {
      return localVarFp
        .getAdminRoutingAuditDetails(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves available filter options for routing audit in a given hospital.
     * @param {string} hospitalId The ID of the hospital
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoutingAuditFilterOptions(
      hospitalId: string,
      options?: any
    ): AxiosPromise<RoutingAuditFilterOptionsResponse> {
      return localVarFp
        .getRoutingAuditFilterOptions(hospitalId, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminRoutingAuditApi - object-oriented interface
 * @export
 * @class AdminRoutingAuditApi
 * @extends {BaseAPI}
 */
export class AdminRoutingAuditApi extends BaseAPI {
  /**
   * Retrieves a paginated list of consultations managed by Routing V2 for the admin audit panel.
   * @param {string} hospitalId The ID of the hospital to filter consultations by
   * @param {Array<UrgencyDTO>} [urgencies]
   * @param {Array<ConsultationRequestStatusDTO>} [statuses]
   * @param {Array<string>} [specialities]
   * @param {Array<string>} [creators]
   * @param {Array<string>} [patients]
   * @param {string} [createdAtFrom]
   * @param {string} [createdAtTo]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminRoutingAuditApi
   */
  public getAdminConsultationsList(
    hospitalId: string,
    urgencies?: Array<UrgencyDTO>,
    statuses?: Array<ConsultationRequestStatusDTO>,
    specialities?: Array<string>,
    creators?: Array<string>,
    patients?: Array<string>,
    createdAtFrom?: string,
    createdAtTo?: string,
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return AdminRoutingAuditApiFp(this.configuration)
      .getAdminConsultationsList(
        hospitalId,
        urgencies,
        statuses,
        specialities,
        creators,
        patients,
        createdAtFrom,
        createdAtTo,
        page,
        size,
        sort,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves detailed routing v2 audit information for a specific consultation request.
   * @param {string} consultationRequestId The ID of the consultation request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminRoutingAuditApi
   */
  public getAdminRoutingAuditDetails(
    consultationRequestId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AdminRoutingAuditApiFp(this.configuration)
      .getAdminRoutingAuditDetails(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves available filter options for routing audit in a given hospital.
   * @param {string} hospitalId The ID of the hospital
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminRoutingAuditApi
   */
  public getRoutingAuditFilterOptions(hospitalId: string, options?: RawAxiosRequestConfig) {
    return AdminRoutingAuditApiFp(this.configuration)
      .getRoutingAuditFilterOptions(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminUserApi - axios parameter creator
 * @export
 */
export const AdminUserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Archives a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveUser: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('archiveUser', 'encodedUserName', encodedUserName)
      const localVarPath = `/admin/user/{encodedUserName}/archive`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates a User object
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (
      userDetailsDTO: UserDetailsDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userDetailsDTO' is not null or undefined
      assertParamExists('createUser', 'userDetailsDTO', userDetailsDTO)
      const localVarPath = `/admin/user`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userDetailsDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of all User objects
     * @param {boolean} [archived] defines if archived or not archived users should be fetched
     * @param {string} [hospitalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers: async (
      archived?: boolean,
      hospitalId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/admin/user`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (archived !== undefined) {
        localVarQueryParameter['archived'] = archived
      }

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Triggers sending of a password reset email for the specified user
     * @param {string} encodedUserName Base64-encoded username of the user to whom the reset email should be sent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendResetPasswordEmail: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('sendResetPasswordEmail', 'encodedUserName', encodedUserName)
      const localVarPath = `/admin/user/{encodedUserName}/reset-password-email`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Allows or disallows user to create patients
     * @param {string} encodedUserName Base64 encoded username of the user that should be modified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleUserCanCreatePatients: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('toggleUserCanCreatePatients', 'encodedUserName', encodedUserName)
      const localVarPath = `/admin/user/{encodedUserName}/toggle-can-create-patients`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Enables or disables a User
     * @param {string} encodedUserName Base64 encoded username of the user that should be enabled/disabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleUserEnabled: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('toggleUserEnabled', 'encodedUserName', encodedUserName)
      const localVarPath = `/admin/user/{encodedUserName}/toggle-enabled`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be updated
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (
      encodedUserName: string,
      userDetailsDTO: UserDetailsDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('updateUser', 'encodedUserName', encodedUserName)
      // verify required parameter 'userDetailsDTO' is not null or undefined
      assertParamExists('updateUser', 'userDetailsDTO', userDetailsDTO)
      const localVarPath = `/admin/user/{encodedUserName}`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userDetailsDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminUserApi - functional programming interface
 * @export
 */
export const AdminUserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminUserApiAxiosParamCreator(configuration)
  return {
    /**
     * Archives a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveUser(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.archiveUser(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.archiveUser']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates a User object
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(
      userDetailsDTO: UserDetailsDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(userDetailsDTO, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.createUser']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of all User objects
     * @param {boolean} [archived] defines if archived or not archived users should be fetched
     * @param {string} [hospitalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUsers(
      archived?: boolean,
      hospitalId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUsersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(
        archived,
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.listUsers']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Triggers sending of a password reset email for the specified user
     * @param {string} encodedUserName Base64-encoded username of the user to whom the reset email should be sent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendResetPasswordEmail(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendResetPasswordEmail(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.sendResetPasswordEmail']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Allows or disallows user to create patients
     * @param {string} encodedUserName Base64 encoded username of the user that should be modified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleUserCanCreatePatients(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleUserCanCreatePatients(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.toggleUserCanCreatePatients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Enables or disables a User
     * @param {string} encodedUserName Base64 encoded username of the user that should be enabled/disabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleUserEnabled(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.toggleUserEnabled(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.toggleUserEnabled']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be updated
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(
      encodedUserName: string,
      userDetailsDTO: UserDetailsDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(
        encodedUserName,
        userDetailsDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminUserApi.updateUser']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminUserApi - factory interface
 * @export
 */
export const AdminUserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminUserApiFp(configuration)
  return {
    /**
     * Archives a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be archived
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveUser(encodedUserName: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .archiveUser(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates a User object
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(userDetailsDTO: UserDetailsDTO, options?: any): AxiosPromise<void> {
      return localVarFp
        .createUser(userDetailsDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of all User objects
     * @param {boolean} [archived] defines if archived or not archived users should be fetched
     * @param {string} [hospitalId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(
      archived?: boolean,
      hospitalId?: string,
      options?: any
    ): AxiosPromise<ListUsersResponse> {
      return localVarFp
        .listUsers(archived, hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Triggers sending of a password reset email for the specified user
     * @param {string} encodedUserName Base64-encoded username of the user to whom the reset email should be sent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendResetPasswordEmail(encodedUserName: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .sendResetPasswordEmail(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Allows or disallows user to create patients
     * @param {string} encodedUserName Base64 encoded username of the user that should be modified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleUserCanCreatePatients(encodedUserName: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .toggleUserCanCreatePatients(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Enables or disables a User
     * @param {string} encodedUserName Base64 encoded username of the user that should be enabled/disabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleUserEnabled(encodedUserName: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .toggleUserEnabled(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a User object
     * @param {string} encodedUserName Base64 encoded username of the user that should be updated
     * @param {UserDetailsDTO} userDetailsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      encodedUserName: string,
      userDetailsDTO: UserDetailsDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateUser(encodedUserName, userDetailsDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminUserApi - object-oriented interface
 * @export
 * @class AdminUserApi
 * @extends {BaseAPI}
 */
export class AdminUserApi extends BaseAPI {
  /**
   * Archives a User object
   * @param {string} encodedUserName Base64 encoded username of the user that should be archived
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public archiveUser(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .archiveUser(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates a User object
   * @param {UserDetailsDTO} userDetailsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public createUser(userDetailsDTO: UserDetailsDTO, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .createUser(userDetailsDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of all User objects
   * @param {boolean} [archived] defines if archived or not archived users should be fetched
   * @param {string} [hospitalId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public listUsers(archived?: boolean, hospitalId?: string, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .listUsers(archived, hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Triggers sending of a password reset email for the specified user
   * @param {string} encodedUserName Base64-encoded username of the user to whom the reset email should be sent
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public sendResetPasswordEmail(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .sendResetPasswordEmail(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Allows or disallows user to create patients
   * @param {string} encodedUserName Base64 encoded username of the user that should be modified
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public toggleUserCanCreatePatients(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .toggleUserCanCreatePatients(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Enables or disables a User
   * @param {string} encodedUserName Base64 encoded username of the user that should be enabled/disabled
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public toggleUserEnabled(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return AdminUserApiFp(this.configuration)
      .toggleUserEnabled(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a User object
   * @param {string} encodedUserName Base64 encoded username of the user that should be updated
   * @param {UserDetailsDTO} userDetailsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminUserApi
   */
  public updateUser(
    encodedUserName: string,
    userDetailsDTO: UserDetailsDTO,
    options?: RawAxiosRequestConfig
  ) {
    return AdminUserApiFp(this.configuration)
      .updateUser(encodedUserName, userDetailsDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdminWardApi - axios parameter creator
 * @export
 */
export const AdminWardApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates multiple Ward objects
     * @param {CreateWardsRequest} createWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWards: async (
      createWardsRequest: CreateWardsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createWardsRequest' is not null or undefined
      assertParamExists('createWards', 'createWardsRequest', createWardsRequest)
      const localVarPath = `/admin/ward`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createWardsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AdminWardApi - functional programming interface
 * @export
 */
export const AdminWardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminWardApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates multiple Ward objects
     * @param {CreateWardsRequest} createWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWards(
      createWardsRequest: CreateWardsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createWards(
        createWardsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdminWardApi.createWards']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AdminWardApi - factory interface
 * @export
 */
export const AdminWardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminWardApiFp(configuration)
  return {
    /**
     * Creates multiple Ward objects
     * @param {CreateWardsRequest} createWardsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createWards(createWardsRequest: CreateWardsRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .createWards(createWardsRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AdminWardApi - object-oriented interface
 * @export
 * @class AdminWardApi
 * @extends {BaseAPI}
 */
export class AdminWardApi extends BaseAPI {
  /**
   * Creates multiple Ward objects
   * @param {CreateWardsRequest} createWardsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminWardApi
   */
  public createWards(createWardsRequest: CreateWardsRequest, options?: RawAxiosRequestConfig) {
    return AdminWardApiFp(this.configuration)
      .createWards(createWardsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AkiOverviewControllerApi - axios parameter creator
 * @export
 */
export const AkiOverviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves the self-contained payload for the Patient AKI Detail Infobox of one case: patient demographics, AKI risk and last-update time, vital parameters, AKI-related laboratory samples and organ support indicators.
     * @summary Get AKI Detail Infobox for a single case
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAkiInfoPanel: async (
      caseId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getAkiInfoPanel', 'caseId', caseId)
      const localVarPath = `/aki/prediction/{caseId}/panel`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves aggregated summary data and paginated detailed AKI prediction results for the currently authenticated clinician.
     * @summary Get AKI Overview for Clinician
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAkiOverview: async (
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/aki/prediction/overview`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AkiOverviewControllerApi - functional programming interface
 * @export
 */
export const AkiOverviewControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AkiOverviewControllerApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves the self-contained payload for the Patient AKI Detail Infobox of one case: patient demographics, AKI risk and last-update time, vital parameters, AKI-related laboratory samples and organ support indicators.
     * @summary Get AKI Detail Infobox for a single case
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAkiInfoPanel(
      caseId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AkiInfoPanelDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAkiInfoPanel(caseId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AkiOverviewControllerApi.getAkiInfoPanel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves aggregated summary data and paginated detailed AKI prediction results for the currently authenticated clinician.
     * @summary Get AKI Overview for Clinician
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAkiOverview(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AkiOverviewResponseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAkiOverview(
        page,
        size,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AkiOverviewControllerApi.getAkiOverview']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AkiOverviewControllerApi - factory interface
 * @export
 */
export const AkiOverviewControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AkiOverviewControllerApiFp(configuration)
  return {
    /**
     * Retrieves the self-contained payload for the Patient AKI Detail Infobox of one case: patient demographics, AKI risk and last-update time, vital parameters, AKI-related laboratory samples and organ support indicators.
     * @summary Get AKI Detail Infobox for a single case
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAkiInfoPanel(caseId: string, options?: any): AxiosPromise<AkiInfoPanelDTO> {
      return localVarFp.getAkiInfoPanel(caseId, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieves aggregated summary data and paginated detailed AKI prediction results for the currently authenticated clinician.
     * @summary Get AKI Overview for Clinician
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAkiOverview(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<AkiOverviewResponseDTO> {
      return localVarFp
        .getAkiOverview(page, size, sort, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AkiOverviewControllerApi - object-oriented interface
 * @export
 * @class AkiOverviewControllerApi
 * @extends {BaseAPI}
 */
export class AkiOverviewControllerApi extends BaseAPI {
  /**
   * Retrieves the self-contained payload for the Patient AKI Detail Infobox of one case: patient demographics, AKI risk and last-update time, vital parameters, AKI-related laboratory samples and organ support indicators.
   * @summary Get AKI Detail Infobox for a single case
   * @param {string} caseId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AkiOverviewControllerApi
   */
  public getAkiInfoPanel(caseId: string, options?: RawAxiosRequestConfig) {
    return AkiOverviewControllerApiFp(this.configuration)
      .getAkiInfoPanel(caseId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves aggregated summary data and paginated detailed AKI prediction results for the currently authenticated clinician.
   * @summary Get AKI Overview for Clinician
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AkiOverviewControllerApi
   */
  public getAkiOverview(
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return AkiOverviewControllerApiFp(this.configuration)
      .getAkiOverview(page, size, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AuditApi - axios parameter creator
 * @export
 */
export const AuditApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves Audit for Consultation Requests
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {ConsultationAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    auditConsultationRequests: async (
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: ConsultationAuditSort,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('auditConsultationRequests', 'hospitalId', hospitalId)
      const localVarPath = `/audit/consultation-request/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (sort !== undefined) {
        for (const [key, value] of Object.entries(sort)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves Audit for Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {HospitalAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    auditHospitalEscalationSettings: async (
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: HospitalAuditSort,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('auditHospitalEscalationSettings', 'hospitalId', hospitalId)
      const localVarPath = `/audit/hospital-settings/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (sort !== undefined) {
        for (const [key, value] of Object.entries(sort)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AuditApi - functional programming interface
 * @export
 */
export const AuditApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuditApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves Audit for Consultation Requests
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {ConsultationAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async auditConsultationRequests(
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: ConsultationAuditSort,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditResponseConsultationAudit>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.auditConsultationRequests(
        hospitalId,
        limit,
        offset,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuditApi.auditConsultationRequests']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves Audit for Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {HospitalAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async auditHospitalEscalationSettings(
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: HospitalAuditSort,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuditResponseHospitalEscalationAudit>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.auditHospitalEscalationSettings(
        hospitalId,
        limit,
        offset,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuditApi.auditHospitalEscalationSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AuditApi - factory interface
 * @export
 */
export const AuditApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuditApiFp(configuration)
  return {
    /**
     * Retrieves Audit for Consultation Requests
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {ConsultationAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    auditConsultationRequests(
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: ConsultationAuditSort,
      options?: any
    ): AxiosPromise<AuditResponseConsultationAudit> {
      return localVarFp
        .auditConsultationRequests(hospitalId, limit, offset, sort, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves Audit for Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {HospitalAuditSort} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    auditHospitalEscalationSettings(
      hospitalId: string,
      limit?: number,
      offset?: number,
      sort?: HospitalAuditSort,
      options?: any
    ): AxiosPromise<AuditResponseHospitalEscalationAudit> {
      return localVarFp
        .auditHospitalEscalationSettings(hospitalId, limit, offset, sort, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * AuditApi - object-oriented interface
 * @export
 * @class AuditApi
 * @extends {BaseAPI}
 */
export class AuditApi extends BaseAPI {
  /**
   * Retrieves Audit for Consultation Requests
   * @param {string} hospitalId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {ConsultationAuditSort} [sort]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuditApi
   */
  public auditConsultationRequests(
    hospitalId: string,
    limit?: number,
    offset?: number,
    sort?: ConsultationAuditSort,
    options?: RawAxiosRequestConfig
  ) {
    return AuditApiFp(this.configuration)
      .auditConsultationRequests(hospitalId, limit, offset, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves Audit for Hospital Escalation Settings
   * @param {string} hospitalId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {HospitalAuditSort} [sort]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuditApi
   */
  public auditHospitalEscalationSettings(
    hospitalId: string,
    limit?: number,
    offset?: number,
    sort?: HospitalAuditSort,
    options?: RawAxiosRequestConfig
  ) {
    return AuditApiFp(this.configuration)
      .auditHospitalEscalationSettings(hospitalId, limit, offset, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * BloodGasApi - axios parameter creator
 * @export
 */
export const BloodGasApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves blood gas data for given period of time
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBloodGas: async (
      caseId: string,
      types: Array<BloodGasTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getBloodGas', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getBloodGas', 'types', types)
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists('getBloodGas', 'startTime', startTime)
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists('getBloodGas', 'endTime', endTime)
      const localVarPath = `/blood-gas/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (startTime !== undefined) {
        localVarQueryParameter['startTime'] =
          (startTime as any) instanceof Date ? (startTime as any).toISOString() : startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['endTime'] =
          (endTime as any) instanceof Date ? (endTime as any).toISOString() : endTime
      }

      if (samplingMinutes !== undefined) {
        localVarQueryParameter['samplingMinutes'] = samplingMinutes
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves all blood gas data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {string} [shareCode]
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBloodGasInPeriod: async (
      caseId: string,
      period: VitalsPeriod,
      shareCode?: string,
      typeKeyLike?: VitalSignTypeKeyLike,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getBloodGasInPeriod', 'caseId', caseId)
      // verify required parameter 'period' is not null or undefined
      assertParamExists('getBloodGasInPeriod', 'period', period)
      const localVarPath = `/blood-gas-in-period/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      if (typeKeyLike !== undefined) {
        for (const [key, value] of Object.entries(typeKeyLike)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves latest values for the selected blood gas vital signs
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestBloodGas: async (
      caseId: string,
      types: Array<BloodGasTypeKey>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLatestBloodGas', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getLatestBloodGas', 'types', types)
      const localVarPath = `/blood-gas/{caseId}/latest`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * BloodGasApi - functional programming interface
 * @export
 */
export const BloodGasApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BloodGasApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves blood gas data for given period of time
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBloodGas(
      caseId: string,
      types: Array<BloodGasTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaginatedVitalSignsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBloodGas(
        caseId,
        types,
        startTime,
        endTime,
        samplingMinutes,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BloodGasApi.getBloodGas']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves all blood gas data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {string} [shareCode]
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBloodGasInPeriod(
      caseId: string,
      period: VitalsPeriod,
      shareCode?: string,
      typeKeyLike?: VitalSignTypeKeyLike,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBloodGasInPeriod(
        caseId,
        period,
        shareCode,
        typeKeyLike,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BloodGasApi.getBloodGasInPeriod']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves latest values for the selected blood gas vital signs
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestBloodGas(
      caseId: string,
      types: Array<BloodGasTypeKey>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestBloodGas(
        caseId,
        types,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['BloodGasApi.getLatestBloodGas']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * BloodGasApi - factory interface
 * @export
 */
export const BloodGasApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BloodGasApiFp(configuration)
  return {
    /**
     * Retrieves blood gas data for given period of time
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBloodGas(
      caseId: string,
      types: Array<BloodGasTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      options?: any
    ): AxiosPromise<GetPaginatedVitalSignsResponse> {
      return localVarFp
        .getBloodGas(caseId, types, startTime, endTime, samplingMinutes, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves all blood gas data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {string} [shareCode]
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBloodGasInPeriod(
      caseId: string,
      period: VitalsPeriod,
      shareCode?: string,
      typeKeyLike?: VitalSignTypeKeyLike,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getBloodGasInPeriod(caseId, period, shareCode, typeKeyLike, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves latest values for the selected blood gas vital signs
     * @param {string} caseId
     * @param {Array<BloodGasTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestBloodGas(
      caseId: string,
      types: Array<BloodGasTypeKey>,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getLatestBloodGas(caseId, types, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * BloodGasApi - object-oriented interface
 * @export
 * @class BloodGasApi
 * @extends {BaseAPI}
 */
export class BloodGasApi extends BaseAPI {
  /**
   * Retrieves blood gas data for given period of time
   * @param {string} caseId
   * @param {Array<BloodGasTypeKey>} types
   * @param {string} startTime
   * @param {string} endTime
   * @param {number} [samplingMinutes]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BloodGasApi
   */
  public getBloodGas(
    caseId: string,
    types: Array<BloodGasTypeKey>,
    startTime: string,
    endTime: string,
    samplingMinutes?: number,
    options?: RawAxiosRequestConfig
  ) {
    return BloodGasApiFp(this.configuration)
      .getBloodGas(caseId, types, startTime, endTime, samplingMinutes, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves all blood gas data for a predefined period
   * @param {string} caseId
   * @param {VitalsPeriod} period
   * @param {string} [shareCode]
   * @param {VitalSignTypeKeyLike} [typeKeyLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BloodGasApi
   */
  public getBloodGasInPeriod(
    caseId: string,
    period: VitalsPeriod,
    shareCode?: string,
    typeKeyLike?: VitalSignTypeKeyLike,
    options?: RawAxiosRequestConfig
  ) {
    return BloodGasApiFp(this.configuration)
      .getBloodGasInPeriod(caseId, period, shareCode, typeKeyLike, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves latest values for the selected blood gas vital signs
   * @param {string} caseId
   * @param {Array<BloodGasTypeKey>} types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BloodGasApi
   */
  public getLatestBloodGas(
    caseId: string,
    types: Array<BloodGasTypeKey>,
    options?: RawAxiosRequestConfig
  ) {
    return BloodGasApiFp(this.configuration)
      .getLatestBloodGas(caseId, types, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * CaseApi - axios parameter creator
 * @export
 */
export const CaseApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Creates an emergency for a Case.
     * @param {string} caseId ID of the case where the emergency occurred
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmergency: async (
      caseId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('createEmergency', 'caseId', caseId)
      const localVarPath = `/case/{caseId}/emergency`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a Case object.
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCase: async (
      caseId: string,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getCase', 'caseId', caseId)
      const localVarPath = `/case/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of Case objects.
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCases: async (
      offset: number,
      limit: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'offset' is not null or undefined
      assertParamExists('getCases', 'offset', offset)
      // verify required parameter 'limit' is not null or undefined
      assertParamExists('getCases', 'limit', limit)
      const localVarPath = `/case`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a paginated list of Case objects with their vital signs.
     * @param {CasesWithVitalSignsFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesWithVitalSigns: async (
      filterDTO: CasesWithVitalSignsFilterDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filterDTO' is not null or undefined
      assertParamExists('getCasesWithVitalSigns', 'filterDTO', filterDTO)
      const localVarPath = `/case-with-vital-signs`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (filterDTO !== undefined) {
        for (const [key, value] of Object.entries(filterDTO)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves the hospitals, departments and wards available as patient-list filter options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesWithVitalSignsFilterOptions: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/case-with-vital-signs/filter-options`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * CaseApi - functional programming interface
 * @export
 */
export const CaseApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CaseApiAxiosParamCreator(configuration)
  return {
    /**
     * Creates an emergency for a Case.
     * @param {string} caseId ID of the case where the emergency occurred
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEmergency(
      caseId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEmergency(caseId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CaseApi.createEmergency']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a Case object.
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCase(
      caseId: string,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCaseResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCase(caseId, shareCode, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CaseApi.getCase']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of Case objects.
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCases(
      offset: number,
      limit: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCasesResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCases(offset, limit, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CaseApi.getCases']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a paginated list of Case objects with their vital signs.
     * @param {CasesWithVitalSignsFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCasesWithVitalSigns(
      filterDTO: CasesWithVitalSignsFilterDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedResponseCaseWithVitalSignsDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCasesWithVitalSigns(
        filterDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CaseApi.getCasesWithVitalSigns']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves the hospitals, departments and wards available as patient-list filter options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCasesWithVitalSignsFilterOptions(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CasesWithVitalSignsFilterOptionsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCasesWithVitalSignsFilterOptions(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CaseApi.getCasesWithVitalSignsFilterOptions']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * CaseApi - factory interface
 * @export
 */
export const CaseApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CaseApiFp(configuration)
  return {
    /**
     * Creates an emergency for a Case.
     * @param {string} caseId ID of the case where the emergency occurred
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmergency(caseId: string, options?: any): AxiosPromise<void> {
      return localVarFp.createEmergency(caseId, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a Case object.
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCase(caseId: string, shareCode?: string, options?: any): AxiosPromise<GetCaseResponse> {
      return localVarFp
        .getCase(caseId, shareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of Case objects.
     * @param {number} offset page offset
     * @param {number} limit page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCases(offset: number, limit: number, options?: any): AxiosPromise<GetCasesResponse> {
      return localVarFp.getCases(offset, limit, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a paginated list of Case objects with their vital signs.
     * @param {CasesWithVitalSignsFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesWithVitalSigns(
      filterDTO: CasesWithVitalSignsFilterDTO,
      options?: any
    ): AxiosPromise<PaginatedResponseCaseWithVitalSignsDTO> {
      return localVarFp
        .getCasesWithVitalSigns(filterDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves the hospitals, departments and wards available as patient-list filter options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCasesWithVitalSignsFilterOptions(
      options?: any
    ): AxiosPromise<CasesWithVitalSignsFilterOptionsResponse> {
      return localVarFp
        .getCasesWithVitalSignsFilterOptions(options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * CaseApi - object-oriented interface
 * @export
 * @class CaseApi
 * @extends {BaseAPI}
 */
export class CaseApi extends BaseAPI {
  /**
   * Creates an emergency for a Case.
   * @param {string} caseId ID of the case where the emergency occurred
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CaseApi
   */
  public createEmergency(caseId: string, options?: RawAxiosRequestConfig) {
    return CaseApiFp(this.configuration)
      .createEmergency(caseId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a Case object.
   * @param {string} caseId
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CaseApi
   */
  public getCase(caseId: string, shareCode?: string, options?: RawAxiosRequestConfig) {
    return CaseApiFp(this.configuration)
      .getCase(caseId, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of Case objects.
   * @param {number} offset page offset
   * @param {number} limit page limit
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CaseApi
   */
  public getCases(offset: number, limit: number, options?: RawAxiosRequestConfig) {
    return CaseApiFp(this.configuration)
      .getCases(offset, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a paginated list of Case objects with their vital signs.
   * @param {CasesWithVitalSignsFilterDTO} filterDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CaseApi
   */
  public getCasesWithVitalSigns(
    filterDTO: CasesWithVitalSignsFilterDTO,
    options?: RawAxiosRequestConfig
  ) {
    return CaseApiFp(this.configuration)
      .getCasesWithVitalSigns(filterDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves the hospitals, departments and wards available as patient-list filter options.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CaseApi
   */
  public getCasesWithVitalSignsFilterOptions(options?: RawAxiosRequestConfig) {
    return CaseApiFp(this.configuration)
      .getCasesWithVitalSignsFilterOptions(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ConsultationFieldApi - axios parameter creator
 * @export
 */
export const ConsultationFieldApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves all custom consultation fields matching given criteria
     * @param {CustomFieldConsultationTypeDTO} consultationType
     * @param {Array<string>} clientIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomConsultationFieldsByConsultationTypeAndClients: async (
      consultationType: CustomFieldConsultationTypeDTO,
      clientIds: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationType' is not null or undefined
      assertParamExists(
        'getCustomConsultationFieldsByConsultationTypeAndClients',
        'consultationType',
        consultationType
      )
      // verify required parameter 'clientIds' is not null or undefined
      assertParamExists(
        'getCustomConsultationFieldsByConsultationTypeAndClients',
        'clientIds',
        clientIds
      )
      const localVarPath = `/consultation-field`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (consultationType !== undefined) {
        localVarQueryParameter['consultationType'] = consultationType
      }

      if (clientIds) {
        localVarQueryParameter['clientIds'] = clientIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ConsultationFieldApi - functional programming interface
 * @export
 */
export const ConsultationFieldApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ConsultationFieldApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves all custom consultation fields matching given criteria
     * @param {CustomFieldConsultationTypeDTO} consultationType
     * @param {Array<string>} clientIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCustomConsultationFieldsByConsultationTypeAndClients(
      consultationType: CustomFieldConsultationTypeDTO,
      clientIds: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomConsultationFieldDTO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCustomConsultationFieldsByConsultationTypeAndClients(
          consultationType,
          clientIds,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'ConsultationFieldApi.getCustomConsultationFieldsByConsultationTypeAndClients'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ConsultationFieldApi - factory interface
 * @export
 */
export const ConsultationFieldApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ConsultationFieldApiFp(configuration)
  return {
    /**
     * Retrieves all custom consultation fields matching given criteria
     * @param {CustomFieldConsultationTypeDTO} consultationType
     * @param {Array<string>} clientIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCustomConsultationFieldsByConsultationTypeAndClients(
      consultationType: CustomFieldConsultationTypeDTO,
      clientIds: Array<string>,
      options?: any
    ): AxiosPromise<Array<CustomConsultationFieldDTO>> {
      return localVarFp
        .getCustomConsultationFieldsByConsultationTypeAndClients(
          consultationType,
          clientIds,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ConsultationFieldApi - object-oriented interface
 * @export
 * @class ConsultationFieldApi
 * @extends {BaseAPI}
 */
export class ConsultationFieldApi extends BaseAPI {
  /**
   * Retrieves all custom consultation fields matching given criteria
   * @param {CustomFieldConsultationTypeDTO} consultationType
   * @param {Array<string>} clientIds
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationFieldApi
   */
  public getCustomConsultationFieldsByConsultationTypeAndClients(
    consultationType: CustomFieldConsultationTypeDTO,
    clientIds: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationFieldApiFp(this.configuration)
      .getCustomConsultationFieldsByConsultationTypeAndClients(consultationType, clientIds, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ConsultationRequestApi - axios parameter creator
 * @export
 */
export const ConsultationRequestApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Accepts a Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptConsultationRequest: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists('acceptConsultationRequest', 'consultationRequestId', consultationRequestId)
      const localVarPath = `/consultation-request/{consultationRequestId}/accept`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Checks if any physician is available in the specified medical field for the hospital associated with the given case.
     * @param {string} medicalFieldId The ID of the medical field
     * @param {string} caseId The ID of the patient case, used to determine the hospital
     * @param {UrgencyDTO} urgency The urgency of the planned consultation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkDoctorAvailability: async (
      medicalFieldId: string,
      caseId: string,
      urgency: UrgencyDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'medicalFieldId' is not null or undefined
      assertParamExists('checkDoctorAvailability', 'medicalFieldId', medicalFieldId)
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('checkDoctorAvailability', 'caseId', caseId)
      // verify required parameter 'urgency' is not null or undefined
      assertParamExists('checkDoctorAvailability', 'urgency', urgency)
      const localVarPath = `/consultation-request/doctor-availability`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (medicalFieldId !== undefined) {
        localVarQueryParameter['medicalFieldId'] = medicalFieldId
      }

      if (caseId !== undefined) {
        localVarQueryParameter['caseId'] = caseId
      }

      if (urgency !== undefined) {
        localVarQueryParameter['urgency'] = urgency
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates a Consultation Request object
     * @param {ConsultationRequestCreationDTO} consultationRequestCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConsultationRequest: async (
      consultationRequestCreationDTO: ConsultationRequestCreationDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestCreationDTO' is not null or undefined
      assertParamExists(
        'createConsultationRequest',
        'consultationRequestCreationDTO',
        consultationRequestCreationDTO
      )
      const localVarPath = `/consultation-request`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        consultationRequestCreationDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Declines a consultation request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineConsultationRequest: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'declineConsultationRequest',
        'consultationRequestId',
        consultationRequestId
      )
      const localVarPath = `/consultation-request/{consultationRequestId}/decline`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Deletes a Consultation Request object
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteConsultationRequest: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists('deleteConsultationRequest', 'consultationRequestId', consultationRequestId)
      const localVarPath = `/consultation-request/{consultationRequestId}`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Ends a Call for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    endCall: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists('endCall', 'consultationRequestId', consultationRequestId)
      const localVarPath = `/consultation-request/{consultationRequestId}/call`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a filtered list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {FilteringOptions} [filteringOptions] Optional filtering options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findCompletedConsultationRequests: async (
      page?: number,
      size?: number,
      sort?: Array<string>,
      filteringOptions?: FilteringOptions,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/completed-consultation-request`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        filteringOptions,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves consultation requests based on the specified filters
     * @param {ConsultationRequestFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findConsultationRequestsByFilter: async (
      filterDTO: ConsultationRequestFilterDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filterDTO' is not null or undefined
      assertParamExists('findConsultationRequestsByFilter', 'filterDTO', filterDTO)
      const localVarPath = `/consultation-request/filter`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (filterDTO !== undefined) {
        for (const [key, value] of Object.entries(filterDTO)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves the distinct patients associated with user\'s completed consultations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompletedConsultationPatients: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/completed-consultation-request/patients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompletedConsultationRequests: async (
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/completed-consultation-request`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a report for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConsultationRequestReport: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'getConsultationRequestReport',
        'consultationRequestId',
        consultationRequestId
      )
      const localVarPath = `/consultation-request/{consultationRequestId}/report`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a share code for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConsultationRequestShareCode: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'getConsultationRequestShareCode',
        'consultationRequestId',
        consultationRequestId
      )
      const localVarPath = `/consultation-request/{consultationRequestId}/share-code`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of consultation requests incoming to the authenticated user
     * @param {Array<UrgencyDTO>} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIncomingConsultationRequests: async (
      urgency: Array<UrgencyDTO>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'urgency' is not null or undefined
      assertParamExists('getIncomingConsultationRequests', 'urgency', urgency)
      const localVarPath = `/incoming-consultation-request`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (urgency) {
        localVarQueryParameter['urgency'] = urgency
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of consultation requests going out from the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOutgoingConsultationRequests: async (
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/outgoing-consultation-request`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Starts a call or retrieves call access for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinCall: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists('joinCall', 'consultationRequestId', consultationRequestId)
      const localVarPath = `/consultation-request/{consultationRequestId}/call`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Joins a Call for the Consultation Request with share code
     * @param {string} consultationShareCode The share code of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinConsultationRequestWithShareCode: async (
      consultationShareCode: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationShareCode' is not null or undefined
      assertParamExists(
        'joinConsultationRequestWithShareCode',
        'consultationShareCode',
        consultationShareCode
      )
      const localVarPath =
        `/consultation-request/join-with-share-code/{consultationShareCode}`.replace(
          `{${'consultationShareCode'}}`,
          encodeURIComponent(String(consultationShareCode))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Adds a report for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {ConsultationRequestReportDTO} consultationRequestReportDTO
     * @param {boolean} [finalize] True if the consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putConsultationRequestReport: async (
      consultationRequestId: string,
      consultationRequestReportDTO: ConsultationRequestReportDTO,
      finalize?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'putConsultationRequestReport',
        'consultationRequestId',
        consultationRequestId
      )
      // verify required parameter 'consultationRequestReportDTO' is not null or undefined
      assertParamExists(
        'putConsultationRequestReport',
        'consultationRequestReportDTO',
        consultationRequestReportDTO
      )
      const localVarPath = `/consultation-request/{consultationRequestId}/report`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (finalize !== undefined) {
        localVarQueryParameter['finalize'] = finalize
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        consultationRequestReportDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ConsultationRequestApi - functional programming interface
 * @export
 */
export const ConsultationRequestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ConsultationRequestApiAxiosParamCreator(configuration)
  return {
    /**
     * Accepts a Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptConsultationRequest(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.acceptConsultationRequest(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.acceptConsultationRequest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Checks if any physician is available in the specified medical field for the hospital associated with the given case.
     * @param {string} medicalFieldId The ID of the medical field
     * @param {string} caseId The ID of the patient case, used to determine the hospital
     * @param {UrgencyDTO} urgency The urgency of the planned consultation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkDoctorAvailability(
      medicalFieldId: string,
      caseId: string,
      urgency: UrgencyDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkDoctorAvailability(
        medicalFieldId,
        caseId,
        urgency,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.checkDoctorAvailability']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates a Consultation Request object
     * @param {ConsultationRequestCreationDTO} consultationRequestCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createConsultationRequest(
      consultationRequestCreationDTO: ConsultationRequestCreationDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createConsultationRequest(
        consultationRequestCreationDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.createConsultationRequest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Declines a consultation request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async declineConsultationRequest(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.declineConsultationRequest(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.declineConsultationRequest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Deletes a Consultation Request object
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteConsultationRequest(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConsultationRequest(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.deleteConsultationRequest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Ends a Call for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async endCall(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.endCall(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.endCall']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a filtered list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {FilteringOptions} [filteringOptions] Optional filtering options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findCompletedConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      filteringOptions?: FilteringOptions,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedResponseConsultationSummaryDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findCompletedConsultationRequests(
        page,
        size,
        sort,
        filteringOptions,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.findCompletedConsultationRequests']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves consultation requests based on the specified filters
     * @param {ConsultationRequestFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findConsultationRequestsByFilter(
      filterDTO: ConsultationRequestFilterDTO,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetConsultationRequestsWithCaseResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findConsultationRequestsByFilter(
        filterDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.findConsultationRequestsByFilter']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves the distinct patients associated with user\'s completed consultations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompletedConsultationPatients(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CompletedConsultationPatientsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCompletedConsultationPatients(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getCompletedConsultationPatients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompletedConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PaginatedResponseConsultationSummaryDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCompletedConsultationRequests(
        page,
        size,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getCompletedConsultationRequests']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a report for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConsultationRequestReport(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetConsultationRequestReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConsultationRequestReport(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getConsultationRequestReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a share code for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConsultationRequestShareCode(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetConsultationRequestShareCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConsultationRequestShareCode(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getConsultationRequestShareCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of consultation requests incoming to the authenticated user
     * @param {Array<UrgencyDTO>} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIncomingConsultationRequests(
      urgency: Array<UrgencyDTO>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetPaginatedConsultationsRequestsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getIncomingConsultationRequests(
        urgency,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getIncomingConsultationRequests']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of consultation requests going out from the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOutgoingConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetPaginatedConsultationsRequestsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOutgoingConsultationRequests(
        page,
        size,
        sort,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.getOutgoingConsultationRequests']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Starts a call or retrieves call access for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async joinCall(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallAccessDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.joinCall(
        consultationRequestId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.joinCall']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Joins a Call for the Consultation Request with share code
     * @param {string} consultationShareCode The share code of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async joinConsultationRequestWithShareCode(
      consultationShareCode: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallAccessDTO>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.joinConsultationRequestWithShareCode(
          consultationShareCode,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.joinConsultationRequestWithShareCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Adds a report for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {ConsultationRequestReportDTO} consultationRequestReportDTO
     * @param {boolean} [finalize] True if the consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putConsultationRequestReport(
      consultationRequestId: string,
      consultationRequestReportDTO: ConsultationRequestReportDTO,
      finalize?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putConsultationRequestReport(
        consultationRequestId,
        consultationRequestReportDTO,
        finalize,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationRequestApi.putConsultationRequestReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ConsultationRequestApi - factory interface
 * @export
 */
export const ConsultationRequestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ConsultationRequestApiFp(configuration)
  return {
    /**
     * Accepts a Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptConsultationRequest(consultationRequestId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .acceptConsultationRequest(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Checks if any physician is available in the specified medical field for the hospital associated with the given case.
     * @param {string} medicalFieldId The ID of the medical field
     * @param {string} caseId The ID of the patient case, used to determine the hospital
     * @param {UrgencyDTO} urgency The urgency of the planned consultation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkDoctorAvailability(
      medicalFieldId: string,
      caseId: string,
      urgency: UrgencyDTO,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .checkDoctorAvailability(medicalFieldId, caseId, urgency, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates a Consultation Request object
     * @param {ConsultationRequestCreationDTO} consultationRequestCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConsultationRequest(
      consultationRequestCreationDTO: ConsultationRequestCreationDTO,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .createConsultationRequest(consultationRequestCreationDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Declines a consultation request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineConsultationRequest(consultationRequestId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .declineConsultationRequest(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes a Consultation Request object
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteConsultationRequest(consultationRequestId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteConsultationRequest(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Ends a Call for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    endCall(consultationRequestId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .endCall(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a filtered list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {FilteringOptions} [filteringOptions] Optional filtering options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findCompletedConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      filteringOptions?: FilteringOptions,
      options?: any
    ): AxiosPromise<PaginatedResponseConsultationSummaryDTO> {
      return localVarFp
        .findCompletedConsultationRequests(page, size, sort, filteringOptions, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves consultation requests based on the specified filters
     * @param {ConsultationRequestFilterDTO} filterDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findConsultationRequestsByFilter(
      filterDTO: ConsultationRequestFilterDTO,
      options?: any
    ): AxiosPromise<GetConsultationRequestsWithCaseResponse> {
      return localVarFp
        .findConsultationRequestsByFilter(filterDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves the distinct patients associated with user\'s completed consultations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompletedConsultationPatients(
      options?: any
    ): AxiosPromise<CompletedConsultationPatientsResponse> {
      return localVarFp
        .getCompletedConsultationPatients(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of completed consultation requests for the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompletedConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<PaginatedResponseConsultationSummaryDTO> {
      return localVarFp
        .getCompletedConsultationRequests(page, size, sort, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a report for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConsultationRequestReport(
      consultationRequestId: string,
      options?: any
    ): AxiosPromise<GetConsultationRequestReportResponse> {
      return localVarFp
        .getConsultationRequestReport(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a share code for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConsultationRequestShareCode(
      consultationRequestId: string,
      options?: any
    ): AxiosPromise<GetConsultationRequestShareCodeResponse> {
      return localVarFp
        .getConsultationRequestShareCode(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of consultation requests incoming to the authenticated user
     * @param {Array<UrgencyDTO>} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIncomingConsultationRequests(
      urgency: Array<UrgencyDTO>,
      options?: any
    ): AxiosPromise<GetPaginatedConsultationsRequestsResponse> {
      return localVarFp
        .getIncomingConsultationRequests(urgency, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of consultation requests going out from the authenticated user
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOutgoingConsultationRequests(
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<GetPaginatedConsultationsRequestsResponse> {
      return localVarFp
        .getOutgoingConsultationRequests(page, size, sort, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Starts a call or retrieves call access for the Consultation Request
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinCall(consultationRequestId: string, options?: any): AxiosPromise<CallAccessDTO> {
      return localVarFp
        .joinCall(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Joins a Call for the Consultation Request with share code
     * @param {string} consultationShareCode The share code of the consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinConsultationRequestWithShareCode(
      consultationShareCode: string,
      options?: any
    ): AxiosPromise<CallAccessDTO> {
      return localVarFp
        .joinConsultationRequestWithShareCode(consultationShareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Adds a report for the Consultation Request.
     * @param {string} consultationRequestId
     * @param {ConsultationRequestReportDTO} consultationRequestReportDTO
     * @param {boolean} [finalize] True if the consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putConsultationRequestReport(
      consultationRequestId: string,
      consultationRequestReportDTO: ConsultationRequestReportDTO,
      finalize?: boolean,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .putConsultationRequestReport(
          consultationRequestId,
          consultationRequestReportDTO,
          finalize,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ConsultationRequestApi - object-oriented interface
 * @export
 * @class ConsultationRequestApi
 * @extends {BaseAPI}
 */
export class ConsultationRequestApi extends BaseAPI {
  /**
   * Accepts a Consultation Request
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public acceptConsultationRequest(consultationRequestId: string, options?: RawAxiosRequestConfig) {
    return ConsultationRequestApiFp(this.configuration)
      .acceptConsultationRequest(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Checks if any physician is available in the specified medical field for the hospital associated with the given case.
   * @param {string} medicalFieldId The ID of the medical field
   * @param {string} caseId The ID of the patient case, used to determine the hospital
   * @param {UrgencyDTO} urgency The urgency of the planned consultation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public checkDoctorAvailability(
    medicalFieldId: string,
    caseId: string,
    urgency: UrgencyDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .checkDoctorAvailability(medicalFieldId, caseId, urgency, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates a Consultation Request object
   * @param {ConsultationRequestCreationDTO} consultationRequestCreationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public createConsultationRequest(
    consultationRequestCreationDTO: ConsultationRequestCreationDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .createConsultationRequest(consultationRequestCreationDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Declines a consultation request
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public declineConsultationRequest(
    consultationRequestId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .declineConsultationRequest(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes a Consultation Request object
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public deleteConsultationRequest(consultationRequestId: string, options?: RawAxiosRequestConfig) {
    return ConsultationRequestApiFp(this.configuration)
      .deleteConsultationRequest(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Ends a Call for the Consultation Request
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public endCall(consultationRequestId: string, options?: RawAxiosRequestConfig) {
    return ConsultationRequestApiFp(this.configuration)
      .endCall(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a filtered list of completed consultation requests for the authenticated user
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {FilteringOptions} [filteringOptions] Optional filtering options
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public findCompletedConsultationRequests(
    page?: number,
    size?: number,
    sort?: Array<string>,
    filteringOptions?: FilteringOptions,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .findCompletedConsultationRequests(page, size, sort, filteringOptions, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves consultation requests based on the specified filters
   * @param {ConsultationRequestFilterDTO} filterDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public findConsultationRequestsByFilter(
    filterDTO: ConsultationRequestFilterDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .findConsultationRequestsByFilter(filterDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves the distinct patients associated with user\'s completed consultations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getCompletedConsultationPatients(options?: RawAxiosRequestConfig) {
    return ConsultationRequestApiFp(this.configuration)
      .getCompletedConsultationPatients(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of completed consultation requests for the authenticated user
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getCompletedConsultationRequests(
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .getCompletedConsultationRequests(page, size, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a report for the Consultation Request
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getConsultationRequestReport(
    consultationRequestId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .getConsultationRequestReport(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a share code for the Consultation Request.
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getConsultationRequestShareCode(
    consultationRequestId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .getConsultationRequestShareCode(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of consultation requests incoming to the authenticated user
   * @param {Array<UrgencyDTO>} urgency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getIncomingConsultationRequests(
    urgency: Array<UrgencyDTO>,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .getIncomingConsultationRequests(urgency, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of consultation requests going out from the authenticated user
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public getOutgoingConsultationRequests(
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .getOutgoingConsultationRequests(page, size, sort, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Starts a call or retrieves call access for the Consultation Request
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public joinCall(consultationRequestId: string, options?: RawAxiosRequestConfig) {
    return ConsultationRequestApiFp(this.configuration)
      .joinCall(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Joins a Call for the Consultation Request with share code
   * @param {string} consultationShareCode The share code of the consultation request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public joinConsultationRequestWithShareCode(
    consultationShareCode: string,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .joinConsultationRequestWithShareCode(consultationShareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Adds a report for the Consultation Request.
   * @param {string} consultationRequestId
   * @param {ConsultationRequestReportDTO} consultationRequestReportDTO
   * @param {boolean} [finalize] True if the consultation report is final and can\&#39;t be overwritten anymore
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationRequestApi
   */
  public putConsultationRequestReport(
    consultationRequestId: string,
    consultationRequestReportDTO: ConsultationRequestReportDTO,
    finalize?: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationRequestApiFp(this.configuration)
      .putConsultationRequestReport(
        consultationRequestId,
        consultationRequestReportDTO,
        finalize,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ConsultationSummaryReportApi - axios parameter creator
 * @export
 */
export const ConsultationSummaryReportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Generates a PDF report aggregating every completed consultation the requesting user is a member of that matches the provided filter (date range + patients), independent of UI pagination.
     * @summary Generate consultation summary report
     * @param {ExportSummaryRequest} exportSummaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportConsultationsSummaryReport: async (
      exportSummaryRequest: ExportSummaryRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'exportSummaryRequest' is not null or undefined
      assertParamExists(
        'exportConsultationsSummaryReport',
        'exportSummaryRequest',
        exportSummaryRequest
      )
      const localVarPath = `/consultations/report-summary`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        exportSummaryRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ConsultationSummaryReportApi - functional programming interface
 * @export
 */
export const ConsultationSummaryReportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ConsultationSummaryReportApiAxiosParamCreator(configuration)
  return {
    /**
     * Generates a PDF report aggregating every completed consultation the requesting user is a member of that matches the provided filter (date range + patients), independent of UI pagination.
     * @summary Generate consultation summary report
     * @param {ExportSummaryRequest} exportSummaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportConsultationsSummaryReport(
      exportSummaryRequest: ExportSummaryRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportConsultationsSummaryReport(
        exportSummaryRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ConsultationSummaryReportApi.exportConsultationsSummaryReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ConsultationSummaryReportApi - factory interface
 * @export
 */
export const ConsultationSummaryReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ConsultationSummaryReportApiFp(configuration)
  return {
    /**
     * Generates a PDF report aggregating every completed consultation the requesting user is a member of that matches the provided filter (date range + patients), independent of UI pagination.
     * @summary Generate consultation summary report
     * @param {ExportSummaryRequest} exportSummaryRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportConsultationsSummaryReport(
      exportSummaryRequest: ExportSummaryRequest,
      options?: any
    ): AxiosPromise<File> {
      return localVarFp
        .exportConsultationsSummaryReport(exportSummaryRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ConsultationSummaryReportApi - object-oriented interface
 * @export
 * @class ConsultationSummaryReportApi
 * @extends {BaseAPI}
 */
export class ConsultationSummaryReportApi extends BaseAPI {
  /**
   * Generates a PDF report aggregating every completed consultation the requesting user is a member of that matches the provided filter (date range + patients), independent of UI pagination.
   * @summary Generate consultation summary report
   * @param {ExportSummaryRequest} exportSummaryRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConsultationSummaryReportApi
   */
  public exportConsultationsSummaryReport(
    exportSummaryRequest: ExportSummaryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ConsultationSummaryReportApiFp(this.configuration)
      .exportConsultationsSummaryReport(exportSummaryRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * DocsControllerApi - axios parameter creator
 * @export
 */
export const DocsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Archives a Case object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getElmoDocs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/v3/api-docs/elmo-ui/openapi.json`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * DocsControllerApi - functional programming interface
 * @export
 */
export const DocsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DocsControllerApiAxiosParamCreator(configuration)
  return {
    /**
     * Archives a Case object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getElmoDocs(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getElmoDocs(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DocsControllerApi.getElmoDocs']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * DocsControllerApi - factory interface
 * @export
 */
export const DocsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DocsControllerApiFp(configuration)
  return {
    /**
     * Archives a Case object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getElmoDocs(options?: any): AxiosPromise<File> {
      return localVarFp.getElmoDocs(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * DocsControllerApi - object-oriented interface
 * @export
 * @class DocsControllerApi
 * @extends {BaseAPI}
 */
export class DocsControllerApi extends BaseAPI {
  /**
   * Archives a Case object
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocsControllerApi
   */
  public getElmoDocs(options?: RawAxiosRequestConfig) {
    return DocsControllerApiFp(this.configuration)
      .getElmoDocs(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * EDSAcceptancesApi - axios parameter creator
 * @export
 */
export const EDSAcceptancesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of EDS contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for EDS contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accept: async (
      pluginAcceptanceRequest: PluginAcceptanceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pluginAcceptanceRequest' is not null or undefined
      assertParamExists('accept', 'pluginAcceptanceRequest', pluginAcceptanceRequest)
      const localVarPath = `/eds/acceptance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        pluginAcceptanceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * EDSAcceptancesApi - functional programming interface
 * @export
 */
export const EDSAcceptancesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EDSAcceptancesApiAxiosParamCreator(configuration)
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of EDS contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for EDS contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accept(
      pluginAcceptanceRequest: PluginAcceptanceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accept(
        pluginAcceptanceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EDSAcceptancesApi.accept']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * EDSAcceptancesApi - factory interface
 * @export
 */
export const EDSAcceptancesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EDSAcceptancesApiFp(configuration)
  return {
    /**
     * Persists the explicit user acceptance for a specific version and scope of EDS contraindications. This acts as an append-only audit log required for MDR compliance.
     * @summary Record user acceptance for EDS contraindications
     * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accept(pluginAcceptanceRequest: PluginAcceptanceRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .accept(pluginAcceptanceRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * EDSAcceptancesApi - object-oriented interface
 * @export
 * @class EDSAcceptancesApi
 * @extends {BaseAPI}
 */
export class EDSAcceptancesApi extends BaseAPI {
  /**
   * Persists the explicit user acceptance for a specific version and scope of EDS contraindications. This acts as an append-only audit log required for MDR compliance.
   * @summary Record user acceptance for EDS contraindications
   * @param {PluginAcceptanceRequest} pluginAcceptanceRequest The exact version and scope of the contraindications being accepted
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EDSAcceptancesApi
   */
  public accept(pluginAcceptanceRequest: PluginAcceptanceRequest, options?: RawAxiosRequestConfig) {
    return EDSAcceptancesApiFp(this.configuration)
      .accept(pluginAcceptanceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * EDSEarlyDeteriorationServicePluginApi - axios parameter creator
 * @export
 */
export const EDSEarlyDeteriorationServicePluginApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Evaluates the patient\'s current vital signs to compute the EDS risk score. A correlation requestId is mandatory for auditing and traceability purposes.
     * @summary Calculate Clinical Risk Score
     * @param {string} caseId Unique identifier of the patient\&#39;s medical case
     * @param {string} wardId Current ward ID of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalScore: async (
      caseId: string,
      wardId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getClinicalScore', 'caseId', caseId)
      // verify required parameter 'wardId' is not null or undefined
      assertParamExists('getClinicalScore', 'wardId', wardId)
      const localVarPath = `/eds/{caseId}/score`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (wardId !== undefined) {
        localVarQueryParameter['wardId'] = wardId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Evaluates the vital signs of multiple patient cases in a single request to compute their EDS risk scores.
     * @summary Calculate Clinical Risk Scores in Batch
     * @param {Array<BatchScoreRequestItemDto>} batchScoreRequestItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalScoresBatch: async (
      batchScoreRequestItemDto: Array<BatchScoreRequestItemDto>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchScoreRequestItemDto' is not null or undefined
      assertParamExists(
        'getClinicalScoresBatch',
        'batchScoreRequestItemDto',
        batchScoreRequestItemDto
      )
      const localVarPath = `/eds/score/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        batchScoreRequestItemDto,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the EDS medical device.
     * @summary Get EDS UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUdi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/eds/udi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * EDSEarlyDeteriorationServicePluginApi - functional programming interface
 * @export
 */
export const EDSEarlyDeteriorationServicePluginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EDSEarlyDeteriorationServicePluginApiAxiosParamCreator(configuration)
  return {
    /**
     * Evaluates the patient\'s current vital signs to compute the EDS risk score. A correlation requestId is mandatory for auditing and traceability purposes.
     * @summary Calculate Clinical Risk Score
     * @param {string} caseId Unique identifier of the patient\&#39;s medical case
     * @param {string} wardId Current ward ID of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClinicalScore(
      caseId: string,
      wardId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClinicalScoreResultDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalScore(
        caseId,
        wardId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EDSEarlyDeteriorationServicePluginApi.getClinicalScore']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Evaluates the vital signs of multiple patient cases in a single request to compute their EDS risk scores.
     * @summary Calculate Clinical Risk Scores in Batch
     * @param {Array<BatchScoreRequestItemDto>} batchScoreRequestItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClinicalScoresBatch(
      batchScoreRequestItemDto: Array<BatchScoreRequestItemDto>,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClinicalScoreResultDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getClinicalScoresBatch(
        batchScoreRequestItemDto,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EDSEarlyDeteriorationServicePluginApi.getClinicalScoresBatch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the EDS medical device.
     * @summary Get EDS UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUdi(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PluginUdiDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUdi(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['EDSEarlyDeteriorationServicePluginApi.getUdi']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * EDSEarlyDeteriorationServicePluginApi - factory interface
 * @export
 */
export const EDSEarlyDeteriorationServicePluginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EDSEarlyDeteriorationServicePluginApiFp(configuration)
  return {
    /**
     * Evaluates the patient\'s current vital signs to compute the EDS risk score. A correlation requestId is mandatory for auditing and traceability purposes.
     * @summary Calculate Clinical Risk Score
     * @param {string} caseId Unique identifier of the patient\&#39;s medical case
     * @param {string} wardId Current ward ID of the patient
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalScore(
      caseId: string,
      wardId: string,
      options?: any
    ): AxiosPromise<ClinicalScoreResultDto> {
      return localVarFp
        .getClinicalScore(caseId, wardId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Evaluates the vital signs of multiple patient cases in a single request to compute their EDS risk scores.
     * @summary Calculate Clinical Risk Scores in Batch
     * @param {Array<BatchScoreRequestItemDto>} batchScoreRequestItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClinicalScoresBatch(
      batchScoreRequestItemDto: Array<BatchScoreRequestItemDto>,
      options?: any
    ): AxiosPromise<Array<ClinicalScoreResultDto>> {
      return localVarFp
        .getClinicalScoresBatch(batchScoreRequestItemDto, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves Unique Device Identification (UDI) data for the EDS medical device.
     * @summary Get EDS UDI Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUdi(options?: any): AxiosPromise<PluginUdiDto> {
      return localVarFp.getUdi(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * EDSEarlyDeteriorationServicePluginApi - object-oriented interface
 * @export
 * @class EDSEarlyDeteriorationServicePluginApi
 * @extends {BaseAPI}
 */
export class EDSEarlyDeteriorationServicePluginApi extends BaseAPI {
  /**
   * Evaluates the patient\'s current vital signs to compute the EDS risk score. A correlation requestId is mandatory for auditing and traceability purposes.
   * @summary Calculate Clinical Risk Score
   * @param {string} caseId Unique identifier of the patient\&#39;s medical case
   * @param {string} wardId Current ward ID of the patient
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EDSEarlyDeteriorationServicePluginApi
   */
  public getClinicalScore(caseId: string, wardId: string, options?: RawAxiosRequestConfig) {
    return EDSEarlyDeteriorationServicePluginApiFp(this.configuration)
      .getClinicalScore(caseId, wardId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Evaluates the vital signs of multiple patient cases in a single request to compute their EDS risk scores.
   * @summary Calculate Clinical Risk Scores in Batch
   * @param {Array<BatchScoreRequestItemDto>} batchScoreRequestItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EDSEarlyDeteriorationServicePluginApi
   */
  public getClinicalScoresBatch(
    batchScoreRequestItemDto: Array<BatchScoreRequestItemDto>,
    options?: RawAxiosRequestConfig
  ) {
    return EDSEarlyDeteriorationServicePluginApiFp(this.configuration)
      .getClinicalScoresBatch(batchScoreRequestItemDto, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves Unique Device Identification (UDI) data for the EDS medical device.
   * @summary Get EDS UDI Information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EDSEarlyDeteriorationServicePluginApi
   */
  public getUdi(options?: RawAxiosRequestConfig) {
    return EDSEarlyDeteriorationServicePluginApiFp(this.configuration)
      .getUdi(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Deletes a file if the user is the same as uploader
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: async (
      fileId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('deleteFile', 'fileId', fileId)
      const localVarPath = `/file/{fileId}`.replace(
        `{${'fileId'}}`,
        encodeURIComponent(String(fileId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Completes the file upload process
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finalizeFile: async (
      fileId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('finalizeFile', 'fileId', fileId)
      const localVarPath = `/file/{fileId}`.replace(
        `{${'fileId'}}`,
        encodeURIComponent(String(fileId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a pre-signed URL to download the file
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDownloadUrl: async (
      fileId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('getDownloadUrl', 'fileId', fileId)
      const localVarPath = `/file/{fileId}`.replace(
        `{${'fileId'}}`,
        encodeURIComponent(String(fileId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Uploads a file for a Case.
     * @param {string} caseId ID of the case where the file should be uploaded
     * @param {FileUploadRequestDTO} fileUploadRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFile: async (
      caseId: string,
      fileUploadRequestDTO: FileUploadRequestDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('uploadFile', 'caseId', caseId)
      // verify required parameter 'fileUploadRequestDTO' is not null or undefined
      assertParamExists('uploadFile', 'fileUploadRequestDTO', fileUploadRequestDTO)
      const localVarPath = `/case/{caseId}/file`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        fileUploadRequestDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
  return {
    /**
     * Deletes a file if the user is the same as uploader
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteFile(
      fileId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(fileId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FileApi.deleteFile']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Completes the file upload process
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async finalizeFile(
      fileId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeFile(fileId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FileApi.finalizeFile']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a pre-signed URL to download the file
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDownloadUrl(
      fileId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadFileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUrl(fileId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FileApi.getDownloadUrl']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Uploads a file for a Case.
     * @param {string} caseId ID of the case where the file should be uploaded
     * @param {FileUploadRequestDTO} fileUploadRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadFile(
      caseId: string,
      fileUploadRequestDTO: FileUploadRequestDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(
        caseId,
        fileUploadRequestDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FileApi.uploadFile']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FileApiFp(configuration)
  return {
    /**
     * Deletes a file if the user is the same as uploader
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(fileId: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteFile(fileId, options).then((request) => request(axios, basePath))
    },
    /**
     * Completes the file upload process
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finalizeFile(fileId: string, options?: any): AxiosPromise<void> {
      return localVarFp.finalizeFile(fileId, options).then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a pre-signed URL to download the file
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDownloadUrl(fileId: string, options?: any): AxiosPromise<DownloadFileResponse> {
      return localVarFp.getDownloadUrl(fileId, options).then((request) => request(axios, basePath))
    },
    /**
     * Uploads a file for a Case.
     * @param {string} caseId ID of the case where the file should be uploaded
     * @param {FileUploadRequestDTO} fileUploadRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFile(
      caseId: string,
      fileUploadRequestDTO: FileUploadRequestDTO,
      options?: any
    ): AxiosPromise<UploadFileResponse> {
      return localVarFp
        .uploadFile(caseId, fileUploadRequestDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
  /**
   * Deletes a file if the user is the same as uploader
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public deleteFile(fileId: string, options?: RawAxiosRequestConfig) {
    return FileApiFp(this.configuration)
      .deleteFile(fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Completes the file upload process
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public finalizeFile(fileId: string, options?: RawAxiosRequestConfig) {
    return FileApiFp(this.configuration)
      .finalizeFile(fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a pre-signed URL to download the file
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public getDownloadUrl(fileId: string, options?: RawAxiosRequestConfig) {
    return FileApiFp(this.configuration)
      .getDownloadUrl(fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Uploads a file for a Case.
   * @param {string} caseId ID of the case where the file should be uploaded
   * @param {FileUploadRequestDTO} fileUploadRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public uploadFile(
    caseId: string,
    fileUploadRequestDTO: FileUploadRequestDTO,
    options?: RawAxiosRequestConfig
  ) {
    return FileApiFp(this.configuration)
      .uploadFile(caseId, fileUploadRequestDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * FiltersApi - axios parameter creator
 * @export
 */
export const FiltersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Deletes filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVitalSignsFilters: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('deleteVitalSignsFilters', 'encodedUserName', encodedUserName)
      const localVarPath = `/user-settings/{encodedUserName}/filters/vital-signs`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVitalSignsFilters: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('getVitalSignsFilters', 'encodedUserName', encodedUserName)
      const localVarPath = `/user-settings/{encodedUserName}/filters/vital-signs`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {VitalSignsFiltersDTO} vitalSignsFiltersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVitalSignsFilters: async (
      encodedUserName: string,
      vitalSignsFiltersDTO: VitalSignsFiltersDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('postVitalSignsFilters', 'encodedUserName', encodedUserName)
      // verify required parameter 'vitalSignsFiltersDTO' is not null or undefined
      assertParamExists('postVitalSignsFilters', 'vitalSignsFiltersDTO', vitalSignsFiltersDTO)
      const localVarPath = `/user-settings/{encodedUserName}/filters/vital-signs`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        vitalSignsFiltersDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * FiltersApi - functional programming interface
 * @export
 */
export const FiltersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FiltersApiAxiosParamCreator(configuration)
  return {
    /**
     * Deletes filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteVitalSignsFilters(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVitalSignsFilters(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FiltersApi.deleteVitalSignsFilters']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVitalSignsFilters(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VitalSignsFiltersDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getVitalSignsFilters(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FiltersApi.getVitalSignsFilters']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {VitalSignsFiltersDTO} vitalSignsFiltersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postVitalSignsFilters(
      encodedUserName: string,
      vitalSignsFiltersDTO: VitalSignsFiltersDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VitalSignsFiltersDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postVitalSignsFilters(
        encodedUserName,
        vitalSignsFiltersDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['FiltersApi.postVitalSignsFilters']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * FiltersApi - factory interface
 * @export
 */
export const FiltersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FiltersApiFp(configuration)
  return {
    /**
     * Deletes filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteVitalSignsFilters(encodedUserName: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteVitalSignsFilters(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVitalSignsFilters(
      encodedUserName: string,
      options?: any
    ): AxiosPromise<VitalSignsFiltersDTO> {
      return localVarFp
        .getVitalSignsFilters(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates filters for Vital Signs
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {VitalSignsFiltersDTO} vitalSignsFiltersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postVitalSignsFilters(
      encodedUserName: string,
      vitalSignsFiltersDTO: VitalSignsFiltersDTO,
      options?: any
    ): AxiosPromise<VitalSignsFiltersDTO> {
      return localVarFp
        .postVitalSignsFilters(encodedUserName, vitalSignsFiltersDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * FiltersApi - object-oriented interface
 * @export
 * @class FiltersApi
 * @extends {BaseAPI}
 */
export class FiltersApi extends BaseAPI {
  /**
   * Deletes filters for Vital Signs
   * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FiltersApi
   */
  public deleteVitalSignsFilters(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return FiltersApiFp(this.configuration)
      .deleteVitalSignsFilters(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of filters for Vital Signs
   * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FiltersApi
   */
  public getVitalSignsFilters(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return FiltersApiFp(this.configuration)
      .getVitalSignsFilters(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates filters for Vital Signs
   * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
   * @param {VitalSignsFiltersDTO} vitalSignsFiltersDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FiltersApi
   */
  public postVitalSignsFilters(
    encodedUserName: string,
    vitalSignsFiltersDTO: VitalSignsFiltersDTO,
    options?: RawAxiosRequestConfig
  ) {
    return FiltersApiFp(this.configuration)
      .postVitalSignsFilters(encodedUserName, vitalSignsFiltersDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * HospitalSettingsApi - axios parameter creator
 * @export
 */
export const HospitalSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves Hospital Active Escalation Steps
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalActiveEscalationSettings: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospitalActiveEscalationSettings', 'hospitalId', hospitalId)
      const localVarPath =
        `/hospital-escalation-settings/{hospitalId}/escalation-steps/active`.replace(
          `{${'hospitalId'}}`,
          encodeURIComponent(String(hospitalId))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalEscalationSettings: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospitalEscalationSettings', 'hospitalId', hospitalId)
      const localVarPath = `/hospital-escalation-settings/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Gets Hospital Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalSettings: async (
      hospitalId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('getHospitalSettings', 'hospitalId', hospitalId)
      const localVarPath = `/hospital-settings/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleHospitalSettingsUrgencyEscalationDisabled: async (
      hospitalId: string,
      urgency: UrgencyDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('toggleHospitalSettingsUrgencyEscalationDisabled', 'hospitalId', hospitalId)
      // verify required parameter 'urgency' is not null or undefined
      assertParamExists('toggleHospitalSettingsUrgencyEscalationDisabled', 'urgency', urgency)
      const localVarPath = `/hospital-settings/{hospitalId}/toggle-escalation-disabled/{urgency}`
        .replace(`{${'hospitalId'}}`, encodeURIComponent(String(hospitalId)))
        .replace(`{${'urgency'}}`, encodeURIComponent(String(urgency)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates Hospital Settings
     * @param {string} hospitalId
     * @param {HospitalSettingsDTO} hospitalSettingsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalSettings: async (
      hospitalId: string,
      hospitalSettingsDTO: HospitalSettingsDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('updateHospitalSettings', 'hospitalId', hospitalId)
      // verify required parameter 'hospitalSettingsDTO' is not null or undefined
      assertParamExists('updateHospitalSettings', 'hospitalSettingsDTO', hospitalSettingsDTO)
      const localVarPath = `/hospital-settings/{hospitalId}`.replace(
        `{${'hospitalId'}}`,
        encodeURIComponent(String(hospitalId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        hospitalSettingsDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {EscalationExtensionDTO} escalationExtensionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalSettingsEscalationExtension: async (
      hospitalId: string,
      escalationExtensionDTO: EscalationExtensionDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('updateHospitalSettingsEscalationExtension', 'hospitalId', hospitalId)
      // verify required parameter 'escalationExtensionDTO' is not null or undefined
      assertParamExists(
        'updateHospitalSettingsEscalationExtension',
        'escalationExtensionDTO',
        escalationExtensionDTO
      )
      const localVarPath =
        `/hospital-escalation-settings/{hospitalId}/escalation-duration-extension`.replace(
          `{${'hospitalId'}}`,
          encodeURIComponent(String(hospitalId))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        escalationExtensionDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates Escalation Steps for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency The urgency for which the escalation steps should be set
     * @param {Array<EscalationStepDTO>} escalationStepDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertHospitalSettingsEscalationSteps: async (
      hospitalId: string,
      urgency: UrgencyDTO,
      escalationStepDTO: Array<EscalationStepDTO>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'hospitalId' is not null or undefined
      assertParamExists('upsertHospitalSettingsEscalationSteps', 'hospitalId', hospitalId)
      // verify required parameter 'urgency' is not null or undefined
      assertParamExists('upsertHospitalSettingsEscalationSteps', 'urgency', urgency)
      // verify required parameter 'escalationStepDTO' is not null or undefined
      assertParamExists(
        'upsertHospitalSettingsEscalationSteps',
        'escalationStepDTO',
        escalationStepDTO
      )
      const localVarPath = `/hospital-escalation-settings/{hospitalId}/escalation-steps/{urgency}`
        .replace(`{${'hospitalId'}}`, encodeURIComponent(String(hospitalId)))
        .replace(`{${'urgency'}}`, encodeURIComponent(String(urgency)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        escalationStepDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * HospitalSettingsApi - functional programming interface
 * @export
 */
export const HospitalSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HospitalSettingsApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves Hospital Active Escalation Steps
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitalActiveEscalationSettings(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalActiveEscalationSteps>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalActiveEscalationSettings(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.getHospitalActiveEscalationSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitalEscalationSettings(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalEscalationSettings>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalEscalationSettings(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.getHospitalEscalationSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Gets Hospital Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHospitalSettings(
      hospitalId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHospitalSettingsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalSettings(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.getHospitalSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async toggleHospitalSettingsUrgencyEscalationDisabled(
      hospitalId: string,
      urgency: UrgencyDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.toggleHospitalSettingsUrgencyEscalationDisabled(
          hospitalId,
          urgency,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.toggleHospitalSettingsUrgencyEscalationDisabled']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates Hospital Settings
     * @param {string} hospitalId
     * @param {HospitalSettingsDTO} hospitalSettingsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHospitalSettings(
      hospitalId: string,
      hospitalSettingsDTO: HospitalSettingsDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalSettings(
        hospitalId,
        hospitalSettingsDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.updateHospitalSettings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {EscalationExtensionDTO} escalationExtensionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHospitalSettingsEscalationExtension(
      hospitalId: string,
      escalationExtensionDTO: EscalationExtensionDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateHospitalSettingsEscalationExtension(
          hospitalId,
          escalationExtensionDTO,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.updateHospitalSettingsEscalationExtension']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates Escalation Steps for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency The urgency for which the escalation steps should be set
     * @param {Array<EscalationStepDTO>} escalationStepDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertHospitalSettingsEscalationSteps(
      hospitalId: string,
      urgency: UrgencyDTO,
      escalationStepDTO: Array<EscalationStepDTO>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.upsertHospitalSettingsEscalationSteps(
          hospitalId,
          urgency,
          escalationStepDTO,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HospitalSettingsApi.upsertHospitalSettingsEscalationSteps']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * HospitalSettingsApi - factory interface
 * @export
 */
export const HospitalSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HospitalSettingsApiFp(configuration)
  return {
    /**
     * Retrieves Hospital Active Escalation Steps
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalActiveEscalationSettings(
      hospitalId: string,
      options?: any
    ): AxiosPromise<HospitalActiveEscalationSteps> {
      return localVarFp
        .getHospitalActiveEscalationSettings(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves Hospital Escalation Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalEscalationSettings(
      hospitalId: string,
      options?: any
    ): AxiosPromise<HospitalEscalationSettings> {
      return localVarFp
        .getHospitalEscalationSettings(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets Hospital Settings
     * @param {string} hospitalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHospitalSettings(
      hospitalId: string,
      options?: any
    ): AxiosPromise<GetHospitalSettingsResponse> {
      return localVarFp
        .getHospitalSettings(hospitalId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    toggleHospitalSettingsUrgencyEscalationDisabled(
      hospitalId: string,
      urgency: UrgencyDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .toggleHospitalSettingsUrgencyEscalationDisabled(hospitalId, urgency, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates Hospital Settings
     * @param {string} hospitalId
     * @param {HospitalSettingsDTO} hospitalSettingsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalSettings(
      hospitalId: string,
      hospitalSettingsDTO: HospitalSettingsDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateHospitalSettings(hospitalId, hospitalSettingsDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates Escalation Extension for the Hospital Settings
     * @param {string} hospitalId
     * @param {EscalationExtensionDTO} escalationExtensionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHospitalSettingsEscalationExtension(
      hospitalId: string,
      escalationExtensionDTO: EscalationExtensionDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateHospitalSettingsEscalationExtension(hospitalId, escalationExtensionDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates Escalation Steps for the Hospital Settings
     * @param {string} hospitalId
     * @param {UrgencyDTO} urgency The urgency for which the escalation steps should be set
     * @param {Array<EscalationStepDTO>} escalationStepDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertHospitalSettingsEscalationSteps(
      hospitalId: string,
      urgency: UrgencyDTO,
      escalationStepDTO: Array<EscalationStepDTO>,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .upsertHospitalSettingsEscalationSteps(hospitalId, urgency, escalationStepDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * HospitalSettingsApi - object-oriented interface
 * @export
 * @class HospitalSettingsApi
 * @extends {BaseAPI}
 */
export class HospitalSettingsApi extends BaseAPI {
  /**
   * Retrieves Hospital Active Escalation Steps
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public getHospitalActiveEscalationSettings(hospitalId: string, options?: RawAxiosRequestConfig) {
    return HospitalSettingsApiFp(this.configuration)
      .getHospitalActiveEscalationSettings(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves Hospital Escalation Settings
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public getHospitalEscalationSettings(hospitalId: string, options?: RawAxiosRequestConfig) {
    return HospitalSettingsApiFp(this.configuration)
      .getHospitalEscalationSettings(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets Hospital Settings
   * @param {string} hospitalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public getHospitalSettings(hospitalId: string, options?: RawAxiosRequestConfig) {
    return HospitalSettingsApiFp(this.configuration)
      .getHospitalSettings(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates Escalation Extension for the Hospital Settings
   * @param {string} hospitalId
   * @param {UrgencyDTO} urgency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public toggleHospitalSettingsUrgencyEscalationDisabled(
    hospitalId: string,
    urgency: UrgencyDTO,
    options?: RawAxiosRequestConfig
  ) {
    return HospitalSettingsApiFp(this.configuration)
      .toggleHospitalSettingsUrgencyEscalationDisabled(hospitalId, urgency, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates Hospital Settings
   * @param {string} hospitalId
   * @param {HospitalSettingsDTO} hospitalSettingsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public updateHospitalSettings(
    hospitalId: string,
    hospitalSettingsDTO: HospitalSettingsDTO,
    options?: RawAxiosRequestConfig
  ) {
    return HospitalSettingsApiFp(this.configuration)
      .updateHospitalSettings(hospitalId, hospitalSettingsDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates Escalation Extension for the Hospital Settings
   * @param {string} hospitalId
   * @param {EscalationExtensionDTO} escalationExtensionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public updateHospitalSettingsEscalationExtension(
    hospitalId: string,
    escalationExtensionDTO: EscalationExtensionDTO,
    options?: RawAxiosRequestConfig
  ) {
    return HospitalSettingsApiFp(this.configuration)
      .updateHospitalSettingsEscalationExtension(hospitalId, escalationExtensionDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates Escalation Steps for the Hospital Settings
   * @param {string} hospitalId
   * @param {UrgencyDTO} urgency The urgency for which the escalation steps should be set
   * @param {Array<EscalationStepDTO>} escalationStepDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HospitalSettingsApi
   */
  public upsertHospitalSettingsEscalationSteps(
    hospitalId: string,
    urgency: UrgencyDTO,
    escalationStepDTO: Array<EscalationStepDTO>,
    options?: RawAxiosRequestConfig
  ) {
    return HospitalSettingsApiFp(this.configuration)
      .upsertHospitalSettingsEscalationSteps(hospitalId, urgency, escalationStepDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LaboratoryApi - axios parameter creator
 * @export
 */
export const LaboratoryApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves all laboratory data for data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLaboratoryInPeriod: async (
      caseId: string,
      period: VitalsPeriod,
      typeKeyLike?: VitalSignTypeKeyLike,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLaboratoryInPeriod', 'caseId', caseId)
      // verify required parameter 'period' is not null or undefined
      assertParamExists('getLaboratoryInPeriod', 'period', period)
      const localVarPath = `/laboratory-in-period/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      if (typeKeyLike !== undefined) {
        for (const [key, value] of Object.entries(typeKeyLike)) {
          localVarQueryParameter[key] = value
        }
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves latest values for the selected Laboratory Vital Signs
     * @param {string} caseId
     * @param {Array<LaboratoryTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestLaboratoryVitalSigns: async (
      caseId: string,
      types: Array<LaboratoryTypeKey>,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLatestLaboratoryVitalSigns', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getLatestLaboratoryVitalSigns', 'types', types)
      const localVarPath = `/laboratory/{caseId}/latest`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * LaboratoryApi - functional programming interface
 * @export
 */
export const LaboratoryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LaboratoryApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves all laboratory data for data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLaboratoryInPeriod(
      caseId: string,
      period: VitalsPeriod,
      typeKeyLike?: VitalSignTypeKeyLike,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLaboratoryInPeriod(
        caseId,
        period,
        typeKeyLike,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LaboratoryApi.getLaboratoryInPeriod']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves latest values for the selected Laboratory Vital Signs
     * @param {string} caseId
     * @param {Array<LaboratoryTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestLaboratoryVitalSigns(
      caseId: string,
      types: Array<LaboratoryTypeKey>,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestLaboratoryVitalSigns(
        caseId,
        types,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LaboratoryApi.getLatestLaboratoryVitalSigns']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * LaboratoryApi - factory interface
 * @export
 */
export const LaboratoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LaboratoryApiFp(configuration)
  return {
    /**
     * Retrieves all laboratory data for data for a predefined period
     * @param {string} caseId
     * @param {VitalsPeriod} period
     * @param {VitalSignTypeKeyLike} [typeKeyLike]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLaboratoryInPeriod(
      caseId: string,
      period: VitalsPeriod,
      typeKeyLike?: VitalSignTypeKeyLike,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getLaboratoryInPeriod(caseId, period, typeKeyLike, shareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves latest values for the selected Laboratory Vital Signs
     * @param {string} caseId
     * @param {Array<LaboratoryTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestLaboratoryVitalSigns(
      caseId: string,
      types: Array<LaboratoryTypeKey>,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getLatestLaboratoryVitalSigns(caseId, types, shareCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * LaboratoryApi - object-oriented interface
 * @export
 * @class LaboratoryApi
 * @extends {BaseAPI}
 */
export class LaboratoryApi extends BaseAPI {
  /**
   * Retrieves all laboratory data for data for a predefined period
   * @param {string} caseId
   * @param {VitalsPeriod} period
   * @param {VitalSignTypeKeyLike} [typeKeyLike]
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LaboratoryApi
   */
  public getLaboratoryInPeriod(
    caseId: string,
    period: VitalsPeriod,
    typeKeyLike?: VitalSignTypeKeyLike,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return LaboratoryApiFp(this.configuration)
      .getLaboratoryInPeriod(caseId, period, typeKeyLike, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves latest values for the selected Laboratory Vital Signs
   * @param {string} caseId
   * @param {Array<LaboratoryTypeKey>} types
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LaboratoryApi
   */
  public getLatestLaboratoryVitalSigns(
    caseId: string,
    types: Array<LaboratoryTypeKey>,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return LaboratoryApiFp(this.configuration)
      .getLatestLaboratoryVitalSigns(caseId, types, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MedicalFieldApi - axios parameter creator
 * @export
 */
export const MedicalFieldApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves all Medical Fields of a Hospital
     * @param {string} [hospitalId] ID of the hospital of which medical fields are searched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMedicalFields: async (
      hospitalId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/medical-field`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (hospitalId !== undefined) {
        localVarQueryParameter['hospitalId'] = hospitalId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MedicalFieldApi - functional programming interface
 * @export
 */
export const MedicalFieldApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MedicalFieldApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves all Medical Fields of a Hospital
     * @param {string} [hospitalId] ID of the hospital of which medical fields are searched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMedicalFields(
      hospitalId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicalFieldsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalFields(
        hospitalId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MedicalFieldApi.getMedicalFields']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MedicalFieldApi - factory interface
 * @export
 */
export const MedicalFieldApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MedicalFieldApiFp(configuration)
  return {
    /**
     * Retrieves all Medical Fields of a Hospital
     * @param {string} [hospitalId] ID of the hospital of which medical fields are searched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMedicalFields(hospitalId?: string, options?: any): AxiosPromise<GetMedicalFieldsResponse> {
      return localVarFp
        .getMedicalFields(hospitalId, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * MedicalFieldApi - object-oriented interface
 * @export
 * @class MedicalFieldApi
 * @extends {BaseAPI}
 */
export class MedicalFieldApi extends BaseAPI {
  /**
   * Retrieves all Medical Fields of a Hospital
   * @param {string} [hospitalId] ID of the hospital of which medical fields are searched
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MedicalFieldApi
   */
  public getMedicalFields(hospitalId?: string, options?: RawAxiosRequestConfig) {
    return MedicalFieldApiFp(this.configuration)
      .getMedicalFields(hospitalId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MedicalTitleApi - axios parameter creator
 * @export
 */
export const MedicalTitleApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves all Medical Titles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMedicalTitles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/medical-title`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * MedicalTitleApi - functional programming interface
 * @export
 */
export const MedicalTitleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MedicalTitleApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves all Medical Titles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMedicalTitles(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMedicalTitlesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMedicalTitles(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MedicalTitleApi.getMedicalTitles']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * MedicalTitleApi - factory interface
 * @export
 */
export const MedicalTitleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MedicalTitleApiFp(configuration)
  return {
    /**
     * Retrieves all Medical Titles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMedicalTitles(options?: any): AxiosPromise<GetMedicalTitlesResponse> {
      return localVarFp.getMedicalTitles(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * MedicalTitleApi - object-oriented interface
 * @export
 * @class MedicalTitleApi
 * @extends {BaseAPI}
 */
export class MedicalTitleApi extends BaseAPI {
  /**
   * Retrieves all Medical Titles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MedicalTitleApi
   */
  public getMedicalTitles(options?: RawAxiosRequestConfig) {
    return MedicalTitleApiFp(this.configuration)
      .getMedicalTitles(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves a list of Notifications of the current User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/notification`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Marks the given and all older notifications as read
     * @param {string} notificationId The ID of the last read notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markNotificationsStatusAsRead: async (
      notificationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'notificationId' is not null or undefined
      assertParamExists('markNotificationsStatusAsRead', 'notificationId', notificationId)
      const localVarPath = `/notification/{notificationId}/mark-read-including-older`.replace(
        `{${'notificationId'}}`,
        encodeURIComponent(String(notificationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves a list of Notifications of the current User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNotifications(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificationsResponseDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['NotificationApi.getNotifications']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Marks the given and all older notifications as read
     * @param {string} notificationId The ID of the last read notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markNotificationsStatusAsRead(
      notificationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsStatusAsRead(
        notificationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['NotificationApi.markNotificationsStatusAsRead']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotificationApiFp(configuration)
  return {
    /**
     * Retrieves a list of Notifications of the current User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(options?: any): AxiosPromise<GetNotificationsResponseDTO> {
      return localVarFp.getNotifications(options).then((request) => request(axios, basePath))
    },
    /**
     * Marks the given and all older notifications as read
     * @param {string} notificationId The ID of the last read notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markNotificationsStatusAsRead(notificationId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .markNotificationsStatusAsRead(notificationId, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
  /**
   * Retrieves a list of Notifications of the current User
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */
  public getNotifications(options?: RawAxiosRequestConfig) {
    return NotificationApiFp(this.configuration)
      .getNotifications(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Marks the given and all older notifications as read
   * @param {string} notificationId The ID of the last read notification
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */
  public markNotificationsStatusAsRead(notificationId: string, options?: RawAxiosRequestConfig) {
    return NotificationApiFp(this.configuration)
      .markNotificationsStatusAsRead(notificationId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NotificationAppApi - axios parameter creator
 * @export
 */
export const NotificationAppApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ConfirmPairingStatusAppRequest} confirmPairingStatusApp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmPairing: async (
      confirmPairingStatusApp: ConfirmPairingStatusAppRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'confirmPairingStatusApp' is not null or undefined
      assertParamExists('confirmPairing', 'confirmPairingStatusApp', confirmPairingStatusApp)
      const localVarPath = `/notification-app/pairings/status/integration`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (confirmPairingStatusApp !== undefined) {
        for (const [key, value] of Object.entries(confirmPairingStatusApp)) {
          localVarQueryParameter[key] = value
        }
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPairingStatusByEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/notification-app/pairings/status/integration`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * NotificationAppApi - functional programming interface
 * @export
 */
export const NotificationAppApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotificationAppApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {ConfirmPairingStatusAppRequest} confirmPairingStatusApp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmPairing(
      confirmPairingStatusApp: ConfirmPairingStatusAppRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmPairingResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPairing(
        confirmPairingStatusApp,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['NotificationAppApi.confirmPairing']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPairingStatusByEmail(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PairingStatusByEmailResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPairingStatusByEmail(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['NotificationAppApi.getPairingStatusByEmail']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * NotificationAppApi - factory interface
 * @export
 */
export const NotificationAppApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotificationAppApiFp(configuration)
  return {
    /**
     *
     * @param {ConfirmPairingStatusAppRequest} confirmPairingStatusApp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmPairing(
      confirmPairingStatusApp: ConfirmPairingStatusAppRequest,
      options?: any
    ): AxiosPromise<ConfirmPairingResponse> {
      return localVarFp
        .confirmPairing(confirmPairingStatusApp, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPairingStatusByEmail(options?: any): AxiosPromise<PairingStatusByEmailResponse> {
      return localVarFp.getPairingStatusByEmail(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * NotificationAppApi - object-oriented interface
 * @export
 * @class NotificationAppApi
 * @extends {BaseAPI}
 */
export class NotificationAppApi extends BaseAPI {
  /**
   *
   * @param {ConfirmPairingStatusAppRequest} confirmPairingStatusApp
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationAppApi
   */
  public confirmPairing(
    confirmPairingStatusApp: ConfirmPairingStatusAppRequest,
    options?: RawAxiosRequestConfig
  ) {
    return NotificationAppApiFp(this.configuration)
      .confirmPairing(confirmPairingStatusApp, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationAppApi
   */
  public getPairingStatusByEmail(options?: RawAxiosRequestConfig) {
    return NotificationAppApiFp(this.configuration)
      .getPairingStatusByEmail(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NotificationAuditApi - axios parameter creator
 * @export
 */
export const NotificationAuditApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Logs events like RECEIVED, TAPPED, DISMISSED from client apps
     * @summary Log notification event
     * @param {NotificationAuditRequest} notificationAuditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logNotificationEvent: async (
      notificationAuditRequest: NotificationAuditRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'notificationAuditRequest' is not null or undefined
      assertParamExists(
        'logNotificationEvent',
        'notificationAuditRequest',
        notificationAuditRequest
      )
      const localVarPath = `/notifications/audit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        notificationAuditRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * NotificationAuditApi - functional programming interface
 * @export
 */
export const NotificationAuditApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotificationAuditApiAxiosParamCreator(configuration)
  return {
    /**
     * Logs events like RECEIVED, TAPPED, DISMISSED from client apps
     * @summary Log notification event
     * @param {NotificationAuditRequest} notificationAuditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logNotificationEvent(
      notificationAuditRequest: NotificationAuditRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logNotificationEvent(
        notificationAuditRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['NotificationAuditApi.logNotificationEvent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * NotificationAuditApi - factory interface
 * @export
 */
export const NotificationAuditApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotificationAuditApiFp(configuration)
  return {
    /**
     * Logs events like RECEIVED, TAPPED, DISMISSED from client apps
     * @summary Log notification event
     * @param {NotificationAuditRequest} notificationAuditRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logNotificationEvent(
      notificationAuditRequest: NotificationAuditRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .logNotificationEvent(notificationAuditRequest, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * NotificationAuditApi - object-oriented interface
 * @export
 * @class NotificationAuditApi
 * @extends {BaseAPI}
 */
export class NotificationAuditApi extends BaseAPI {
  /**
   * Logs events like RECEIVED, TAPPED, DISMISSED from client apps
   * @summary Log notification event
   * @param {NotificationAuditRequest} notificationAuditRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationAuditApi
   */
  public logNotificationEvent(
    notificationAuditRequest: NotificationAuditRequest,
    options?: RawAxiosRequestConfig
  ) {
    return NotificationAuditApiFp(this.configuration)
      .logNotificationEvent(notificationAuditRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * OrganSupportApi - axios parameter creator
 * @export
 */
export const OrganSupportApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves organ support information for the given case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganSupport: async (
      caseId: string,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getOrganSupport', 'caseId', caseId)
      const localVarPath = `/organ-support/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * OrganSupportApi - functional programming interface
 * @export
 */
export const OrganSupportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrganSupportApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves organ support information for the given case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrganSupport(
      caseId: string,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganSupportDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganSupport(
        caseId,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OrganSupportApi.getOrganSupport']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * OrganSupportApi - factory interface
 * @export
 */
export const OrganSupportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OrganSupportApiFp(configuration)
  return {
    /**
     * Retrieves organ support information for the given case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganSupport(
      caseId: string,
      shareCode?: string,
      options?: any
    ): AxiosPromise<OrganSupportDTO> {
      return localVarFp
        .getOrganSupport(caseId, shareCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * OrganSupportApi - object-oriented interface
 * @export
 * @class OrganSupportApi
 * @extends {BaseAPI}
 */
export class OrganSupportApi extends BaseAPI {
  /**
   * Retrieves organ support information for the given case
   * @param {string} caseId
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganSupportApi
   */
  public getOrganSupport(caseId: string, shareCode?: string, options?: RawAxiosRequestConfig) {
    return OrganSupportApiFp(this.configuration)
      .getOrganSupport(caseId, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * OutputApi - axios parameter creator
 * @export
 */
export const OutputApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves latest values for the selected output data
     * @param {string} caseId
     * @param {Array<OutputTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestOutputVitalSigns: async (
      caseId: string,
      types: Array<OutputTypeKey>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLatestOutputVitalSigns', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getLatestOutputVitalSigns', 'types', types)
      const localVarPath = `/output/{caseId}/latest`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * OutputApi - functional programming interface
 * @export
 */
export const OutputApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OutputApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves latest values for the selected output data
     * @param {string} caseId
     * @param {Array<OutputTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestOutputVitalSigns(
      caseId: string,
      types: Array<OutputTypeKey>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestOutputVitalSigns(
        caseId,
        types,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['OutputApi.getLatestOutputVitalSigns']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * OutputApi - factory interface
 * @export
 */
export const OutputApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OutputApiFp(configuration)
  return {
    /**
     * Retrieves latest values for the selected output data
     * @param {string} caseId
     * @param {Array<OutputTypeKey>} types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestOutputVitalSigns(
      caseId: string,
      types: Array<OutputTypeKey>,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getLatestOutputVitalSigns(caseId, types, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * OutputApi - object-oriented interface
 * @export
 * @class OutputApi
 * @extends {BaseAPI}
 */
export class OutputApi extends BaseAPI {
  /**
   * Retrieves latest values for the selected output data
   * @param {string} caseId
   * @param {Array<OutputTypeKey>} types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OutputApi
   */
  public getLatestOutputVitalSigns(
    caseId: string,
    types: Array<OutputTypeKey>,
    options?: RawAxiosRequestConfig
  ) {
    return OutputApiFp(this.configuration)
      .getLatestOutputVitalSigns(caseId, types, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PluginApi - axios parameter creator
 * @export
 */
export const PluginApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Lists enabled plugins
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEnabledPlugins: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/plugins/enabled`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PluginApi - functional programming interface
 * @export
 */
export const PluginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PluginApiAxiosParamCreator(configuration)
  return {
    /**
     * Lists enabled plugins
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listEnabledPlugins(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PluginKey>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listEnabledPlugins(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PluginApi.listEnabledPlugins']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PluginApi - factory interface
 * @export
 */
export const PluginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PluginApiFp(configuration)
  return {
    /**
     * Lists enabled plugins
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEnabledPlugins(options?: any): AxiosPromise<Array<PluginKey>> {
      return localVarFp.listEnabledPlugins(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * PluginApi - object-oriented interface
 * @export
 * @class PluginApi
 * @extends {BaseAPI}
 */
export class PluginApi extends BaseAPI {
  /**
   * Lists enabled plugins
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PluginApi
   */
  public listEnabledPlugins(options?: RawAxiosRequestConfig) {
    return PluginApiFp(this.configuration)
      .listEnabledPlugins(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PluginAdminAPIApi - axios parameter creator
 * @export
 */
export const PluginAdminAPIApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves a complete list of all wards currently excluded for the selected plugin.
     * @summary Get All Excluded Wards
     * @param {PluginKey} pluginKey Plugin key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllExcludedWards: async (
      pluginKey: PluginKey,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pluginKey' is not null or undefined
      assertParamExists('getAllExcludedWards', 'pluginKey', pluginKey)
      const localVarPath = `/admin/plugins/{pluginKey}/wards/exclusions`.replace(
        `{${'pluginKey'}}`,
        encodeURIComponent(String(pluginKey))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates whether a specific ward is excluded for a given plugin.
     * @summary Update Ward Exclusion Status
     * @param {PluginKey} pluginKey Plugin key
     * @param {string} wardId Unique identifier of the ward
     * @param {WardExclusionStatusRequestDTO} wardExclusionStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWardExclusionStatus: async (
      pluginKey: PluginKey,
      wardId: string,
      wardExclusionStatusRequestDTO: WardExclusionStatusRequestDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pluginKey' is not null or undefined
      assertParamExists('updateWardExclusionStatus', 'pluginKey', pluginKey)
      // verify required parameter 'wardId' is not null or undefined
      assertParamExists('updateWardExclusionStatus', 'wardId', wardId)
      // verify required parameter 'wardExclusionStatusRequestDTO' is not null or undefined
      assertParamExists(
        'updateWardExclusionStatus',
        'wardExclusionStatusRequestDTO',
        wardExclusionStatusRequestDTO
      )
      const localVarPath = `/admin/plugins/{pluginKey}/wards/{wardId}/exclusion`
        .replace(`{${'pluginKey'}}`, encodeURIComponent(String(pluginKey)))
        .replace(`{${'wardId'}}`, encodeURIComponent(String(wardId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        wardExclusionStatusRequestDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * PluginAdminAPIApi - functional programming interface
 * @export
 */
export const PluginAdminAPIApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PluginAdminAPIApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves a complete list of all wards currently excluded for the selected plugin.
     * @summary Get All Excluded Wards
     * @param {PluginKey} pluginKey Plugin key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllExcludedWards(
      pluginKey: PluginKey,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAllExcludedWards(
        pluginKey,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PluginAdminAPIApi.getAllExcludedWards']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates whether a specific ward is excluded for a given plugin.
     * @summary Update Ward Exclusion Status
     * @param {PluginKey} pluginKey Plugin key
     * @param {string} wardId Unique identifier of the ward
     * @param {WardExclusionStatusRequestDTO} wardExclusionStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateWardExclusionStatus(
      pluginKey: PluginKey,
      wardId: string,
      wardExclusionStatusRequestDTO: WardExclusionStatusRequestDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateWardExclusionStatus(
        pluginKey,
        wardId,
        wardExclusionStatusRequestDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PluginAdminAPIApi.updateWardExclusionStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * PluginAdminAPIApi - factory interface
 * @export
 */
export const PluginAdminAPIApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PluginAdminAPIApiFp(configuration)
  return {
    /**
     * Retrieves a complete list of all wards currently excluded for the selected plugin.
     * @summary Get All Excluded Wards
     * @param {PluginKey} pluginKey Plugin key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllExcludedWards(pluginKey: PluginKey, options?: any): AxiosPromise<Array<string>> {
      return localVarFp
        .getAllExcludedWards(pluginKey, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates whether a specific ward is excluded for a given plugin.
     * @summary Update Ward Exclusion Status
     * @param {PluginKey} pluginKey Plugin key
     * @param {string} wardId Unique identifier of the ward
     * @param {WardExclusionStatusRequestDTO} wardExclusionStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateWardExclusionStatus(
      pluginKey: PluginKey,
      wardId: string,
      wardExclusionStatusRequestDTO: WardExclusionStatusRequestDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateWardExclusionStatus(pluginKey, wardId, wardExclusionStatusRequestDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * PluginAdminAPIApi - object-oriented interface
 * @export
 * @class PluginAdminAPIApi
 * @extends {BaseAPI}
 */
export class PluginAdminAPIApi extends BaseAPI {
  /**
   * Retrieves a complete list of all wards currently excluded for the selected plugin.
   * @summary Get All Excluded Wards
   * @param {PluginKey} pluginKey Plugin key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PluginAdminAPIApi
   */
  public getAllExcludedWards(pluginKey: PluginKey, options?: RawAxiosRequestConfig) {
    return PluginAdminAPIApiFp(this.configuration)
      .getAllExcludedWards(pluginKey, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates whether a specific ward is excluded for a given plugin.
   * @summary Update Ward Exclusion Status
   * @param {PluginKey} pluginKey Plugin key
   * @param {string} wardId Unique identifier of the ward
   * @param {WardExclusionStatusRequestDTO} wardExclusionStatusRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PluginAdminAPIApi
   */
  public updateWardExclusionStatus(
    pluginKey: PluginKey,
    wardId: string,
    wardExclusionStatusRequestDTO: WardExclusionStatusRequestDTO,
    options?: RawAxiosRequestConfig
  ) {
    return PluginAdminAPIApiFp(this.configuration)
      .updateWardExclusionStatus(pluginKey, wardId, wardExclusionStatusRequestDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RadiologyCasesApi - axios parameter creator
 * @export
 */
export const RadiologyCasesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns metadata of radiology image URLs linked to a patient case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRadiologyImagesMetadata: async (
      caseId: string,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getRadiologyImagesMetadata', 'caseId', caseId)
      const localVarPath = `/radiology-cases/{caseId}/image-metadata`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RadiologyCasesApi - functional programming interface
 * @export
 */
export const RadiologyCasesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RadiologyCasesApiAxiosParamCreator(configuration)
  return {
    /**
     * Returns metadata of radiology image URLs linked to a patient case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRadiologyImagesMetadata(
      caseId: string,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RadiologyImageMetadataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRadiologyImagesMetadata(
        caseId,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RadiologyCasesApi.getRadiologyImagesMetadata']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RadiologyCasesApi - factory interface
 * @export
 */
export const RadiologyCasesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RadiologyCasesApiFp(configuration)
  return {
    /**
     * Returns metadata of radiology image URLs linked to a patient case
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRadiologyImagesMetadata(
      caseId: string,
      shareCode?: string,
      options?: any
    ): AxiosPromise<RadiologyImageMetadataResponse> {
      return localVarFp
        .getRadiologyImagesMetadata(caseId, shareCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RadiologyCasesApi - object-oriented interface
 * @export
 * @class RadiologyCasesApi
 * @extends {BaseAPI}
 */
export class RadiologyCasesApi extends BaseAPI {
  /**
   * Returns metadata of radiology image URLs linked to a patient case
   * @param {string} caseId
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RadiologyCasesApi
   */
  public getRadiologyImagesMetadata(
    caseId: string,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RadiologyCasesApiFp(this.configuration)
      .getRadiologyImagesMetadata(caseId, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RoutingSupervisorApi - axios parameter creator
 * @export
 */
export const RoutingSupervisorApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves doctors available for assignment to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDoctorsAvailableForConsultationRequestAssignment: async (
      consultationRequestId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'getDoctorsAvailableForConsultationRequestAssignment',
        'consultationRequestId',
        consultationRequestId
      )
      const localVarPath = `/routing-supervisor/available-doctors/{consultationRequestId}`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Assigns doctor to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {AssignDoctorToConsultationRequestDTO} assignDoctorToConsultationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAssignDoctorToConsultationRequest: async (
      consultationRequestId: string,
      assignDoctorToConsultationRequestDTO: AssignDoctorToConsultationRequestDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'consultationRequestId' is not null or undefined
      assertParamExists(
        'putAssignDoctorToConsultationRequest',
        'consultationRequestId',
        consultationRequestId
      )
      // verify required parameter 'assignDoctorToConsultationRequestDTO' is not null or undefined
      assertParamExists(
        'putAssignDoctorToConsultationRequest',
        'assignDoctorToConsultationRequestDTO',
        assignDoctorToConsultationRequestDTO
      )
      const localVarPath = `/routing-supervisor/assign-doctor/{consultationRequestId}`.replace(
        `{${'consultationRequestId'}}`,
        encodeURIComponent(String(consultationRequestId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignDoctorToConsultationRequestDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * RoutingSupervisorApi - functional programming interface
 * @export
 */
export const RoutingSupervisorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoutingSupervisorApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves doctors available for assignment to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDoctorsAvailableForConsultationRequestAssignment(
      consultationRequestId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUsersResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDoctorsAvailableForConsultationRequestAssignment(
          consultationRequestId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'RoutingSupervisorApi.getDoctorsAvailableForConsultationRequestAssignment'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Assigns doctor to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {AssignDoctorToConsultationRequestDTO} assignDoctorToConsultationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putAssignDoctorToConsultationRequest(
      consultationRequestId: string,
      assignDoctorToConsultationRequestDTO: AssignDoctorToConsultationRequestDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.putAssignDoctorToConsultationRequest(
          consultationRequestId,
          assignDoctorToConsultationRequestDTO,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoutingSupervisorApi.putAssignDoctorToConsultationRequest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * RoutingSupervisorApi - factory interface
 * @export
 */
export const RoutingSupervisorApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RoutingSupervisorApiFp(configuration)
  return {
    /**
     * Retrieves doctors available for assignment to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDoctorsAvailableForConsultationRequestAssignment(
      consultationRequestId: string,
      options?: any
    ): AxiosPromise<SearchUsersResponse> {
      return localVarFp
        .getDoctorsAvailableForConsultationRequestAssignment(consultationRequestId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Assigns doctor to a Consultation Request.
     * @param {string} consultationRequestId
     * @param {AssignDoctorToConsultationRequestDTO} assignDoctorToConsultationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAssignDoctorToConsultationRequest(
      consultationRequestId: string,
      assignDoctorToConsultationRequestDTO: AssignDoctorToConsultationRequestDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .putAssignDoctorToConsultationRequest(
          consultationRequestId,
          assignDoctorToConsultationRequestDTO,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * RoutingSupervisorApi - object-oriented interface
 * @export
 * @class RoutingSupervisorApi
 * @extends {BaseAPI}
 */
export class RoutingSupervisorApi extends BaseAPI {
  /**
   * Retrieves doctors available for assignment to a Consultation Request.
   * @param {string} consultationRequestId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoutingSupervisorApi
   */
  public getDoctorsAvailableForConsultationRequestAssignment(
    consultationRequestId: string,
    options?: RawAxiosRequestConfig
  ) {
    return RoutingSupervisorApiFp(this.configuration)
      .getDoctorsAvailableForConsultationRequestAssignment(consultationRequestId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Assigns doctor to a Consultation Request.
   * @param {string} consultationRequestId
   * @param {AssignDoctorToConsultationRequestDTO} assignDoctorToConsultationRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoutingSupervisorApi
   */
  public putAssignDoctorToConsultationRequest(
    consultationRequestId: string,
    assignDoctorToConsultationRequestDTO: AssignDoctorToConsultationRequestDTO,
    options?: RawAxiosRequestConfig
  ) {
    return RoutingSupervisorApiFp(this.configuration)
      .putAssignDoctorToConsultationRequest(
        consultationRequestId,
        assignDoctorToConsultationRequestDTO,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ScheduledConsultationRequestApi - axios parameter creator
 * @export
 */
export const ScheduledConsultationRequestApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Accepts a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'acceptScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/accept`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Completes the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'completeScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/complete`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Creates a Scheduled Consultation object
     * @param {ScheduledConsultationCreationDTO} scheduledConsultationCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createScheduledConsultation: async (
      scheduledConsultationCreationDTO: ScheduledConsultationCreationDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationCreationDTO' is not null or undefined
      assertParamExists(
        'createScheduledConsultation',
        'scheduledConsultationCreationDTO',
        scheduledConsultationCreationDTO
      )
      const localVarPath = `/scheduled-consultation`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        scheduledConsultationCreationDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Declines a scheduled consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'declineScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/decline`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Deletes a Scheduled Consultation object
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'deleteScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a Scheduled Consultation by its ID
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'getScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves report created by authenticated user for a given caseId within the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationReport: async (
      scheduledConsultationId: string,
      caseId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'getScheduledConsultationReport',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getScheduledConsultationReport', 'caseId', caseId)
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/{caseId}/report`
        .replace(
          `{${'scheduledConsultationId'}}`,
          encodeURIComponent(String(scheduledConsultationId))
        )
        .replace(`{${'caseId'}}`, encodeURIComponent(String(caseId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves reports for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationReports: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'getScheduledConsultationReports',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/reports`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a share code for the Scheduled Consultation Request.
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationRequestShareCode: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'getScheduledConsultationRequestShareCode',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/share-code`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Hides a Scheduled Consultation for the user
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hideScheduledConsultation: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'hideScheduledConsultation',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/hide`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Starts a call or retrieves call access for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinScheduledCall: async (
      scheduledConsultationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists('joinScheduledCall', 'scheduledConsultationId', scheduledConsultationId)
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/call`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Joins a Call for the Scheduled Consultation Request with share code
     * @param {string} scheduledConsultationShareCode The share code of the scheduled consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinScheduledConsultationRequestWithShareCode: async (
      scheduledConsultationShareCode: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationShareCode' is not null or undefined
      assertParamExists(
        'joinScheduledConsultationRequestWithShareCode',
        'scheduledConsultationShareCode',
        scheduledConsultationShareCode
      )
      const localVarPath =
        `/scheduled-consultation/join-with-share-code/{scheduledConsultationShareCode}`.replace(
          `{${'scheduledConsultationShareCode'}}`,
          encodeURIComponent(String(scheduledConsultationShareCode))
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Adds a report for the Scheduled Consultation for a given case.
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {ScheduledConsultationRequestReportDTO} scheduledConsultationRequestReportDTO
     * @param {boolean} [shouldFinalizeScheduledConsultationReport] True if the scheduled consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putScheduledConsultationReport: async (
      scheduledConsultationId: string,
      caseId: string,
      scheduledConsultationRequestReportDTO: ScheduledConsultationRequestReportDTO,
      shouldFinalizeScheduledConsultationReport?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'putScheduledConsultationReport',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('putScheduledConsultationReport', 'caseId', caseId)
      // verify required parameter 'scheduledConsultationRequestReportDTO' is not null or undefined
      assertParamExists(
        'putScheduledConsultationReport',
        'scheduledConsultationRequestReportDTO',
        scheduledConsultationRequestReportDTO
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/{caseId}/report`
        .replace(
          `{${'scheduledConsultationId'}}`,
          encodeURIComponent(String(scheduledConsultationId))
        )
        .replace(`{${'caseId'}}`, encodeURIComponent(String(caseId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shouldFinalizeScheduledConsultationReport !== undefined) {
        localVarQueryParameter['shouldFinalizeScheduledConsultationReport'] =
          shouldFinalizeScheduledConsultationReport
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        scheduledConsultationRequestReportDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates the cases of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationCasesDTO} updateScheduledConsultationCasesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScheduledConsultationCases: async (
      scheduledConsultationId: string,
      updateScheduledConsultationCasesDTO: UpdateScheduledConsultationCasesDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'updateScheduledConsultationCases',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      // verify required parameter 'updateScheduledConsultationCasesDTO' is not null or undefined
      assertParamExists(
        'updateScheduledConsultationCases',
        'updateScheduledConsultationCasesDTO',
        updateScheduledConsultationCasesDTO
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/cases`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateScheduledConsultationCasesDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates the recipients (participants and requester) of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationRequestRecipientsDTO} updateScheduledConsultationRequestRecipientsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScheduledConsultationRecipients: async (
      scheduledConsultationId: string,
      updateScheduledConsultationRequestRecipientsDTO: UpdateScheduledConsultationRequestRecipientsDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduledConsultationId' is not null or undefined
      assertParamExists(
        'updateScheduledConsultationRecipients',
        'scheduledConsultationId',
        scheduledConsultationId
      )
      // verify required parameter 'updateScheduledConsultationRequestRecipientsDTO' is not null or undefined
      assertParamExists(
        'updateScheduledConsultationRecipients',
        'updateScheduledConsultationRequestRecipientsDTO',
        updateScheduledConsultationRequestRecipientsDTO
      )
      const localVarPath = `/scheduled-consultation/{scheduledConsultationId}/recipients`.replace(
        `{${'scheduledConsultationId'}}`,
        encodeURIComponent(String(scheduledConsultationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateScheduledConsultationRequestRecipientsDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ScheduledConsultationRequestApi - functional programming interface
 * @export
 */
export const ScheduledConsultationRequestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScheduledConsultationRequestApiAxiosParamCreator(configuration)
  return {
    /**
     * Accepts a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.acceptScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.acceptScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Completes the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async completeScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.completeScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.completeScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Creates a Scheduled Consultation object
     * @param {ScheduledConsultationCreationDTO} scheduledConsultationCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createScheduledConsultation(
      scheduledConsultationCreationDTO: ScheduledConsultationCreationDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createScheduledConsultation(
        scheduledConsultationCreationDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.createScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Declines a scheduled consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async declineScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.declineScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.declineScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Deletes a Scheduled Consultation object
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.deleteScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a Scheduled Consultation by its ID
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledConsultationDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.getScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves report created by authenticated user for a given caseId within the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScheduledConsultationReport(
      scheduledConsultationId: string,
      caseId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledConsultationReportDTO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledConsultationReport(
        scheduledConsultationId,
        caseId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.getScheduledConsultationReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves reports for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScheduledConsultationReports(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetScheduledConsultationReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledConsultationReports(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.getScheduledConsultationReports']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a share code for the Scheduled Consultation Request.
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getScheduledConsultationRequestShareCode(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ScheduledConsultationRequestShareCodeResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getScheduledConsultationRequestShareCode(
          scheduledConsultationId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'ScheduledConsultationRequestApi.getScheduledConsultationRequestShareCode'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Hides a Scheduled Consultation for the user
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hideScheduledConsultation(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hideScheduledConsultation(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.hideScheduledConsultation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Starts a call or retrieves call access for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async joinScheduledCall(
      scheduledConsultationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledCallAccessDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.joinScheduledCall(
        scheduledConsultationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.joinScheduledCall']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Joins a Call for the Scheduled Consultation Request with share code
     * @param {string} scheduledConsultationShareCode The share code of the scheduled consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async joinScheduledConsultationRequestWithShareCode(
      scheduledConsultationShareCode: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledCallAccessDTO>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.joinScheduledConsultationRequestWithShareCode(
          scheduledConsultationShareCode,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'ScheduledConsultationRequestApi.joinScheduledConsultationRequestWithShareCode'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Adds a report for the Scheduled Consultation for a given case.
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {ScheduledConsultationRequestReportDTO} scheduledConsultationRequestReportDTO
     * @param {boolean} [shouldFinalizeScheduledConsultationReport] True if the scheduled consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putScheduledConsultationReport(
      scheduledConsultationId: string,
      caseId: string,
      scheduledConsultationRequestReportDTO: ScheduledConsultationRequestReportDTO,
      shouldFinalizeScheduledConsultationReport?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putScheduledConsultationReport(
        scheduledConsultationId,
        caseId,
        scheduledConsultationRequestReportDTO,
        shouldFinalizeScheduledConsultationReport,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.putScheduledConsultationReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates the cases of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationCasesDTO} updateScheduledConsultationCasesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateScheduledConsultationCases(
      scheduledConsultationId: string,
      updateScheduledConsultationCasesDTO: UpdateScheduledConsultationCasesDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduledConsultationCases(
        scheduledConsultationId,
        updateScheduledConsultationCasesDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduledConsultationRequestApi.updateScheduledConsultationCases']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates the recipients (participants and requester) of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationRequestRecipientsDTO} updateScheduledConsultationRequestRecipientsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateScheduledConsultationRecipients(
      scheduledConsultationId: string,
      updateScheduledConsultationRequestRecipientsDTO: UpdateScheduledConsultationRequestRecipientsDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateScheduledConsultationRecipients(
          scheduledConsultationId,
          updateScheduledConsultationRequestRecipientsDTO,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'ScheduledConsultationRequestApi.updateScheduledConsultationRecipients'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ScheduledConsultationRequestApi - factory interface
 * @export
 */
export const ScheduledConsultationRequestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ScheduledConsultationRequestApiFp(configuration)
  return {
    /**
     * Accepts a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptScheduledConsultation(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .acceptScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Completes the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeScheduledConsultation(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .completeScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates a Scheduled Consultation object
     * @param {ScheduledConsultationCreationDTO} scheduledConsultationCreationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createScheduledConsultation(
      scheduledConsultationCreationDTO: ScheduledConsultationCreationDTO,
      options?: any
    ): AxiosPromise<string> {
      return localVarFp
        .createScheduledConsultation(scheduledConsultationCreationDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Declines a scheduled consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    declineScheduledConsultation(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .declineScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes a Scheduled Consultation object
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScheduledConsultation(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .deleteScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a Scheduled Consultation by its ID
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultation(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<ScheduledConsultationDTO> {
      return localVarFp
        .getScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves report created by authenticated user for a given caseId within the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationReport(
      scheduledConsultationId: string,
      caseId: string,
      options?: any
    ): AxiosPromise<ScheduledConsultationReportDTO> {
      return localVarFp
        .getScheduledConsultationReport(scheduledConsultationId, caseId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves reports for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationReports(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<GetScheduledConsultationReportResponse> {
      return localVarFp
        .getScheduledConsultationReports(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a share code for the Scheduled Consultation Request.
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getScheduledConsultationRequestShareCode(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<ScheduledConsultationRequestShareCodeResponse> {
      return localVarFp
        .getScheduledConsultationRequestShareCode(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Hides a Scheduled Consultation for the user
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hideScheduledConsultation(scheduledConsultationId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .hideScheduledConsultation(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Starts a call or retrieves call access for the Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinScheduledCall(
      scheduledConsultationId: string,
      options?: any
    ): AxiosPromise<ScheduledCallAccessDTO> {
      return localVarFp
        .joinScheduledCall(scheduledConsultationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Joins a Call for the Scheduled Consultation Request with share code
     * @param {string} scheduledConsultationShareCode The share code of the scheduled consultation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    joinScheduledConsultationRequestWithShareCode(
      scheduledConsultationShareCode: string,
      options?: any
    ): AxiosPromise<ScheduledCallAccessDTO> {
      return localVarFp
        .joinScheduledConsultationRequestWithShareCode(scheduledConsultationShareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Adds a report for the Scheduled Consultation for a given case.
     * @param {string} scheduledConsultationId
     * @param {string} caseId
     * @param {ScheduledConsultationRequestReportDTO} scheduledConsultationRequestReportDTO
     * @param {boolean} [shouldFinalizeScheduledConsultationReport] True if the scheduled consultation report is final and can\&#39;t be overwritten anymore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putScheduledConsultationReport(
      scheduledConsultationId: string,
      caseId: string,
      scheduledConsultationRequestReportDTO: ScheduledConsultationRequestReportDTO,
      shouldFinalizeScheduledConsultationReport?: boolean,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .putScheduledConsultationReport(
          scheduledConsultationId,
          caseId,
          scheduledConsultationRequestReportDTO,
          shouldFinalizeScheduledConsultationReport,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates the cases of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationCasesDTO} updateScheduledConsultationCasesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScheduledConsultationCases(
      scheduledConsultationId: string,
      updateScheduledConsultationCasesDTO: UpdateScheduledConsultationCasesDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateScheduledConsultationCases(
          scheduledConsultationId,
          updateScheduledConsultationCasesDTO,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates the recipients (participants and requester) of a Scheduled Consultation
     * @param {string} scheduledConsultationId
     * @param {UpdateScheduledConsultationRequestRecipientsDTO} updateScheduledConsultationRequestRecipientsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateScheduledConsultationRecipients(
      scheduledConsultationId: string,
      updateScheduledConsultationRequestRecipientsDTO: UpdateScheduledConsultationRequestRecipientsDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateScheduledConsultationRecipients(
          scheduledConsultationId,
          updateScheduledConsultationRequestRecipientsDTO,
          options
        )
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ScheduledConsultationRequestApi - object-oriented interface
 * @export
 * @class ScheduledConsultationRequestApi
 * @extends {BaseAPI}
 */
export class ScheduledConsultationRequestApi extends BaseAPI {
  /**
   * Accepts a Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public acceptScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .acceptScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Completes the Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public completeScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .completeScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates a Scheduled Consultation object
   * @param {ScheduledConsultationCreationDTO} scheduledConsultationCreationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public createScheduledConsultation(
    scheduledConsultationCreationDTO: ScheduledConsultationCreationDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .createScheduledConsultation(scheduledConsultationCreationDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Declines a scheduled consultation
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public declineScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .declineScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes a Scheduled Consultation object
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public deleteScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .deleteScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a Scheduled Consultation by its ID
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public getScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .getScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves report created by authenticated user for a given caseId within the Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {string} caseId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public getScheduledConsultationReport(
    scheduledConsultationId: string,
    caseId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .getScheduledConsultationReport(scheduledConsultationId, caseId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves reports for the Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public getScheduledConsultationReports(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .getScheduledConsultationReports(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a share code for the Scheduled Consultation Request.
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public getScheduledConsultationRequestShareCode(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .getScheduledConsultationRequestShareCode(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Hides a Scheduled Consultation for the user
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public hideScheduledConsultation(
    scheduledConsultationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .hideScheduledConsultation(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Starts a call or retrieves call access for the Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public joinScheduledCall(scheduledConsultationId: string, options?: RawAxiosRequestConfig) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .joinScheduledCall(scheduledConsultationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Joins a Call for the Scheduled Consultation Request with share code
   * @param {string} scheduledConsultationShareCode The share code of the scheduled consultation request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public joinScheduledConsultationRequestWithShareCode(
    scheduledConsultationShareCode: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .joinScheduledConsultationRequestWithShareCode(scheduledConsultationShareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Adds a report for the Scheduled Consultation for a given case.
   * @param {string} scheduledConsultationId
   * @param {string} caseId
   * @param {ScheduledConsultationRequestReportDTO} scheduledConsultationRequestReportDTO
   * @param {boolean} [shouldFinalizeScheduledConsultationReport] True if the scheduled consultation report is final and can\&#39;t be overwritten anymore
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public putScheduledConsultationReport(
    scheduledConsultationId: string,
    caseId: string,
    scheduledConsultationRequestReportDTO: ScheduledConsultationRequestReportDTO,
    shouldFinalizeScheduledConsultationReport?: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .putScheduledConsultationReport(
        scheduledConsultationId,
        caseId,
        scheduledConsultationRequestReportDTO,
        shouldFinalizeScheduledConsultationReport,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates the cases of a Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {UpdateScheduledConsultationCasesDTO} updateScheduledConsultationCasesDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public updateScheduledConsultationCases(
    scheduledConsultationId: string,
    updateScheduledConsultationCasesDTO: UpdateScheduledConsultationCasesDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .updateScheduledConsultationCases(
        scheduledConsultationId,
        updateScheduledConsultationCasesDTO,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates the recipients (participants and requester) of a Scheduled Consultation
   * @param {string} scheduledConsultationId
   * @param {UpdateScheduledConsultationRequestRecipientsDTO} updateScheduledConsultationRequestRecipientsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduledConsultationRequestApi
   */
  public updateScheduledConsultationRecipients(
    scheduledConsultationId: string,
    updateScheduledConsultationRequestRecipientsDTO: UpdateScheduledConsultationRequestRecipientsDTO,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduledConsultationRequestApiFp(this.configuration)
      .updateScheduledConsultationRecipients(
        scheduledConsultationId,
        updateScheduledConsultationRequestRecipientsDTO,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ShiftApi - axios parameter creator
 * @export
 */
export const ShiftApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ShiftDTO} shiftDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAndBeginShift: async (
      shiftDTO: ShiftDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'shiftDTO' is not null or undefined
      assertParamExists('createAndBeginShift', 'shiftDTO', shiftDTO)
      const localVarPath = `/shift`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shiftDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ShiftApi - functional programming interface
 * @export
 */
export const ShiftApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ShiftApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {ShiftDTO} shiftDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAndBeginShift(
      shiftDTO: ShiftDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createAndBeginShift(
        shiftDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ShiftApi.createAndBeginShift']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ShiftApi - factory interface
 * @export
 */
export const ShiftApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ShiftApiFp(configuration)
  return {
    /**
     *
     * @param {ShiftDTO} shiftDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAndBeginShift(shiftDTO: ShiftDTO, options?: any): AxiosPromise<void> {
      return localVarFp
        .createAndBeginShift(shiftDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * ShiftApi - object-oriented interface
 * @export
 * @class ShiftApi
 * @extends {BaseAPI}
 */
export class ShiftApi extends BaseAPI {
  /**
   *
   * @param {ShiftDTO} shiftDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShiftApi
   */
  public createAndBeginShift(shiftDTO: ShiftDTO, options?: RawAxiosRequestConfig) {
    return ShiftApiFp(this.configuration)
      .createAndBeginShift(shiftDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TccnaTestControllerApi - axios parameter creator
 * @export
 */
export const TccnaTestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} email
     * @param {string} consultationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveNotification: async (
      email: string,
      consultationUuid: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists('resolveNotification', 'email', email)
      // verify required parameter 'consultationUuid' is not null or undefined
      assertParamExists('resolveNotification', 'consultationUuid', consultationUuid)
      const localVarPath = `/tccna/resolve`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (email !== undefined) {
        localVarQueryParameter['email'] = email
      }

      if (consultationUuid !== undefined) {
        localVarQueryParameter['consultationUuid'] = consultationUuid
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleEmergencyNotificationDelivery: async (
      email: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists('scheduleEmergencyNotificationDelivery', 'email', email)
      const localVarPath = `/tccna/schedule/emergency`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (email !== undefined) {
        localVarQueryParameter['email'] = email
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleRoutineNotificationDelivery: async (
      email: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists('scheduleRoutineNotificationDelivery', 'email', email)
      const localVarPath = `/tccna/schedule/routine`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (email !== undefined) {
        localVarQueryParameter['email'] = email
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stopNotificationDelivery: async (
      email: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists('stopNotificationDelivery', 'email', email)
      const localVarPath = `/tccna/schedule/stop`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (email !== undefined) {
        localVarQueryParameter['email'] = email
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} email
     * @param {boolean} isCritical
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testPushNotifications: async (
      email: string,
      isCritical: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists('testPushNotifications', 'email', email)
      // verify required parameter 'isCritical' is not null or undefined
      assertParamExists('testPushNotifications', 'isCritical', isCritical)
      const localVarPath = `/tccna`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (email !== undefined) {
        localVarQueryParameter['email'] = email
      }

      if (isCritical !== undefined) {
        localVarQueryParameter['isCritical'] = isCritical
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TccnaTestControllerApi - functional programming interface
 * @export
 */
export const TccnaTestControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TccnaTestControllerApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} email
     * @param {string} consultationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resolveNotification(
      email: string,
      consultationUuid: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resolveNotification(
        email,
        consultationUuid,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TccnaTestControllerApi.resolveNotification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scheduleEmergencyNotificationDelivery(
      email: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.scheduleEmergencyNotificationDelivery(email, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TccnaTestControllerApi.scheduleEmergencyNotificationDelivery']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scheduleRoutineNotificationDelivery(
      email: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleRoutineNotificationDelivery(
        email,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TccnaTestControllerApi.scheduleRoutineNotificationDelivery']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stopNotificationDelivery(
      email: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stopNotificationDelivery(
        email,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TccnaTestControllerApi.stopNotificationDelivery']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} email
     * @param {boolean} isCritical
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async testPushNotifications(
      email: string,
      isCritical: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.testPushNotifications(
        email,
        isCritical,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TccnaTestControllerApi.testPushNotifications']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * TccnaTestControllerApi - factory interface
 * @export
 */
export const TccnaTestControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TccnaTestControllerApiFp(configuration)
  return {
    /**
     *
     * @param {string} email
     * @param {string} consultationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resolveNotification(
      email: string,
      consultationUuid: string,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .resolveNotification(email, consultationUuid, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleEmergencyNotificationDelivery(email: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .scheduleEmergencyNotificationDelivery(email, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleRoutineNotificationDelivery(email: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .scheduleRoutineNotificationDelivery(email, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stopNotificationDelivery(email: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .stopNotificationDelivery(email, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} email
     * @param {boolean} isCritical
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    testPushNotifications(email: string, isCritical: boolean, options?: any): AxiosPromise<void> {
      return localVarFp
        .testPushNotifications(email, isCritical, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * TccnaTestControllerApi - object-oriented interface
 * @export
 * @class TccnaTestControllerApi
 * @extends {BaseAPI}
 */
export class TccnaTestControllerApi extends BaseAPI {
  /**
   *
   * @param {string} email
   * @param {string} consultationUuid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TccnaTestControllerApi
   */
  public resolveNotification(
    email: string,
    consultationUuid: string,
    options?: RawAxiosRequestConfig
  ) {
    return TccnaTestControllerApiFp(this.configuration)
      .resolveNotification(email, consultationUuid, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TccnaTestControllerApi
   */
  public scheduleEmergencyNotificationDelivery(email: string, options?: RawAxiosRequestConfig) {
    return TccnaTestControllerApiFp(this.configuration)
      .scheduleEmergencyNotificationDelivery(email, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TccnaTestControllerApi
   */
  public scheduleRoutineNotificationDelivery(email: string, options?: RawAxiosRequestConfig) {
    return TccnaTestControllerApiFp(this.configuration)
      .scheduleRoutineNotificationDelivery(email, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TccnaTestControllerApi
   */
  public stopNotificationDelivery(email: string, options?: RawAxiosRequestConfig) {
    return TccnaTestControllerApiFp(this.configuration)
      .stopNotificationDelivery(email, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} email
   * @param {boolean} isCritical
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TccnaTestControllerApi
   */
  public testPushNotifications(
    email: string,
    isCritical: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return TccnaTestControllerApiFp(this.configuration)
      .testPushNotifications(email, isCritical, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Extends current shift of the user to given end time
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {ShiftExtendDTO} shiftExtendDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    extendShift: async (
      encodedUserName: string,
      shiftExtendDTO: ShiftExtendDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('extendShift', 'encodedUserName', encodedUserName)
      // verify required parameter 'shiftExtendDTO' is not null or undefined
      assertParamExists('extendShift', 'shiftExtendDTO', shiftExtendDTO)
      const localVarPath = `/user/{encodedUserName}/extend-shift`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shiftExtendDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user whose shift must be handed over to another user
     * @param {ShiftHandoverDTO} [shiftHandoverDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handoverShift: async (
      encodedUserName: string,
      shiftHandoverDTO?: ShiftHandoverDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('handoverShift', 'encodedUserName', encodedUserName)
      const localVarPath = `/user/{encodedUserName}/handover-shift`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        shiftHandoverDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of User objects from hospitals accessible to the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAssignableUsersInSharedHospitals: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/accessible-hospital-users`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {LoginDTO} loginDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (
      encodedUserName: string,
      loginDTO: LoginDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('login', 'encodedUserName', encodedUserName)
      // verify required parameter 'loginDTO' is not null or undefined
      assertParamExists('login', 'loginDTO', loginDTO)
      const localVarPath = `/user/{encodedUserName}/login`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        loginDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who wants to logout
     * @param {LogoutDTO} logoutDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutDevice: async (
      encodedUserName: string,
      logoutDTO: LogoutDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('logoutDevice', 'encodedUserName', encodedUserName)
      // verify required parameter 'logoutDTO' is not null or undefined
      assertParamExists('logoutDevice', 'logoutDTO', logoutDTO)
      const localVarPath = `/user/{encodedUserName}/logout-device`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        logoutDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Searches users and filters them if a relevant filter has been given
     * @param {SearchUsersFilterDTO} eligibleFor Applies a filter on the users\&#39; list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUsers: async (
      eligibleFor: SearchUsersFilterDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eligibleFor' is not null or undefined
      assertParamExists('searchUsers', 'eligibleFor', eligibleFor)
      const localVarPath = `/user/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (eligibleFor !== undefined) {
        localVarQueryParameter['eligible-for'] = eligibleFor
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
  return {
    /**
     * Extends current shift of the user to given end time
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {ShiftExtendDTO} shiftExtendDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async extendShift(
      encodedUserName: string,
      shiftExtendDTO: ShiftExtendDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.extendShift(
        encodedUserName,
        shiftExtendDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.extendShift']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user whose shift must be handed over to another user
     * @param {ShiftHandoverDTO} [shiftHandoverDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async handoverShift(
      encodedUserName: string,
      shiftHandoverDTO?: ShiftHandoverDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.handoverShift(
        encodedUserName,
        shiftHandoverDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.handoverShift']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of User objects from hospitals accessible to the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAssignableUsersInSharedHospitals(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignableUserDTO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listAssignableUsersInSharedHospitals(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.listAssignableUsersInSharedHospitals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {LoginDTO} loginDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      encodedUserName: string,
      loginDTO: LoginDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.login(
        encodedUserName,
        loginDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.login']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who wants to logout
     * @param {LogoutDTO} logoutDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logoutDevice(
      encodedUserName: string,
      logoutDTO: LogoutDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logoutDevice(
        encodedUserName,
        logoutDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.logoutDevice']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Searches users and filters them if a relevant filter has been given
     * @param {SearchUsersFilterDTO} eligibleFor Applies a filter on the users\&#39; list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchUsers(
      eligibleFor: SearchUsersFilterDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUsersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(eligibleFor, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.searchUsers']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiFp(configuration)
  return {
    /**
     * Extends current shift of the user to given end time
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {ShiftExtendDTO} shiftExtendDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    extendShift(
      encodedUserName: string,
      shiftExtendDTO: ShiftExtendDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .extendShift(encodedUserName, shiftExtendDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user whose shift must be handed over to another user
     * @param {ShiftHandoverDTO} [shiftHandoverDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handoverShift(
      encodedUserName: string,
      shiftHandoverDTO?: ShiftHandoverDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .handoverShift(encodedUserName, shiftHandoverDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of User objects from hospitals accessible to the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAssignableUsersInSharedHospitals(options?: any): AxiosPromise<Array<AssignableUserDTO>> {
      return localVarFp
        .listAssignableUsersInSharedHospitals(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who has logged in
     * @param {LoginDTO} loginDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(encodedUserName: string, loginDTO: LoginDTO, options?: any): AxiosPromise<void> {
      return localVarFp
        .login(encodedUserName, loginDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} encodedUserName Base64 encoded username of the user who wants to logout
     * @param {LogoutDTO} logoutDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutDevice(encodedUserName: string, logoutDTO: LogoutDTO, options?: any): AxiosPromise<void> {
      return localVarFp
        .logoutDevice(encodedUserName, logoutDTO, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Searches users and filters them if a relevant filter has been given
     * @param {SearchUsersFilterDTO} eligibleFor Applies a filter on the users\&#39; list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUsers(
      eligibleFor: SearchUsersFilterDTO,
      options?: any
    ): AxiosPromise<SearchUsersResponse> {
      return localVarFp
        .searchUsers(eligibleFor, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   * Extends current shift of the user to given end time
   * @param {string} encodedUserName Base64 encoded username of the user who has logged in
   * @param {ShiftExtendDTO} shiftExtendDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public extendShift(
    encodedUserName: string,
    shiftExtendDTO: ShiftExtendDTO,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .extendShift(encodedUserName, shiftExtendDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} encodedUserName Base64 encoded username of the user whose shift must be handed over to another user
   * @param {ShiftHandoverDTO} [shiftHandoverDTO]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public handoverShift(
    encodedUserName: string,
    shiftHandoverDTO?: ShiftHandoverDTO,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .handoverShift(encodedUserName, shiftHandoverDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of User objects from hospitals accessible to the authenticated user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public listAssignableUsersInSharedHospitals(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .listAssignableUsersInSharedHospitals(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} encodedUserName Base64 encoded username of the user who has logged in
   * @param {LoginDTO} loginDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public login(encodedUserName: string, loginDTO: LoginDTO, options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .login(encodedUserName, loginDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} encodedUserName Base64 encoded username of the user who wants to logout
   * @param {LogoutDTO} logoutDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public logoutDevice(
    encodedUserName: string,
    logoutDTO: LogoutDTO,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .logoutDevice(encodedUserName, logoutDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Searches users and filters them if a relevant filter has been given
   * @param {SearchUsersFilterDTO} eligibleFor Applies a filter on the users\&#39; list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public searchUsers(eligibleFor: SearchUsersFilterDTO, options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .searchUsers(eligibleFor, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserAccessApi - axios parameter creator
 * @export
 */
export const UserAccessApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Deletes User Access
     * @param {UserName} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserAccess: async (
      userName: UserName,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userName' is not null or undefined
      assertParamExists('deleteUserAccess', 'userName', userName)
      const localVarPath = `/admin/user-access`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userName,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates User Access
     * @param {Array<UserAttributesDto>} userAttributesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserAccess: async (
      userAttributesDto: Array<UserAttributesDto>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userAttributesDto' is not null or undefined
      assertParamExists('updateUserAccess', 'userAttributesDto', userAttributesDto)
      const localVarPath = `/admin/user-access`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userAttributesDto,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserAccessApi - functional programming interface
 * @export
 */
export const UserAccessApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserAccessApiAxiosParamCreator(configuration)
  return {
    /**
     * Deletes User Access
     * @param {UserName} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUserAccess(
      userName: UserName,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAccess(userName, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserAccessApi.deleteUserAccess']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates User Access
     * @param {Array<UserAttributesDto>} userAttributesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUserAccess(
      userAttributesDto: Array<UserAttributesDto>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccess(
        userAttributesDto,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserAccessApi.updateUserAccess']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserAccessApi - factory interface
 * @export
 */
export const UserAccessApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserAccessApiFp(configuration)
  return {
    /**
     * Deletes User Access
     * @param {UserName} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserAccess(userName: UserName, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteUserAccess(userName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates User Access
     * @param {Array<UserAttributesDto>} userAttributesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserAccess(
      userAttributesDto: Array<UserAttributesDto>,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .updateUserAccess(userAttributesDto, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserAccessApi - object-oriented interface
 * @export
 * @class UserAccessApi
 * @extends {BaseAPI}
 */
export class UserAccessApi extends BaseAPI {
  /**
   * Deletes User Access
   * @param {UserName} userName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserAccessApi
   */
  public deleteUserAccess(userName: UserName, options?: RawAxiosRequestConfig) {
    return UserAccessApiFp(this.configuration)
      .deleteUserAccess(userName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates User Access
   * @param {Array<UserAttributesDto>} userAttributesDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserAccessApi
   */
  public updateUserAccess(
    userAttributesDto: Array<UserAttributesDto>,
    options?: RawAxiosRequestConfig
  ) {
    return UserAccessApiFp(this.configuration)
      .updateUserAccess(userAttributesDto, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserRightsApi - axios parameter creator
 * @export
 */
export const UserRightsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves all User Rights
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserRights: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user-rights`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserRightsApi - functional programming interface
 * @export
 */
export const UserRightsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserRightsApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves all User Rights
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserRights(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserRightsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRights(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserRightsApi.getUserRights']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserRightsApi - factory interface
 * @export
 */
export const UserRightsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserRightsApiFp(configuration)
  return {
    /**
     * Retrieves all User Rights
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserRights(options?: any): AxiosPromise<GetUserRightsResponse> {
      return localVarFp.getUserRights(options).then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserRightsApi - object-oriented interface
 * @export
 * @class UserRightsApi
 * @extends {BaseAPI}
 */
export class UserRightsApi extends BaseAPI {
  /**
   * Retrieves all User Rights
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRightsApi
   */
  public getUserRights(options?: RawAxiosRequestConfig) {
    return UserRightsApiFp(this.configuration)
      .getUserRights(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UserSettingsApi - axios parameter creator
 * @export
 */
export const UserSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves a hierarchical structure Clients, Hospitals, Departments and Wards assigned to the User
     * @param {string} encodedUserName Base64 encoded username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedClientsStructure: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('getAssignedClientsStructure', 'encodedUserName', encodedUserName)
      const localVarPath = `/user-settings/{encodedUserName}/assigned-clients`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of Hospital and Ward objects assigned to the User
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their assigned hospitals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedHospitals: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('getAssignedHospitals', 'encodedUserName', encodedUserName)
      const localVarPath = `/user-settings/{encodedUserName}/assigned-hospitals`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSettings: async (
      encodedUserName: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('getUserSettings', 'encodedUserName', encodedUserName)
      const localVarPath = `/user-settings/{encodedUserName}`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Updates a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to partially update their settings
     * @param {UserSettingsUpdateDTO} userSettingsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchUserSettings: async (
      encodedUserName: string,
      userSettingsUpdateDTO: UserSettingsUpdateDTO,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'encodedUserName' is not null or undefined
      assertParamExists('patchUserSettings', 'encodedUserName', encodedUserName)
      // verify required parameter 'userSettingsUpdateDTO' is not null or undefined
      assertParamExists('patchUserSettings', 'userSettingsUpdateDTO', userSettingsUpdateDTO)
      const localVarPath = `/user-settings/{encodedUserName}`.replace(
        `{${'encodedUserName'}}`,
        encodeURIComponent(String(encodedUserName))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        userSettingsUpdateDTO,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * UserSettingsApi - functional programming interface
 * @export
 */
export const UserSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserSettingsApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves a hierarchical structure Clients, Hospitals, Departments and Wards assigned to the User
     * @param {string} encodedUserName Base64 encoded username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssignedClientsStructure(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientStructureDTO>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignedClientsStructure(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserSettingsApi.getAssignedClientsStructure']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of Hospital and Ward objects assigned to the User
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their assigned hospitals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssignedHospitals(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssignedHospitalsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignedHospitals(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserSettingsApi.getAssignedHospitals']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserSettings(
      encodedUserName: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSettingsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettings(
        encodedUserName,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserSettingsApi.getUserSettings']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Updates a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to partially update their settings
     * @param {UserSettingsUpdateDTO} userSettingsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchUserSettings(
      encodedUserName: string,
      userSettingsUpdateDTO: UserSettingsUpdateDTO,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserSettings(
        encodedUserName,
        userSettingsUpdateDTO,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UserSettingsApi.patchUserSettings']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * UserSettingsApi - factory interface
 * @export
 */
export const UserSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserSettingsApiFp(configuration)
  return {
    /**
     * Retrieves a hierarchical structure Clients, Hospitals, Departments and Wards assigned to the User
     * @param {string} encodedUserName Base64 encoded username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedClientsStructure(
      encodedUserName: string,
      options?: any
    ): AxiosPromise<Array<ClientStructureDTO>> {
      return localVarFp
        .getAssignedClientsStructure(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of Hospital and Ward objects assigned to the User
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their assigned hospitals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignedHospitals(
      encodedUserName: string,
      options?: any
    ): AxiosPromise<GetAssignedHospitalsResponse> {
      return localVarFp
        .getAssignedHospitals(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSettings(encodedUserName: string, options?: any): AxiosPromise<GetUserSettingsResponse> {
      return localVarFp
        .getUserSettings(encodedUserName, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a User Settings object
     * @param {string} encodedUserName Base64 encoded username of the user to partially update their settings
     * @param {UserSettingsUpdateDTO} userSettingsUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchUserSettings(
      encodedUserName: string,
      userSettingsUpdateDTO: UserSettingsUpdateDTO,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .patchUserSettings(encodedUserName, userSettingsUpdateDTO, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * UserSettingsApi - object-oriented interface
 * @export
 * @class UserSettingsApi
 * @extends {BaseAPI}
 */
export class UserSettingsApi extends BaseAPI {
  /**
   * Retrieves a hierarchical structure Clients, Hospitals, Departments and Wards assigned to the User
   * @param {string} encodedUserName Base64 encoded username
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSettingsApi
   */
  public getAssignedClientsStructure(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return UserSettingsApiFp(this.configuration)
      .getAssignedClientsStructure(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of Hospital and Ward objects assigned to the User
   * @param {string} encodedUserName Base64 encoded username of the user to retrieve their assigned hospitals
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSettingsApi
   */
  public getAssignedHospitals(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return UserSettingsApiFp(this.configuration)
      .getAssignedHospitals(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a User Settings object
   * @param {string} encodedUserName Base64 encoded username of the user to retrieve their settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSettingsApi
   */
  public getUserSettings(encodedUserName: string, options?: RawAxiosRequestConfig) {
    return UserSettingsApiFp(this.configuration)
      .getUserSettings(encodedUserName, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a User Settings object
   * @param {string} encodedUserName Base64 encoded username of the user to partially update their settings
   * @param {UserSettingsUpdateDTO} userSettingsUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserSettingsApi
   */
  public patchUserSettings(
    encodedUserName: string,
    userSettingsUpdateDTO: UserSettingsUpdateDTO,
    options?: RawAxiosRequestConfig
  ) {
    return UserSettingsApiFp(this.configuration)
      .patchUserSettings(encodedUserName, userSettingsUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VentilationApi - axios parameter creator
 * @export
 */
export const VentilationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves latest ventilation data for a given case ID
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestVentilationData: async (
      caseId: string,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLatestVentilationData', 'caseId', caseId)
      const localVarPath = `/ventilation/{caseId}/latest`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of ventilation data for given period of time
     * @param {string} caseId
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVentilation: async (
      caseId: string,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getVentilation', 'caseId', caseId)
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists('getVentilation', 'startTime', startTime)
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists('getVentilation', 'endTime', endTime)
      const localVarPath = `/ventilation/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (startTime !== undefined) {
        localVarQueryParameter['startTime'] =
          (startTime as any) instanceof Date ? (startTime as any).toISOString() : startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['endTime'] =
          (endTime as any) instanceof Date ? (endTime as any).toISOString() : endTime
      }

      if (samplingMinutes !== undefined) {
        localVarQueryParameter['samplingMinutes'] = samplingMinutes
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * VentilationApi - functional programming interface
 * @export
 */
export const VentilationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VentilationApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves latest ventilation data for a given case ID
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestVentilationData(
      caseId: string,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVentilationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestVentilationData(
        caseId,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['VentilationApi.getLatestVentilationData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of ventilation data for given period of time
     * @param {string} caseId
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVentilation(
      caseId: string,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVentilationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getVentilation(
        caseId,
        startTime,
        endTime,
        samplingMinutes,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['VentilationApi.getVentilation']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * VentilationApi - factory interface
 * @export
 */
export const VentilationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VentilationApiFp(configuration)
  return {
    /**
     * Retrieves latest ventilation data for a given case ID
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestVentilationData(
      caseId: string,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetVentilationResponse> {
      return localVarFp
        .getLatestVentilationData(caseId, shareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of ventilation data for given period of time
     * @param {string} caseId
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVentilation(
      caseId: string,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetVentilationResponse> {
      return localVarFp
        .getVentilation(caseId, startTime, endTime, samplingMinutes, shareCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * VentilationApi - object-oriented interface
 * @export
 * @class VentilationApi
 * @extends {BaseAPI}
 */
export class VentilationApi extends BaseAPI {
  /**
   * Retrieves latest ventilation data for a given case ID
   * @param {string} caseId
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VentilationApi
   */
  public getLatestVentilationData(
    caseId: string,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VentilationApiFp(this.configuration)
      .getLatestVentilationData(caseId, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of ventilation data for given period of time
   * @param {string} caseId
   * @param {string} startTime
   * @param {string} endTime
   * @param {number} [samplingMinutes]
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VentilationApi
   */
  public getVentilation(
    caseId: string,
    startTime: string,
    endTime: string,
    samplingMinutes?: number,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VentilationApiFp(this.configuration)
      .getVentilation(caseId, startTime, endTime, samplingMinutes, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * VitalSignsApi - axios parameter creator
 * @export
 */
export const VitalSignsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Retrieves latest values for the selected vital signs
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestVitalSigns: async (
      caseId: string,
      types: Array<VitalSignTypeKey>,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getLatestVitalSigns', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getLatestVitalSigns', 'types', types)
      const localVarPath = `/vital-signs/{caseId}/latest`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a list of vital signs for given period of time
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVitalSigns: async (
      caseId: string,
      types: Array<VitalSignTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getVitalSigns', 'caseId', caseId)
      // verify required parameter 'types' is not null or undefined
      assertParamExists('getVitalSigns', 'types', types)
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists('getVitalSigns', 'startTime', startTime)
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists('getVitalSigns', 'endTime', endTime)
      const localVarPath = `/vital-signs/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (startTime !== undefined) {
        localVarQueryParameter['startTime'] =
          (startTime as any) instanceof Date ? (startTime as any).toISOString() : startTime
      }

      if (endTime !== undefined) {
        localVarQueryParameter['endTime'] =
          (endTime as any) instanceof Date ? (endTime as any).toISOString() : endTime
      }

      if (samplingMinutes !== undefined) {
        localVarQueryParameter['samplingMinutes'] = samplingMinutes
      }

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     * Retrieves a stream of Server-Sent Events (SSE) with Waveform values of the Vital Signs
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWaveforms: async (
      caseId: string,
      shareCode?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'caseId' is not null or undefined
      assertParamExists('getWaveforms', 'caseId', caseId)
      const localVarPath = `/waveforms/{caseId}`.replace(
        `{${'caseId'}}`,
        encodeURIComponent(String(caseId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (shareCode !== undefined) {
        localVarQueryParameter['shareCode'] = shareCode
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * VitalSignsApi - functional programming interface
 * @export
 */
export const VitalSignsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VitalSignsApiAxiosParamCreator(configuration)
  return {
    /**
     * Retrieves latest values for the selected vital signs
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestVitalSigns(
      caseId: string,
      types: Array<VitalSignTypeKey>,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVitalSignsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestVitalSigns(
        caseId,
        types,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['VitalSignsApi.getLatestVitalSigns']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a list of vital signs for given period of time
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVitalSigns(
      caseId: string,
      types: Array<VitalSignTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaginatedVitalSignsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getVitalSigns(
        caseId,
        types,
        startTime,
        endTime,
        samplingMinutes,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['VitalSignsApi.getVitalSigns']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Retrieves a stream of Server-Sent Events (SSE) with Waveform values of the Vital Signs
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWaveforms(
      caseId: string,
      shareCode?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SseEmitter>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWaveforms(
        caseId,
        shareCode,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['VitalSignsApi.getWaveforms']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * VitalSignsApi - factory interface
 * @export
 */
export const VitalSignsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VitalSignsApiFp(configuration)
  return {
    /**
     * Retrieves latest values for the selected vital signs
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestVitalSigns(
      caseId: string,
      types: Array<VitalSignTypeKey>,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetVitalSignsResponse> {
      return localVarFp
        .getLatestVitalSigns(caseId, types, shareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a list of vital signs for given period of time
     * @param {string} caseId
     * @param {Array<VitalSignTypeKey>} types
     * @param {string} startTime
     * @param {string} endTime
     * @param {number} [samplingMinutes]
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVitalSigns(
      caseId: string,
      types: Array<VitalSignTypeKey>,
      startTime: string,
      endTime: string,
      samplingMinutes?: number,
      shareCode?: string,
      options?: any
    ): AxiosPromise<GetPaginatedVitalSignsResponse> {
      return localVarFp
        .getVitalSigns(caseId, types, startTime, endTime, samplingMinutes, shareCode, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a stream of Server-Sent Events (SSE) with Waveform values of the Vital Signs
     * @param {string} caseId
     * @param {string} [shareCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWaveforms(caseId: string, shareCode?: string, options?: any): AxiosPromise<SseEmitter> {
      return localVarFp
        .getWaveforms(caseId, shareCode, options)
        .then((request) => request(axios, basePath))
    }
  }
}

/**
 * VitalSignsApi - object-oriented interface
 * @export
 * @class VitalSignsApi
 * @extends {BaseAPI}
 */
export class VitalSignsApi extends BaseAPI {
  /**
   * Retrieves latest values for the selected vital signs
   * @param {string} caseId
   * @param {Array<VitalSignTypeKey>} types
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VitalSignsApi
   */
  public getLatestVitalSigns(
    caseId: string,
    types: Array<VitalSignTypeKey>,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VitalSignsApiFp(this.configuration)
      .getLatestVitalSigns(caseId, types, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a list of vital signs for given period of time
   * @param {string} caseId
   * @param {Array<VitalSignTypeKey>} types
   * @param {string} startTime
   * @param {string} endTime
   * @param {number} [samplingMinutes]
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VitalSignsApi
   */
  public getVitalSigns(
    caseId: string,
    types: Array<VitalSignTypeKey>,
    startTime: string,
    endTime: string,
    samplingMinutes?: number,
    shareCode?: string,
    options?: RawAxiosRequestConfig
  ) {
    return VitalSignsApiFp(this.configuration)
      .getVitalSigns(caseId, types, startTime, endTime, samplingMinutes, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a stream of Server-Sent Events (SSE) with Waveform values of the Vital Signs
   * @param {string} caseId
   * @param {string} [shareCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VitalSignsApi
   */
  public getWaveforms(caseId: string, shareCode?: string, options?: RawAxiosRequestConfig) {
    return VitalSignsApiFp(this.configuration)
      .getWaveforms(caseId, shareCode, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
